import { j as m, c as N, a as tt, b as ri, g as Wa } from "./index-x_nYiiot.js";
import * as A from "react";
import c, { useState as $, useEffect as Q, useRef as pe, useMemo as lt, createContext as S1, useContext as $n, useCallback as me, forwardRef as ii, useLayoutEffect as ai, Component as ka, Fragment as Wn, cloneElement as oi, useImperativeHandle as Xa } from "react";
import { createPortal as za } from "react-dom";
const Ya = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M14 21L12 23L10 21H4.99509C3.89323 21 3 20.1074 3 19.0049V4.99509C3 3.89323 3.89262 3 4.99509 3H19.0049C20.1068 3 21 3.89262 21 4.99509V19.0049C21 20.1068 20.1074 21 19.0049 21H14ZM6.35687 18H17.8475C16.5825 16.1865 14.4809 15 12.1022 15C9.72344 15 7.62182 16.1865 6.35687 18ZM12 13C13.933 13 15.5 11.433 15.5 9.5C15.5 7.567 13.933 6 12 6C10.067 6 8.5 7.567 8.5 9.5C8.5 11.433 10.067 13 12 13Z" })), ja = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" })), Ja = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z" })), _a = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM4.20568 19.0002H19.7941L11.9999 5.50017L4.20568 19.0002ZM10.9999 16.0002H12.9999V18.0002H10.9999V16.0002ZM10.9999 9.00017H12.9999V14.0002H10.9999V9.00017Z" })), Ua = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 4H21V6H3V4ZM5 19H19V21H5V19ZM3 14H21V16H3V14ZM5 9H19V11H5V9Z" })), $a = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM3 14H21V16H3V14ZM3 9H21V11H3V9Z" })), Qa = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 4H21V6H3V4ZM3 19H17V21H3V19ZM3 14H21V16H3V14ZM3 9H17V11H3V9Z" })), Ka = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 4H21V6H3V4ZM7 19H21V21H7V19ZM3 14H21V16H3V14ZM7 9H21V11H7V9Z" })), qa = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13.0001 16.1716L18.3641 10.8076L19.7783 12.2218L12.0001 20L4.22192 12.2218L5.63614 10.8076L11.0001 16.1716V4H13.0001V16.1716Z" })), eo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z" })), to = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12.1717 12.0005L9.34326 9.17203L10.7575 7.75781L15.0001 12.0005L10.7575 16.2431L9.34326 14.8289L12.1717 12.0005Z" })), no = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5.82843 6.99955L8.36396 9.53509L6.94975 10.9493L2 5.99955L6.94975 1.0498L8.36396 2.46402L5.82843 4.99955H13C17.4183 4.99955 21 8.58127 21 12.9996C21 17.4178 17.4183 20.9996 13 20.9996H4V18.9996H13C16.3137 18.9996 19 16.3133 19 12.9996C19 9.68584 16.3137 6.99955 13 6.99955H5.82843Z" })), ro = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z" })), io = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M16 16V12L21 17L16 22V18H4V16H16ZM8 2V5.999L20 6V8H8V12L3 7L8 2Z" })), ao = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M16.0503 12.0498L21 16.9996L16.0503 21.9493L14.636 20.5351L17.172 17.9988L4 17.9996V15.9996L17.172 15.9988L14.636 13.464L16.0503 12.0498ZM7.94975 2.0498L9.36396 3.46402L6.828 5.9988L20 5.99955V7.99955L6.828 7.9988L9.36396 10.5351L7.94975 11.9493L3 6.99955L7.94975 2.0498Z" })), oo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z" })), so = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" })), lo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z" })), co = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z" })), uo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13.0001 7.82843V20H11.0001V7.82843L5.63614 13.1924L4.22192 11.7782L12.0001 4L19.7783 11.7782L18.3641 13.1924L13.0001 7.82843Z" })), fo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11.9999 10.8284L7.0502 15.7782L5.63599 14.364L11.9999 8L18.3639 14.364L16.9497 15.7782L11.9999 10.8284Z" })), mo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM7 6H11V10H7V6ZM7 12H17V14H7V12ZM7 16H17V18H7V16ZM13 7H17V9H13V7Z" })), go = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M14.8287 7.75737L9.1718 13.4142C8.78127 13.8047 8.78127 14.4379 9.1718 14.8284C9.56232 15.219 10.1955 15.219 10.586 14.8284L16.2429 9.17158C17.4144 8.00001 17.4144 6.10052 16.2429 4.92894C15.0713 3.75737 13.1718 3.75737 12.0002 4.92894L6.34337 10.5858C4.39075 12.5384 4.39075 15.7042 6.34337 17.6569C8.29599 19.6095 11.4618 19.6095 13.4144 17.6569L19.0713 12L20.4855 13.4142L14.8287 19.0711C12.095 21.8047 7.66283 21.8047 4.92916 19.0711C2.19549 16.3374 2.19549 11.9053 4.92916 9.17158L10.586 3.51473C12.5386 1.56211 15.7045 1.56211 17.6571 3.51473C19.6097 5.46735 19.6097 8.63317 17.6571 10.5858L12.0002 16.2427C10.8287 17.4142 8.92916 17.4142 7.75759 16.2427C6.58601 15.0711 6.58601 13.1716 7.75759 12L13.4144 6.34316L14.8287 7.75737Z" })), ho = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M14 13.5V8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8V13.5C6 17.0899 8.91015 20 12.5 20C16.0899 20 19 17.0899 19 13.5V4H21V13.5C21 18.1944 17.1944 22 12.5 22C7.80558 22 4 18.1944 4 13.5V8C4 4.68629 6.68629 2 10 2C13.3137 2 16 4.68629 16 8V13.5C16 15.433 14.433 17 12.5 17C10.567 17 9 15.433 9 13.5V8H11V13.5C11 14.3284 11.6716 15 12.5 15C13.3284 15 14 14.3284 14 13.5Z" })), Co = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM8 9H16V11H8V9ZM8 13H16V15H8V13Z" })), bo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z" })), po = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2ZM18 4H6V19.4324L12 15.6707L18 19.4324V4Z" })), vo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 18V14.3C4 13.4716 3.32843 12.8 2.5 12.8H2V11.2H2.5C3.32843 11.2 4 10.5284 4 9.7V6C4 4.34315 5.34315 3 7 3H8V5H7C6.44772 5 6 5.44772 6 6V10.1C6 10.9858 5.42408 11.7372 4.62623 12C5.42408 12.2628 6 13.0142 6 13.9V18C6 18.5523 6.44772 19 7 19H8V21H7C5.34315 21 4 19.6569 4 18ZM20 14.3V18C20 19.6569 18.6569 21 17 21H16V19H17C17.5523 19 18 18.5523 18 18V13.9C18 13.0142 18.5759 12.2628 19.3738 12C18.5759 11.7372 18 10.9858 18 10.1V6C18 5.44772 17.5523 5 17 5H16V3H17C18.6569 3 20 4.34315 20 6V9.7C20 10.5284 20.6716 11.2 21.5 11.2H22V12.8H21.5C20.6716 12.8 20 13.4716 20 14.3Z" })), wo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M7 5V2C7 1.44772 7.44772 1 8 1H16C16.5523 1 17 1.44772 17 2V5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V6C2 5.44772 2.44772 5 3 5H7ZM9 13H4V19H20V13H15V16H9V13ZM20 7H4V11H9V9H15V11H20V7ZM11 11V14H13V11H11ZM9 3V5H15V3H9Z" })), xo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2ZM7 12V14H9V12H7ZM7 16V18H9V16H7ZM11 12V14H13V12H11ZM11 16V18H13V16H11ZM15 12V18H17V12H15ZM7 6V10H17V6H7Z" })), yo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM8 13V15H6V13H8ZM13 13V15H11V13H13ZM18 13V15H16V13H18ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z" })), Io = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9 1V3H15V1H17V3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H7V1H9ZM20 11H4V19H20V11ZM7 5H4V9H20V5H17V7H15V5H9V7H7V5Z" })), Vo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z" })), Ho = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z" })), Mo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z" })), Eo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM17.4571 9.45711L16.0429 8.04289L11 13.0858L8.20711 10.2929L6.79289 11.7071L11 15.9142L17.4571 9.45711Z" })), No = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" })), Lo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z" })), Ao = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M6.99979 7V3C6.99979 2.44772 7.4475 2 7.99979 2H20.9998C21.5521 2 21.9998 2.44772 21.9998 3V16C21.9998 16.5523 21.5521 17 20.9998 17H17V20.9925C17 21.5489 16.551 22 15.9925 22H3.00728C2.45086 22 2 21.5511 2 20.9925L2.00276 8.00748C2.00288 7.45107 2.4518 7 3.01025 7H6.99979ZM8.99979 7H15.9927C16.549 7 17 7.44892 17 8.00748V15H19.9998V4H8.99979V7ZM8.50242 18L14.1593 12.3431L12.7451 10.9289L8.50242 15.1716L6.3811 13.0503L4.96689 14.4645L8.50242 18Z" })), Zo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z" })), Ro = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z" })), Bo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M23 12L15.9289 19.0711L14.5147 17.6569L20.1716 12L14.5147 6.34317L15.9289 4.92896L23 12ZM3.82843 12L9.48528 17.6569L8.07107 19.0711L1 12L8.07107 4.92896L9.48528 6.34317L3.82843 12Z" })), So = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12.0049 4.00281C18.08 4.00281 23.0049 6.6891 23.0049 10.0028V14.0028C23.0049 17.3165 18.08 20.0028 12.0049 20.0028C6.03824 20.0028 1.18114 17.4116 1.00957 14.1797L1.00488 14.0028V10.0028C1.00488 6.6891 5.92975 4.00281 12.0049 4.00281ZM12.0049 16.0028C8.28443 16.0028 4.99537 14.9953 3.00466 13.4533L3.00488 14.0028C3.00488 15.885 6.88751 18.0028 12.0049 18.0028C17.0156 18.0028 20.8426 15.9723 20.9999 14.1207L21.0049 14.0028L21.0061 13.4525C19.0155 14.995 15.726 16.0028 12.0049 16.0028ZM12.0049 6.00281C6.88751 6.00281 3.00488 8.12061 3.00488 10.0028C3.00488 11.885 6.88751 14.0028 12.0049 14.0028C17.1223 14.0028 21.0049 11.885 21.0049 10.0028C21.0049 8.12061 17.1223 6.00281 12.0049 6.00281Z" })), Go = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M6 18H18V6H6V18ZM14 20H10V22H8V20H5C4.44772 20 4 19.5523 4 19V16H2V14H4V10H2V8H4V5C4 4.44772 4.44772 4 5 4H8V2H10V4H14V2H16V4H19C19.5523 4 20 4.44772 20 5V8H22V10H20V14H22V16H20V19C20 19.5523 19.5523 20 19 20H16V22H14V20ZM8 8H16V16H8V8Z" })), Do = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13.9093 12.3603L17.0007 20.8537L14.1816 21.8798L11.0902 13.3864L6.91797 16.5422L8.4087 1.63318L19.134 12.0959L13.9093 12.3603Z" })), Fo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21 9.5V12.5C21 14.9853 16.9706 17 12 17C7.02944 17 3 14.9853 3 12.5V9.5C3 11.9853 7.02944 14 12 14C16.9706 14 21 11.9853 21 9.5ZM3 14.5C3 16.9853 7.02944 19 12 19C16.9706 19 21 16.9853 21 14.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5V14.5ZM12 12C7.02944 12 3 9.98528 3 7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5C21 9.98528 16.9706 12 12 12Z" })), Oo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z" })), To = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17 4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7V2H17V4ZM9 9V17H11V9H9ZM13 9V17H15V9H13Z" })), Po = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM9 11V17H11V11H9ZM13 11V17H15V11H13ZM9 4V6H15V4H9Z" })), Wo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z" })), ko = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17 2V4H20C20.5523 4 21 4.44772 21 5V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V5C3 4.44772 3.44772 4 4 4H7V2H17ZM7 6H5V20H19V6H17V8H7V6ZM13 11V13H15V15H12.999L13 17H11L10.999 15H9V13H11V11H13ZM15 4H9V6H15V4Z" })), Xo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 19H21V21H3V19ZM13 13.1716L19.0711 7.1005L20.4853 8.51472L12 17L3.51472 8.51472L4.92893 7.1005L11 13.1716V2H13V13.1716Z" })), zo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9.24264 18.9967H21V20.9967H3V16.754L12.8995 6.85453L17.1421 11.0972L9.24264 18.9967ZM14.3137 5.44032L16.435 3.319C16.8256 2.92848 17.4587 2.92848 17.8492 3.319L20.6777 6.14743C21.0682 6.53795 21.0682 7.17112 20.6777 7.56164L18.5563 9.68296L14.3137 5.44032Z" })), Yo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12.6844 4.02547C12.4588 4.00646 12.2306 3.9967 12 3.9967C7.58172 3.9967 4 7.57843 4 11.9967C4 16.415 7.58172 19.9967 12 19.9967C16.4183 19.9967 20 16.415 20 11.9967C20 11.7662 19.9902 11.5379 19.9711 11.3123C19.8996 10.4646 19.6953 9.6442 19.368 8.87344L20.8682 7.37114C21.2031 8.01192 21.4706 8.6935 21.6613 9.40649C21.8213 10.0063 21.9258 10.6222 21.9723 11.248C21.9907 11.4952 22 11.7449 22 11.9967C22 17.5196 17.5228 21.9967 12 21.9967C6.47715 21.9967 2 17.5196 2 11.9967C2 6.47386 6.47715 1.9967 12 1.9967C12.2518 1.9967 12.5015 2.00601 12.7487 2.02431C13.3745 2.07081 13.9904 2.17542 14.5898 2.3358C15.3032 2.52609 15.9848 2.79359 16.6256 3.1285L15.1247 4.62934C14.3525 4.30143 13.5321 4.09707 12.6844 4.02547ZM20.4853 2.09721L21.8995 3.51142L12.7071 12.7038L11.2954 12.7063L11.2929 11.2896L20.4853 2.09721Z" })), jo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" })), Jo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z" })), _o = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V11H19L18.9999 6.413L11.2071 14.2071L9.79289 12.7929L17.5849 5H13V3H21Z" })), Uo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12ZM12.0003 17C14.7617 17 17.0003 14.7614 17.0003 12C17.0003 9.23858 14.7617 7 12.0003 7C9.23884 7 7.00026 9.23858 7.00026 12C7.00026 14.7614 9.23884 17 12.0003 17ZM12.0003 15C10.3434 15 9.00026 13.6569 9.00026 12C9.00026 10.3431 10.3434 9 12.0003 9C13.6571 9 15.0003 10.3431 15.0003 12C15.0003 13.6569 13.6571 15 12.0003 15Z" })), $o = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z" })), Qo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457ZM14.7577 16.1718L13.2937 14.7078C12.902 14.8952 12.4634 15.0002 12.0003 15.0002C10.3434 15.0002 9.00026 13.657 9.00026 12.0002C9.00026 11.537 9.10522 11.0984 9.29263 10.7067L7.82866 9.24277C7.30514 10.0332 7.00026 10.9811 7.00026 12.0002C7.00026 14.7616 9.23884 17.0002 12.0003 17.0002C13.0193 17.0002 13.9672 16.6953 14.7577 16.1718ZM7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925L16.947 12.7327C16.9821 12.4936 17.0003 12.249 17.0003 12.0002C17.0003 9.23873 14.7617 7.00016 12.0003 7.00016C11.7514 7.00016 11.5068 7.01833 11.2677 7.05343L7.97446 3.76015Z" })), Ko = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17.8827 19.2968C16.1814 20.3755 14.1638 21.0002 12.0003 21.0002C6.60812 21.0002 2.12215 17.1204 1.18164 12.0002C1.61832 9.62282 2.81932 7.5129 4.52047 5.93457L1.39366 2.80777L2.80788 1.39355L22.6069 21.1925L21.1927 22.6068L17.8827 19.2968ZM5.9356 7.3497C4.60673 8.56015 3.6378 10.1672 3.22278 12.0002C4.14022 16.0521 7.7646 19.0002 12.0003 19.0002C13.5997 19.0002 15.112 18.5798 16.4243 17.8384L14.396 15.8101C13.7023 16.2472 12.8808 16.5002 12.0003 16.5002C9.51498 16.5002 7.50026 14.4854 7.50026 12.0002C7.50026 11.1196 7.75317 10.2981 8.19031 9.60442L5.9356 7.3497ZM12.9139 14.328L9.67246 11.0866C9.5613 11.3696 9.50026 11.6777 9.50026 12.0002C9.50026 13.3809 10.6196 14.5002 12.0003 14.5002C12.3227 14.5002 12.6309 14.4391 12.9139 14.328ZM20.8068 16.5925L19.376 15.1617C20.0319 14.2268 20.5154 13.1586 20.7777 12.0002C19.8603 7.94818 16.2359 5.00016 12.0003 5.00016C11.1544 5.00016 10.3329 5.11773 9.55249 5.33818L7.97446 3.76015C9.22127 3.26959 10.5793 3.00016 12.0003 3.00016C17.3924 3.00016 21.8784 6.87992 22.8189 12.0002C22.5067 13.6998 21.8038 15.2628 20.8068 16.5925ZM11.7229 7.50857C11.8146 7.50299 11.9071 7.50016 12.0003 7.50016C14.4855 7.50016 16.5003 9.51488 16.5003 12.0002C16.5003 12.0933 16.4974 12.1858 16.4919 12.2775L11.7229 7.50857Z" })), qo = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z" })), es = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9 2.00318V2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8L9 2.00318ZM5.82918 8H9V4.83086L5.82918 8ZM11 4V9C11 9.55228 10.5523 10 10 10H5V20H19V4H11Z" })), ts = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" })), ns = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13 10H20L11 23V14H4L13 1V10Z" })), rs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13 9H21L11 24V15H4L13 0V9ZM11 11V7.22063L7.53238 13H13V17.3944L17.263 11H11Z" })), is = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M15.9994 2V4H14.9994V7.24291C14.9994 8.40051 15.2506 9.54432 15.7357 10.5954L20.017 19.8714C20.3641 20.6236 20.0358 21.5148 19.2836 21.8619C19.0865 21.9529 18.8721 22 18.655 22H5.34375C4.51532 22 3.84375 21.3284 3.84375 20.5C3.84375 20.2829 3.89085 20.0685 3.98181 19.8714L8.26306 10.5954C8.74816 9.54432 8.99939 8.40051 8.99939 7.24291V4H7.99939V2H15.9994ZM13.3873 10.0012H10.6115C10.5072 10.3644 10.3823 10.7221 10.2371 11.0724L10.079 11.4335L6.12439 20H17.8734L13.9198 11.4335C13.7054 10.9691 13.5276 10.4902 13.3873 10.0012ZM10.9994 7.24291C10.9994 7.49626 10.9898 7.7491 10.9706 8.00087H13.0282C13.0189 7.87982 13.0119 7.75852 13.0072 7.63704L12.9994 7.24291V4H10.9994V7.24291Z" })), as = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M6 21.5C4.067 21.5 2.5 19.933 2.5 18C2.5 16.067 4.067 14.5 6 14.5C7.5852 14.5 8.92427 15.5539 9.35481 16.9992L15 16.9994V15L17 14.9994V9.24339L14.757 6.99938H9V9.00003H3V3.00003H9V4.99939H14.757L18 1.75739L22.2426 6.00003L19 9.24139V14.9994L21 15V21H15V18.9994L9.35499 19.0003C8.92464 20.4459 7.58543 21.5 6 21.5ZM6 16.5C5.17157 16.5 4.5 17.1716 4.5 18C4.5 18.8285 5.17157 19.5 6 19.5C6.82843 19.5 7.5 18.8285 7.5 18C7.5 17.1716 6.82843 16.5 6 16.5ZM19 17H17V19H19V17ZM18 4.58581L16.5858 6.00003L18 7.41424L19.4142 6.00003L18 4.58581ZM7 5.00003H5V7.00003H7V5.00003Z" })), os = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13 1L13.001 4.06201C16.6192 4.51365 19.4869 7.38163 19.9381 11L23 11V13L19.938 13.001C19.4864 16.6189 16.6189 19.4864 13.001 19.938L13 23H11L11 19.9381C7.38163 19.4869 4.51365 16.6192 4.06201 13.001L1 13V11L4.06189 11C4.51312 7.38129 7.38129 4.51312 11 4.06189L11 1H13ZM12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z" })), ss = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13.4144 5H20.0002C20.5525 5 21.0002 5.44772 21.0002 6V7H3.00017V4C3.00017 3.44772 3.44789 3 4.00017 3H11.4144L13.4144 5ZM3.08697 9H20.9134C21.4657 9 21.9134 9.44772 21.9134 10C21.9134 10.0277 21.9122 10.0554 21.9099 10.083L21.0766 20.083C21.0334 20.6013 20.6001 21 20.08 21H3.9203C3.40021 21 2.96695 20.6013 2.92376 20.083L2.09042 10.083C2.04456 9.53267 2.45355 9.04932 3.00392 9.00345C3.03155 9.00115 3.05925 9 3.08697 9Z" })), ls = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M7.10508 8.78991C7.45179 10.0635 8.61653 11 10 11H14C16.4703 11 18.5222 12.7915 18.9274 15.1461C20.1303 15.5367 21 16.6668 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.7334 15.7849 15.6501 16.8949 15.2101C16.5482 13.9365 15.3835 13 14 13H10C8.87439 13 7.83566 12.6281 7 12.0004V15.1707C8.16519 15.5825 9 16.6938 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5825 5 15.1707V8.82929C3.83481 8.41746 3 7.30622 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6C9 7.26661 8.21506 8.34988 7.10508 8.78991ZM6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7ZM6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19ZM18 19C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17C17.4477 17 17 17.4477 17 18C17 18.5523 17.4477 19 18 19Z" })), cs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z" })), us = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13.0003 21H18.0003V23H6.00032V21H11.0003V19.9506C7.70689 19.6236 4.88351 17.6987 3.31641 14.9622L5.05319 13.9697C6.43208 16.3776 9.02674 18 12.0003 18C16.4186 18 20.0003 14.4182 20.0003 9.99995C20.0003 7.02637 18.378 4.43171 15.9701 3.05282L16.9626 1.31604C19.9724 3.03965 22.0003 6.28297 22.0003 9.99995C22.0003 15.1853 18.0536 19.4489 13.0003 19.9506V21ZM12.0003 17C8.13433 17 5.00032 13.8659 5.00032 9.99995C5.00032 6.13396 8.13433 2.99995 12.0003 2.99995C15.8663 2.99995 19.0003 6.13396 19.0003 9.99995C19.0003 13.8659 15.8663 17 12.0003 17ZM12.0003 15C14.7617 15 17.0003 12.7614 17.0003 9.99995C17.0003 7.23853 14.7617 4.99995 12.0003 4.99995C9.2389 4.99995 7.00032 7.23853 7.00032 9.99995C7.00032 12.7614 9.2389 15 12.0003 15Z" })), ds = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM21.0005 8V20H19.0005L19 10.204L17 10.74V8.67L19.5005 8H21.0005Z" })), fs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 8C20.5711 8 22.25 9.67893 22.25 11.75C22.25 12.6074 21.9623 13.3976 21.4781 14.0292L21.3302 14.2102L18.0343 18H22V20H15L14.9993 18.444L19.8207 12.8981C20.0881 12.5908 20.25 12.1893 20.25 11.75C20.25 10.7835 19.4665 10 18.5 10C17.5818 10 16.8288 10.7071 16.7558 11.6065L16.75 11.75H14.75C14.75 9.67893 16.4289 8 18.5 8Z" })), ms = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M22 8L21.9984 10L19.4934 12.883C21.0823 13.3184 22.25 14.7728 22.25 16.5C22.25 18.5711 20.5711 20.25 18.5 20.25C16.674 20.25 15.1528 18.9449 14.8184 17.2166L16.7821 16.8352C16.9384 17.6413 17.6481 18.25 18.5 18.25C19.4665 18.25 20.25 17.4665 20.25 16.5C20.25 15.5335 19.4665 14.75 18.5 14.75C18.214 14.75 17.944 14.8186 17.7056 14.9403L16.3992 13.3932L19.3484 10H15V8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z" })), gs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM22 8V16H23.5V18H22V20H20V18H14.5V16.66L19.5 8H22ZM20 11.133L17.19 16H20V11.133Z" })), hs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M22 8V10H17.6769L17.2126 12.6358C17.5435 12.5472 17.8912 12.5 18.25 12.5C20.4591 12.5 22.25 14.2909 22.25 16.5C22.25 18.7091 20.4591 20.5 18.25 20.5C16.4233 20.5 14.8827 19.2756 14.4039 17.6027L16.3271 17.0519C16.5667 17.8881 17.3369 18.5 18.25 18.5C19.3546 18.5 20.25 17.6046 20.25 16.5C20.25 15.3954 19.3546 14.5 18.25 14.5C17.6194 14.5 17.057 14.7918 16.6904 15.2478L14.8803 14.3439L16 8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z" })), Cs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21.097 8L18.499 12.5C20.7091 12.5 22.5 14.2909 22.5 16.5C22.5 18.7091 20.7091 20.5 18.5 20.5C16.2909 20.5 14.5 18.7091 14.5 16.5C14.5 15.7636 14.699 15.0737 15.0461 14.4811L18.788 8H21.097ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 14.5C17.3954 14.5 16.5 15.3954 16.5 16.5C16.5 17.6046 17.3954 18.5 18.5 18.5C19.6046 18.5 20.5 17.6046 20.5 16.5C20.5 15.3954 19.6046 14.5 18.5 14.5Z" })), bs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M7.78428 14L8.2047 10H4V8H8.41491L8.94043 3H10.9514L10.4259 8H14.4149L14.9404 3H16.9514L16.4259 8H20V10H16.2157L15.7953 14H20V16H15.5851L15.0596 21H13.0486L13.5741 16H9.58509L9.05957 21H7.04855L7.57407 16H4V14H7.78428ZM9.7953 14H13.7843L14.2047 10H10.2157L9.7953 14Z" })), ps = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17 11V4H19V21H17V13H7V21H5V4H7V11H17Z" })), vs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M20 2C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22H6C5.44772 22 5 21.5523 5 21V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3C5 2.44772 5.44772 2 6 2H20ZM14 8H12V11H9V13H11.999L12 16H14L13.999 13H17V11H14V8Z" })), ws = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C10.0226 20.3135 4.91699 17.563 2.86894 13.001L1 13V11L2.21045 11.0009C2.07425 10.3633 2 9.69651 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3ZM16.5 5C15.4241 5 14.2593 5.56911 13.4142 6.41421L12 7.82843L10.5858 6.41421C9.74068 5.56911 8.5759 5 7.5 5C5.55906 5 4 6.6565 4 9C4 9.68542 4.09035 10.3516 4.26658 11.0004L6.43381 11L8.5 7.55635L11.5 12.5563L12.4338 11H17V13H13.5662L11.5 16.4437L8.5 11.4437L7.56619 13L5.10789 13.0006C5.89727 14.3737 7.09304 15.6681 8.64514 16.9029C9.39001 17.4955 10.1845 18.0485 11.0661 18.6038C11.3646 18.7919 11.6611 18.9729 12 19.1752C12.3389 18.9729 12.6354 18.7919 12.9339 18.6038C13.8155 18.0485 14.61 17.4955 15.3549 16.9029C18.3337 14.533 20 11.9435 20 9C20 6.64076 18.463 5 16.5 5Z" })), xs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z" })), ys = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9.48907C3 9.18048 3.14247 8.88917 3.38606 8.69972L11.3861 2.47749C11.7472 2.19663 12.2528 2.19663 12.6139 2.47749L20.6139 8.69972C20.8575 8.88917 21 9.18048 21 9.48907V20ZM19 19V9.97815L12 4.53371L5 9.97815V19H19Z" })), Is = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z" })), Vs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z" })), Hs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 21C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4ZM8 10H5V19H8V10ZM19 10H10V19H19V10ZM19 5H5V8H19V5Z" })), Ms = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 17C11.355 17 10.7386 16.8779 10.1725 16.6555L7.93604 18.8923C9.12707 19.5961 10.5164 20 12 20C13.4836 20 14.8729 19.5961 16.064 18.8923L13.8275 16.6555C13.2614 16.8779 12.645 17 12 17ZM4 12C4 13.4836 4.40386 14.8729 5.10765 16.064L7.34451 13.8275C7.12213 13.2614 7 12.645 7 12C7 11.355 7.12213 10.7386 7.34451 10.1725L5.10765 7.93604C4.40386 9.12707 4 10.5164 4 12ZM18.8923 7.93604L16.6555 10.1725C16.8779 10.7386 17 11.355 17 12C17 12.645 16.8779 13.2614 16.6555 13.8275L18.8923 16.064C19.5961 14.8729 20 13.4836 20 12C20 10.5164 19.5961 9.12707 18.8923 7.93604ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM12 4C10.5164 4 9.12707 4.40386 7.93604 5.10765L10.1725 7.34451C10.7386 7.12213 11.355 7 12 7C12.645 7 13.2614 7.12213 13.8275 7.34451L16.064 5.10765C14.8729 4.40386 13.4836 4 12 4Z" })), Es = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5 3V19H21V21H3V3H5ZM20.2929 6.29289L21.7071 7.70711L16 13.4142L13 10.415L8.70711 14.7071L7.29289 13.2929L13 7.58579L16 10.585L20.2929 6.29289Z" })), Ns = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M18.3638 15.5355L16.9496 14.1213L18.3638 12.7071C20.3164 10.7545 20.3164 7.58866 18.3638 5.63604C16.4112 3.68341 13.2453 3.68341 11.2927 5.63604L9.87849 7.05025L8.46428 5.63604L9.87849 4.22182C12.6122 1.48815 17.0443 1.48815 19.778 4.22182C22.5117 6.95549 22.5117 11.3876 19.778 14.1213L18.3638 15.5355ZM15.5353 18.364L14.1211 19.7782C11.3875 22.5118 6.95531 22.5118 4.22164 19.7782C1.48797 17.0445 1.48797 12.6123 4.22164 9.87868L5.63585 8.46446L7.05007 9.87868L5.63585 11.2929C3.68323 13.2455 3.68323 16.4113 5.63585 18.364C7.58847 20.3166 10.7543 20.3166 12.7069 18.364L14.1211 16.9497L15.5353 18.364ZM14.8282 7.75736L16.2425 9.17157L9.17139 16.2426L7.75717 14.8284L14.8282 7.75736Z" })), Ls = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13.0607 8.11097L14.4749 9.52518C17.2086 12.2589 17.2086 16.691 14.4749 19.4247L14.1214 19.7782C11.3877 22.5119 6.95555 22.5119 4.22188 19.7782C1.48821 17.0446 1.48821 12.6124 4.22188 9.87874L5.6361 11.293C3.68348 13.2456 3.68348 16.4114 5.6361 18.364C7.58872 20.3166 10.7545 20.3166 12.7072 18.364L13.0607 18.0105C15.0133 16.0578 15.0133 12.892 13.0607 10.9394L11.6465 9.52518L13.0607 8.11097ZM19.7782 14.1214L18.364 12.7072C20.3166 10.7545 20.3166 7.58872 18.364 5.6361C16.4114 3.68348 13.2456 3.68348 11.293 5.6361L10.9394 5.98965C8.98678 7.94227 8.98678 11.1081 10.9394 13.0607L12.3536 14.4749L10.9394 15.8891L9.52518 14.4749C6.79151 11.7413 6.79151 7.30911 9.52518 4.57544L9.87874 4.22188C12.6124 1.48821 17.0446 1.48821 19.7782 4.22188C22.5119 6.95555 22.5119 11.3877 19.7782 14.1214Z" })), As = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8 4H21V6H8V4ZM3 3.5H6V6.5H3V3.5ZM3 10.5H6V13.5H3V10.5ZM3 17.5H6V20.5H3V17.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" })), Zs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M19 10H20C20.5523 10 21 10.4477 21 11V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11C3 10.4477 3.44772 10 4 10H5V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V10ZM5 12V20H19V12H5ZM11 14H13V18H11V14ZM17 10V9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V10H17Z" })), Rs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5 22C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V6H18V4H6V20H18V18H20V21C20 21.5523 19.5523 22 19 22H5ZM18 16V13H11V11H18V8L23 12L18 16Z" })), Bs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 7.23792L12.0718 14.338L4 7.21594V19H20V7.23792ZM4.51146 5L12.0619 11.662L19.501 5H4.51146Z" })), Ss = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M2 8.99374C2 5.68349 4.67654 3 8.00066 3H15.9993C19.3134 3 22 5.69478 22 8.99374V21H8.00066C4.68659 21 2 18.3052 2 15.0063V8.99374ZM14 11V13H16V11H14ZM8 11V13H10V11H8Z" })), Gs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z" })), Ds = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M10 2C10.5523 2 11 2.44772 11 3V7C11 7.55228 10.5523 8 10 8H8V10H13V9C13 8.44772 13.4477 8 14 8H20C20.5523 8 21 8.44772 21 9V13C21 13.5523 20.5523 14 20 14H14C13.4477 14 13 13.5523 13 13V12H8V18H13V17C13 16.4477 13.4477 16 14 16H20C20.5523 16 21 16.4477 21 17V21C21 21.5523 20.5523 22 20 22H14C13.4477 22 13 21.5523 13 21V20H7C6.44772 20 6 19.5523 6 19V8H4C3.44772 8 3 7.55228 3 7V3C3 2.44772 3.44772 2 4 2H10ZM19 18H15V20H19V18ZM19 10H15V12H19V10ZM9 4H5V6H9V4Z" })), Fs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M22 20H2V18H3V11.0314C3 6.04348 7.02944 2 12 2C16.9706 2 21 6.04348 21 11.0314V18H22V20ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z" })), Os = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M22 20H2V18H3V11.0314C3 6.04348 7.02944 2 12 2C16.9706 2 21 6.04348 21 11.0314V18H22V20ZM5 18H19V11.0314C19 7.14806 15.866 4 12 4C8.13401 4 5 7.14806 5 11.0314V18ZM9.5 21H14.5C14.5 22.3807 13.3807 23.5 12 23.5C10.6193 23.5 9.5 22.3807 9.5 21Z" })), Ts = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12.8995 6.85453L17.1421 11.0972L7.24264 20.9967H3V16.754L12.8995 6.85453ZM14.3137 5.44032L16.435 3.319C16.8256 2.92848 17.4587 2.92848 17.8492 3.319L20.6777 6.14743C21.0682 6.53795 21.0682 7.17112 20.6777 7.56164L18.5563 9.68296L14.3137 5.44032Z" })), Ps = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z" })), Ws = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z" })), ks = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M19.376 12.4161L8.77735 19.4818C8.54759 19.635 8.23715 19.5729 8.08397 19.3432C8.02922 19.261 8 19.1645 8 19.0658V4.93433C8 4.65818 8.22386 4.43433 8.5 4.43433C8.59871 4.43433 8.69522 4.46355 8.77735 4.5183L19.376 11.584C19.6057 11.7372 19.6678 12.0477 19.5146 12.2774C19.478 12.3323 19.4309 12.3795 19.376 12.4161Z" })), Xs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M10.9042 2.10025L20.8037 3.51446L22.2179 13.414L13.0255 22.6063C12.635 22.9969 12.0019 22.9969 11.6113 22.6063L1.71184 12.7069C1.32131 12.3163 1.32131 11.6832 1.71184 11.2926L10.9042 2.10025ZM13.7327 10.5855C14.5137 11.3666 15.78 11.3666 16.5611 10.5855C17.3421 9.80448 17.3421 8.53815 16.5611 7.7571C15.78 6.97606 14.5137 6.97606 13.7327 7.7571C12.9516 8.53815 12.9516 9.80448 13.7327 10.5855Z" })), zs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21.0082 3C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM20 5H4V19H20V5ZM18 15V17H6V15H18ZM12 7V13H6V7H12ZM18 11V13H14V11H18ZM10 9H8V11H10V9ZM18 7V9H14V7H18Z" })), Ys = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9 7.53861L15 21.5386L18.6594 13H23V11H17.3406L15 16.4614L9 2.46143L5.3406 11H1V13H6.6594L9 7.53861Z" })), js = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M16 17V16H13V13H16V15H18V17H17V19H15V21H13V18H15V17H16ZM21 21H17V19H19V17H21V21ZM3 3H11V11H3V3ZM5 5V9H9V5H5ZM13 3H21V11H13V3ZM15 5V9H19V5H15ZM3 13H11V21H3V13ZM5 15V19H9V15H5ZM18 13H21V15H18V13ZM6 6H8V8H6V6ZM6 16H8V18H6V16ZM16 6H18V8H16V6Z" })), Js = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM13 13.3551C14.4457 12.9248 15.5 11.5855 15.5 10C15.5 8.067 13.933 6.5 12 6.5C10.302 6.5 8.88637 7.70919 8.56731 9.31346L10.5288 9.70577C10.6656 9.01823 11.2723 8.5 12 8.5C12.8284 8.5 13.5 9.17157 13.5 10C13.5 10.8284 12.8284 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5V14H13V13.3551Z" })), _s = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM13 13.3551V14H11V12.5C11 11.9477 11.4477 11.5 12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.2723 8.5 10.6656 9.01823 10.5288 9.70577L8.56731 9.31346C8.88637 7.70919 10.302 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.5855 14.4457 12.9248 13 13.3551Z" })), Us = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17Z" })), $s = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z" })), Qs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M15.5018 20.0048C14.8432 21.5841 13.5794 22.848 12 23.5066C10.4206 22.848 9.15679 21.5841 8.49816 20.0048H10.7575C11.0838 20.4934 11.5051 20.9171 12 21.248C12.4949 20.9171 12.9162 20.4934 13.2425 20.0048H15.5018ZM18 14.8095L20 17.0777V19.0048H4V17.0777L6 14.8095V9.00478C6 5.52153 8.50442 2.55822 12 1.45999C15.4956 2.55822 18 5.52153 18 9.00478V14.8095ZM17.2692 17.0048L16 15.5653V9.00478C16 6.68694 14.4292 4.57431 12 3.58384C9.57078 4.57431 8 6.68694 8 9.00478V15.5653L6.73076 17.0048H17.2692ZM12 11.0048C10.8954 11.0048 10 10.1093 10 9.00478C10 7.90021 10.8954 7.00478 12 7.00478C13.1046 7.00478 14 7.90021 14 9.00478C14 10.1093 13.1046 11.0048 12 11.0048Z" })), Ks = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M7 19V13H17V19H19V7.82843L16.1716 5H5V19H7ZM4 3H17L21 7V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM9 15V19H15V15H9Z" })), qs = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z" })), el = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5 11H19V5H5V11ZM21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4ZM19 13H5V19H19V13ZM7 15H10V17H7V15ZM7 7H10V9H7V7Z" })), tl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M2 11.9998C2 11.1353 2.1097 10.2964 2.31595 9.49631C3.40622 9.55283 4.48848 9.01015 5.0718 7.99982C5.65467 6.99025 5.58406 5.78271 4.99121 4.86701C6.18354 3.69529 7.66832 2.82022 9.32603 2.36133C9.8222 3.33385 10.8333 3.99982 12 3.99982C13.1667 3.99982 14.1778 3.33385 14.674 2.36133C16.3317 2.82022 17.8165 3.69529 19.0088 4.86701C18.4159 5.78271 18.3453 6.99025 18.9282 7.99982C19.5115 9.01015 20.5938 9.55283 21.6841 9.49631C21.8903 10.2964 22 11.1353 22 11.9998C22 12.8643 21.8903 13.7032 21.6841 14.5033C20.5938 14.4468 19.5115 14.9895 18.9282 15.9998C18.3453 17.0094 18.4159 18.2169 19.0088 19.1326C17.8165 20.3043 16.3317 21.1794 14.674 21.6383C14.1778 20.6658 13.1667 19.9998 12 19.9998C10.8333 19.9998 9.8222 20.6658 9.32603 21.6383C7.66832 21.1794 6.18354 20.3043 4.99121 19.1326C5.58406 18.2169 5.65467 17.0094 5.0718 15.9998C4.48848 14.9895 3.40622 14.4468 2.31595 14.5033C2.1097 13.7032 2 12.8643 2 11.9998ZM6.80385 14.9998C7.43395 16.0912 7.61458 17.3459 7.36818 18.5236C7.77597 18.8138 8.21005 19.0652 8.66489 19.2741C9.56176 18.4712 10.7392 17.9998 12 17.9998C13.2608 17.9998 14.4382 18.4712 15.3351 19.2741C15.7899 19.0652 16.224 18.8138 16.6318 18.5236C16.3854 17.3459 16.566 16.0912 17.1962 14.9998C17.8262 13.9085 18.8225 13.1248 19.9655 12.7493C19.9884 12.5015 20 12.2516 20 11.9998C20 11.7481 19.9884 11.4981 19.9655 11.2504C18.8225 10.8749 17.8262 10.0912 17.1962 8.99982C16.566 7.90845 16.3854 6.65378 16.6318 5.47605C16.224 5.18588 15.7899 4.93447 15.3351 4.72552C14.4382 5.52844 13.2608 5.99982 12 5.99982C10.7392 5.99982 9.56176 5.52844 8.66489 4.72552C8.21005 4.93447 7.77597 5.18588 7.36818 5.47605C7.61458 6.65378 7.43395 7.90845 6.80385 8.99982C6.17376 10.0912 5.17754 10.8749 4.03451 11.2504C4.01157 11.4981 4 11.7481 4 11.9998C4 12.2516 4.01157 12.5015 4.03451 12.7493C5.17754 13.1248 6.17376 13.9085 6.80385 14.9998ZM12 14.9998C10.3431 14.9998 9 13.6567 9 11.9998C9 10.343 10.3431 8.99982 12 8.99982C13.6569 8.99982 15 10.343 15 11.9998C15 13.6567 13.6569 14.9998 12 14.9998ZM12 12.9998C12.5523 12.9998 13 12.5521 13 11.9998C13 11.4475 12.5523 10.9998 12 10.9998C11.4477 10.9998 11 11.4475 11 11.9998C11 12.5521 11.4477 12.9998 12 12.9998Z" })), nl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13.1202 17.0228L8.92129 14.7324C8.19135 15.5125 7.15261 16 6 16C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8C7.15255 8 8.19125 8.48746 8.92118 9.26746L13.1202 6.97713C13.0417 6.66441 13 6.33707 13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6C21 8.20914 19.2091 10 17 10C15.8474 10 14.8087 9.51251 14.0787 8.73246L9.87977 11.0228C9.9583 11.3355 10 11.6629 10 12C10 12.3371 9.95831 12.6644 9.87981 12.9771L14.0788 15.2675C14.8087 14.4875 15.8474 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.6629 13.0417 17.3355 13.1202 17.0228ZM6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14ZM17 8C18.1046 8 19 7.10457 19 6C19 4.89543 18.1046 4 17 4C15.8954 4 15 4.89543 15 6C15 7.10457 15.8954 8 17 8ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z" })), rl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3.78307 2.82598L12 1L20.2169 2.82598C20.6745 2.92766 21 3.33347 21 3.80217V13.7889C21 15.795 19.9974 17.6684 18.3282 18.7812L12 23L5.6718 18.7812C4.00261 17.6684 3 15.795 3 13.7889V3.80217C3 3.33347 3.32553 2.92766 3.78307 2.82598ZM5 4.60434V13.7889C5 15.1263 5.6684 16.3752 6.7812 17.1171L12 20.5963L17.2188 17.1171C18.3316 16.3752 19 15.1263 19 13.7889V4.60434L12 3.04879L5 4.60434ZM12 11C10.6193 11 9.5 9.88071 9.5 8.5C9.5 7.11929 10.6193 6 12 6C13.3807 6 14.5 7.11929 14.5 8.5C14.5 9.88071 13.3807 11 12 11ZM7.52746 16C7.77619 13.75 9.68372 12 12 12C14.3163 12 16.2238 13.75 16.4725 16H7.52746Z" })), il = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M16 12.6667L5.77735 19.4818C5.54759 19.6349 5.23715 19.5729 5.08397 19.3431C5.02922 19.261 5 19.1645 5 19.0657V4.93426C5 4.65812 5.22386 4.43426 5.5 4.43426C5.59871 4.43426 5.69522 4.46348 5.77735 4.51823L16 11.3333V5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V12.6667ZM7 7.73703V16.263L13.3944 12L7 7.73703Z" })), al = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8 3V5H6V9C6 11.2091 7.79086 13 10 13C12.2091 13 14 11.2091 14 9V5H12V3H15C15.5523 3 16 3.44772 16 4V9C16 11.9727 13.8381 14.4405 11.0008 14.9169L11 16.5C11 18.433 12.567 20 14.5 20C15.9973 20 17.275 19.0598 17.7749 17.7375C16.7283 17.27 16 16.2201 16 15C16 13.3431 17.3431 12 19 12C20.6569 12 22 13.3431 22 15C22 16.3711 21.0802 17.5274 19.824 17.8854C19.2102 20.252 17.0592 22 14.5 22C11.4624 22 9 19.5376 9 16.5L9.00019 14.9171C6.16238 14.4411 4 11.9731 4 9V4C4 3.44772 4.44772 3 5 3H8ZM19 14C18.4477 14 18 14.4477 18 15C18 15.5523 18.4477 16 19 16C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14Z" })), ol = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21 16L15.9968 21H3.99826C3.44694 21 3 20.5551 3 20.0066V3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44749 21 3.9985V16Z" })), sl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9 9V15H15V9H9Z" })), ll = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17.1538 14C17.3846 14.5161 17.5 15.0893 17.5 15.7196C17.5 17.0625 16.9762 18.1116 15.9286 18.867C14.8809 19.6223 13.4335 20 11.5862 20C9.94674 20 8.32335 19.6185 6.71592 18.8555V16.6009C8.23538 17.4783 9.7908 17.917 11.3822 17.917C13.9333 17.917 15.2128 17.1846 15.2208 15.7196C15.2208 15.0939 15.0049 14.5598 14.5731 14.1173C14.5339 14.0772 14.4939 14.0381 14.4531 14H3V12H21V14H17.1538ZM13.076 11H7.62908C7.4566 10.8433 7.29616 10.6692 7.14776 10.4778C6.71592 9.92084 6.5 9.24559 6.5 8.45207C6.5 7.21602 6.96583 6.165 7.89749 5.299C8.82916 4.43299 10.2706 4 12.2219 4C13.6934 4 15.1009 4.32808 16.4444 4.98426V7.13591C15.2448 6.44921 13.9293 6.10587 12.4978 6.10587C10.0187 6.10587 8.77917 6.88793 8.77917 8.45207C8.77917 8.87172 8.99709 9.23796 9.43293 9.55079C9.86878 9.86362 10.4066 10.1135 11.0463 10.3004C11.6665 10.4816 12.3431 10.7148 13.076 11H13.076Z" })), cl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M19 11H5V13H19V11Z" })), ul = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M6 4V8H18V4H20.0066C20.5552 4 21 4.44495 21 4.9934V21.0066C21 21.5552 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5551 3 21.0066V4.9934C3 4.44476 3.44495 4 3.9934 4H6ZM9 17H7V19H9V17ZM9 14H7V16H9V14ZM9 11H7V13H9V11ZM16 2V6H8V2H16Z" })), dl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM12 15V17H18V15H12ZM8.41421 12L5.58579 14.8284L7 16.2426L11.2426 12L7 7.75736L5.58579 9.17157L8.41421 12Z" })), fl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M20 10H4V19H20V10ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM5 6V8H7V6H5ZM9 6V8H11V6H9ZM5 11H8V16H5V11Z" })), ml = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17 2V4H16V18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18V4H7V2H17ZM13 15C12.4477 15 12 15.4477 12 16C12 16.5523 12.4477 17 13 17C13.5523 17 14 16.5523 14 16C14 15.4477 13.5523 15 13 15ZM11 12C10.4477 12 10 12.4477 10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12ZM14 4H10V8H14V4Z" })), gl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17 2V4H16V18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18V4H7V2H17ZM14 10H10V18C10 19.1046 10.8954 20 12 20C13.1046 20 14 19.1046 14 18V10ZM13 15C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17C12.4477 17 12 16.5523 12 16C12 15.4477 12.4477 15 13 15ZM11 12C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14C10.4477 14 10 13.5523 10 13C10 12.4477 10.4477 12 11 12ZM14 4H10V8H14V4Z" })), hl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13 6V21H11V6H5V4H19V6H13Z" })), Cl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M22 15H19V3H22C22.5523 3 23 3.44772 23 4V14C23 14.5523 22.5523 15 22 15ZM16.7071 16.2929L10.3066 22.6934C10.1307 22.8693 9.85214 22.8891 9.65308 22.7398L8.8005 22.1004C8.3158 21.7369 8.09739 21.1174 8.24686 20.5303L9.40017 16H3C1.89543 16 1 15.1046 1 14V11.8957C1 11.6344 1.05118 11.3757 1.15064 11.1342L4.24501 3.61925C4.3993 3.24455 4.76447 3 5.16969 3H16C16.5523 3 17 3.44772 17 4V15.5858C17 15.851 16.8946 16.1054 16.7071 16.2929Z" })), bl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9.40017 16H3C1.89543 16 1 15.1046 1 14V11.8957C1 11.6344 1.05118 11.3757 1.15064 11.1342L4.24501 3.61925C4.3993 3.24455 4.76447 3 5.16969 3H22C22.5523 3 23 3.44772 23 4V14C23 14.5523 22.5523 15 22 15H18.5182C18.1932 15 17.8886 15.1579 17.7012 15.4233L12.2478 23.149C12.1053 23.3508 11.8367 23.4184 11.6157 23.3078L9.80163 22.4008C8.74998 21.875 8.20687 20.6874 8.49694 19.548L9.40017 16ZM17 13.4125V5H5.83939L3 11.8957V14H9.40017C10.7049 14 11.6602 15.229 11.3384 16.4934L10.4351 20.0414C10.3771 20.2693 10.4857 20.5068 10.6961 20.612L11.3572 20.9425L16.0673 14.27C16.3172 13.9159 16.6366 13.6257 17 13.4125ZM19 13H21V5H19V13Z" })), pl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M2 8.99997H5V21H2C1.44772 21 1 20.5523 1 20V9.99997C1 9.44769 1.44772 8.99997 2 8.99997ZM7.29289 7.70708L13.6934 1.30661C13.8693 1.13066 14.1479 1.11087 14.3469 1.26016L15.1995 1.8996C15.6842 2.26312 15.9026 2.88253 15.7531 3.46966L14.5998 7.99997H21C22.1046 7.99997 23 8.8954 23 9.99997V12.1043C23 12.3656 22.9488 12.6243 22.8494 12.8658L19.755 20.3807C19.6007 20.7554 19.2355 21 18.8303 21H8C7.44772 21 7 20.5523 7 20V8.41419C7 8.14897 7.10536 7.89462 7.29289 7.70708Z" })), vl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M14.5998 8.00033H21C22.1046 8.00033 23 8.89576 23 10.0003V12.1047C23 12.3659 22.9488 12.6246 22.8494 12.8662L19.755 20.3811C19.6007 20.7558 19.2355 21.0003 18.8303 21.0003H2C1.44772 21.0003 1 20.5526 1 20.0003V10.0003C1 9.44804 1.44772 9.00033 2 9.00033H5.48184C5.80677 9.00033 6.11143 8.84246 6.29881 8.57701L11.7522 0.851355C11.8947 0.649486 12.1633 0.581978 12.3843 0.692483L14.1984 1.59951C15.25 2.12534 15.7931 3.31292 15.5031 4.45235L14.5998 8.00033ZM7 10.5878V19.0003H18.1606L21 12.1047V10.0003H14.5998C13.2951 10.0003 12.3398 8.77128 12.6616 7.50691L13.5649 3.95894C13.6229 3.73105 13.5143 3.49353 13.3039 3.38837L12.6428 3.0578L7.93275 9.73038C7.68285 10.0844 7.36341 10.3746 7 10.5878ZM5 11.0003H3V19.0003H5V11.0003Z" })), wl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM13 12V7H11V14H17V12H13Z" })), xl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 12H17V14H11V7H13V12Z" })), yl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17.6177 5.9681L19.0711 4.51472L20.4853 5.92893L19.0319 7.38231C20.2635 8.92199 21 10.875 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4C14.125 4 16.078 4.73647 17.6177 5.9681ZM12 20C15.866 20 19 16.866 19 13C19 9.13401 15.866 6 12 6C8.13401 6 5 9.13401 5 13C5 16.866 8.13401 20 12 20ZM11 8H13V14H11V8ZM8 1H16V3H8V1Z" })), Il = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5.32943 3.27158C6.56252 2.8332 7.9923 3.10749 8.97927 4.09446C10.1002 5.21537 10.3019 6.90741 9.5843 8.23385L20.293 18.9437L18.8788 20.3579L8.16982 9.64875C6.84325 10.3669 5.15069 10.1654 4.02952 9.04421C3.04227 8.05696 2.7681 6.62665 3.20701 5.39332L5.44373 7.63C6.02952 8.21578 6.97927 8.21578 7.56505 7.63C8.15084 7.04421 8.15084 6.09446 7.56505 5.50868L5.32943 3.27158ZM15.6968 5.15512L18.8788 3.38736L20.293 4.80157L18.5252 7.98355L16.7574 8.3371L14.6361 10.4584L13.2219 9.04421L15.3432 6.92289L15.6968 5.15512ZM8.97927 13.2868L10.3935 14.7011L5.09018 20.0044C4.69966 20.3949 4.06649 20.3949 3.67597 20.0044C3.31334 19.6417 3.28744 19.0699 3.59826 18.6774L3.67597 18.5902L8.97927 13.2868Z" })), Vl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z" })), Hl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M7 20.9811C3.64378 20.7257 1 17.9216 1 14.5C1 12.1716 2.22429 10.1291 4.06426 8.9812C4.56469 5.044 7.92686 2 12 2C16.0731 2 19.4353 5.044 19.9357 8.9812C21.7757 10.1291 23 12.1716 23 14.5C23 17.9216 20.3562 20.7257 17 20.9811V21H7V20.9811ZM13 13H16L12 8L8 13H11V17H13V13Z" })), Ml = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 19H21V21H3V19ZM13 5.82843V17H11V5.82843L4.92893 11.8995L3.51472 10.4853L12 2L20.4853 10.4853L19.0711 11.8995L13 5.82843Z" })), El = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z" })), Nl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z" })), Ll = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM20 11H4V19H20V11ZM20 5H4V9H20V5ZM11 6V8H9V6H11ZM7 6V8H5V6H7Z" })), Al = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748ZM10 10V7H12V10H15V12H12V15H10V12H7V10H10Z" })), Zl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748ZM7 10H15V12H7V10Z" })), Rl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4.83582 12L11.0429 18.2071L12.4571 16.7929L7.66424 12L12.4571 7.20712L11.0429 5.79291L4.83582 12ZM10.4857 12L16.6928 18.2071L18.107 16.7929L13.3141 12L18.107 7.20712L16.6928 5.79291L10.4857 12Z" })), Bl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M15.0712 4.92883L16.4854 6.34305L11.8286 10.9999L21.0004 11L21.0004 13L11.8286 12.9999L16.4854 17.6568L15.0712 19.071L8.00016 11.9999L15.0712 4.92883ZM4.00037 18.9998L4.00037 4.99985H6.00037L6.00037 18.9998H4.00037Z" })), Sl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12.1715 10.9999L7.51457 6.34305L8.92878 4.92883L15.9999 11.9999L8.92878 19.071L7.51457 17.6568L12.1714 12.9999L2.9996 13L2.99957 11L12.1715 10.9999ZM17.9996 18.9998L17.9996 4.99985H19.9996L19.9996 18.9998H17.9996Z" })), Gl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8.66223 14.4841C8.66223 13.9312 9.11034 13.4829 9.6634 13.4829 10.2163 13.4829 10.6646 13.9312 10.6646 14.4841V16.4812C10.6646 17.0341 10.2165 17.4824 9.6634 17.4824 9.11034 17.4824 8.66223 17.0341 8.66223 16.4812V14.4841ZM15.3367 14.4841C15.3367 13.9312 14.8886 13.4829 14.3355 13.4829 13.7822 13.4829 13.3344 13.9314 13.3344 14.4841V16.4812C13.3344 17.0341 13.7825 17.4824 14.3355 17.4824 14.8886 17.4824 15.3367 17.0341 15.3367 16.4812V14.4841ZM11.9995 4.02765C11.1541 2.80927 9.40138 2.71883 8.0541 2.83958 6.51063 2.99438 5.21093 3.52495 4.48026 4.30434 3.2125 5.68959 3.15351 8.59518 3.76523 10.1949 3.70377 10.4683 3.64517 10.7453 3.60293 11.0385 2.4729 11.3362 1.32031 12.9371 1.32031 14.0819V16.2445C1.32031 16.8449 1.60059 17.3921 2.09466 17.7659 4.9186 19.8644 8.43899 21.49 11.9995 21.49 15.5599 21.49 19.0803 19.8644 21.9043 17.7659 22.3983 17.3921 22.6786 16.8449 22.6786 16.2445V14.0819C22.6786 12.9371 21.5261 11.3362 20.396 11.0385 20.3539 10.7453 20.2953 10.4683 20.2338 10.1949 20.8454 8.59518 20.7864 5.68959 19.5187 4.30434 18.788 3.52495 17.4883 2.99438 15.9449 2.83958 14.5976 2.71883 12.8449 2.80927 11.9995 4.02765ZM18.674 17.4874C17.139 18.3415 14.5891 19.4879 11.9995 19.4879 9.40986 19.4879 6.86 18.3415 5.325 17.4874V11.689C7.80186 12.6484 10.6522 12.1537 11.9975 9.93121H12.0014C13.3468 12.1537 16.1971 12.6484 18.674 11.689V17.4874ZM10.6646 6.82895C10.6646 8.41414 10.1848 10.1401 7.99479 10.1401 5.80474 10.1401 5.38758 9.61574 5.38758 8.14315 5.38758 5.80709 5.7441 4.80738 8.70396 4.80738 10.4143 4.80738 10.6646 5.35636 10.6646 6.82895ZM13.3344 6.82895C13.3344 5.35636 13.5847 4.80738 15.2951 4.80738 18.2548 4.80738 18.6114 5.80709 18.6114 8.14315 18.6114 9.61574 18.1942 10.1401 16.0042 10.1401 13.8141 10.1401 13.3344 8.41414 13.3344 6.82895Z" })), Dl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z" })), Fl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M14 4.4375C15.3462 4.4375 16.4375 3.34619 16.4375 2H17.5625C17.5625 3.34619 18.6538 4.4375 20 4.4375V5.5625C18.6538 5.5625 17.5625 6.65381 17.5625 8H16.4375C16.4375 6.65381 15.3462 5.5625 14 5.5625V4.4375ZM1 11C4.31371 11 7 8.31371 7 5H9C9 8.31371 11.6863 11 15 11V13C11.6863 13 9 15.6863 9 19H7C7 15.6863 4.31371 13 1 13V11ZM4.87601 12C6.18717 12.7276 7.27243 13.8128 8 15.124 8.72757 13.8128 9.81283 12.7276 11.124 12 9.81283 11.2724 8.72757 10.1872 8 8.87601 7.27243 10.1872 6.18717 11.2724 4.87601 12ZM17.25 14C17.25 15.7949 15.7949 17.25 14 17.25V18.75C15.7949 18.75 17.25 20.2051 17.25 22H18.75C18.75 20.2051 20.2051 18.75 22 18.75V17.25C20.2051 17.25 18.75 15.7949 18.75 14H17.25Z" })), Ol = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 18H21V6H3V18ZM1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10ZM11 10C11 11.6569 9.65685 13 8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10ZM8.0018 16C7.03503 16 6.1614 16.3907 5.52693 17.0251L4.11272 15.6109C5.10693 14.6167 6.4833 14 8.0018 14C9.52031 14 10.8967 14.6167 11.8909 15.6109L10.4767 17.0251C9.84221 16.3907 8.96858 16 8.0018 16ZM17.7929 8.79289L16 10.5858L14.2071 8.79289L12.7929 10.2071L14.5858 12L12.7929 13.7929L14.2071 15.2071L16 13.4142L17.7929 15.2071L19.2071 13.7929L17.4142 12L19.2071 10.2071L17.7929 8.79289Z" })), Tl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 18H21V6H3V18ZM1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5V19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19V5ZM9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10ZM11 10C11 11.6569 9.65685 13 8 13C6.34315 13 5 11.6569 5 10C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10ZM8.0018 16C7.03503 16 6.1614 16.3907 5.52693 17.0251L4.11272 15.6109C5.10693 14.6167 6.4833 14 8.0018 14C9.52031 14 10.8967 14.6167 11.8909 15.6109L10.4767 17.0251C9.84221 16.3907 8.96858 16 8.0018 16ZM16.2071 14.7071L20.2071 10.7071L18.7929 9.29289L15.5 12.5858L13.7071 10.7929L12.2929 12.2071L14.7929 14.7071L15.5 15.4142L16.2071 14.7071Z" })), Pl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8.5 7C9.32843 7 10 6.32843 10 5.5C10 4.67157 9.32843 4 8.5 4C7.67157 4 7 4.67157 7 5.5C7 6.32843 7.67157 7 8.5 7ZM8.5 13.5C9.32843 13.5 10 12.8284 10 12C10 11.1716 9.32843 10.5 8.5 10.5C7.67157 10.5 7 11.1716 7 12C7 12.8284 7.67157 13.5 8.5 13.5ZM10 18.5C10 19.3284 9.32843 20 8.5 20C7.67157 20 7 19.3284 7 18.5C7 17.6716 7.67157 17 8.5 17C9.32843 17 10 17.6716 10 18.5ZM15.5 7C16.3284 7 17 6.32843 17 5.5C17 4.67157 16.3284 4 15.5 4C14.6716 4 14 4.67157 14 5.5C14 6.32843 14.6716 7 15.5 7ZM17 12C17 12.8284 16.3284 13.5 15.5 13.5C14.6716 13.5 14 12.8284 14 12C14 11.1716 14.6716 10.5 15.5 10.5C16.3284 10.5 17 11.1716 17 12ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z" })), Wl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8.00008 6V9H5.00008V6H8.00008ZM3.00008 4V11H10.0001V4H3.00008ZM13.0001 4H21.0001V6H13.0001V4ZM13.0001 11H21.0001V13H13.0001V11ZM13.0001 18H21.0001V20H13.0001V18ZM10.7072 16.2071L9.29297 14.7929L6.00008 18.0858L4.20718 16.2929L2.79297 17.7071L6.00008 20.9142L10.7072 16.2071Z" })), kl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5.75024 3.5H4.71733L3.25 3.89317V5.44582L4.25002 5.17782L4.25018 8.5H3V10H7V8.5H5.75024V3.5ZM10 4H21V6H10V4ZM10 11H21V13H10V11ZM10 18H21V20H10V18ZM2.875 15.625C2.875 14.4514 3.82639 13.5 5 13.5C6.17361 13.5 7.125 14.4514 7.125 15.625C7.125 16.1106 6.96183 16.5587 6.68747 16.9167L6.68271 16.9229L5.31587 18.5H7V20H3.00012L2.99959 18.8786L5.4717 16.035C5.5673 15.9252 5.625 15.7821 5.625 15.625C5.625 15.2798 5.34518 15 5 15C4.67378 15 4.40573 15.2501 4.37747 15.5688L4.3651 15.875H2.875V15.625Z" })), Xl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M7.0943 5.68009L18.3199 16.9057C19.3736 15.5506 20 13.8491 20 12C20 7.58172 16.4183 4 12 4C10.1509 4 8.44939 4.62644 7.0943 5.68009ZM16.9057 18.3199L5.68009 7.0943C4.62644 8.44939 4 10.1509 4 12C4 16.4183 7.58172 20 12 20C13.8491 20 15.5506 19.3736 16.9057 18.3199ZM4.92893 4.92893C6.73748 3.12038 9.23885 2 12 2C17.5228 2 22 6.47715 22 12C22 14.7611 20.8796 17.2625 19.0711 19.0711C17.2625 20.8796 14.7611 22 12 22C6.47715 22 2 17.5228 2 12C2 9.23885 3.12038 6.73748 4.92893 4.92893Z" })), zl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21 4H3V6H21V4ZM21 11H8V13H21V11ZM21 18H8V20H21V18ZM5 11H3V20H5V11Z" })), Yl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" })), jl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11.9998 1L18 11H6L11.9998 1ZM13 13.5H21V21.5H13V13.5ZM6.75 22C9.37335 22 11.5 19.8734 11.5 17.25C11.5 14.6266 9.37335 12.5 6.75 12.5C4.12665 12.5 2 14.6266 2 17.25C2 19.8734 4.12665 22 6.75 22Z" })), Jl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z" })), _l = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 5V19H19V5H5Z" })), Ul = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5 7C5 6.17157 5.67157 5.5 6.5 5.5C7.32843 5.5 8 6.17157 8 7C8 7.82843 7.32843 8.5 6.5 8.5C5.67157 8.5 5 7.82843 5 7ZM6.5 3.5C4.567 3.5 3 5.067 3 7C3 8.933 4.567 10.5 6.5 10.5C8.433 10.5 10 8.933 10 7C10 5.067 8.433 3.5 6.5 3.5ZM12 8H20V6H12V8ZM16 17C16 16.1716 16.6716 15.5 17.5 15.5C18.3284 15.5 19 16.1716 19 17C19 17.8284 18.3284 18.5 17.5 18.5C16.6716 18.5 16 17.8284 16 17ZM17.5 13.5C15.567 13.5 14 15.067 14 17C14 18.933 15.567 20.5 17.5 20.5C19.433 20.5 21 18.933 21 17C21 15.067 19.433 13.5 17.5 13.5ZM4 16V18H12V16H4Z" })), $l = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11 1V2H7C5.34315 2 4 3.34315 4 5V8C4 10.7614 6.23858 13 9 13H15C17.7614 13 20 10.7614 20 8V5C20 3.34315 18.6569 2 17 2H13V1H11ZM6 5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V8C18 9.65685 16.6569 11 15 11H9C7.34315 11 6 9.65685 6 8V5ZM9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9ZM14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5C13 8.32843 13.6716 9 14.5 9ZM6 22C6 18.6863 8.68629 16 12 16C15.3137 16 18 18.6863 18 22H20C20 17.5817 16.4183 14 12 14C7.58172 14 4 17.5817 4 22H6Z" })), Ql = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3ZM12 16C10.3431 16 9 14.6569 9 13H4V5H20V13H15C15 14.6569 13.6569 16 12 16ZM16 11H13V14H11V11H8L12 6.5L16 11Z" })), Kl = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H10V19H4V5H9.58579L11.5858 7H20V11H22V6C22 5.44772 21.5523 5 21 5H12.4142L10.4142 3H3ZM12 18.25C12 16.9907 12.8465 15.9291 14.0015 15.6031C13.9452 13.6578 15.5523 12 17.5 12C19.4477 12 21.0548 13.6578 20.9985 15.6031C22.1535 15.9291 23 16.9907 23 18.25C23 19.7688 21.7688 21 20.25 21H14.75C13.2312 21 12 19.7688 12 18.25ZM17.5 14C16.6716 14 16 14.6716 16 15.5C16 15.9637 16.0239 16.4751 16.0569 16.9605C15.0926 17.1654 14 17.5516 14 18.25C14 18.6642 14.3358 19 14.75 19H20.25C20.6642 19 21 18.6642 21 18.25C21 17.5516 19.9074 17.1654 18.9431 16.9605C18.9761 16.4751 19 15.9637 19 15.5C19 14.6716 18.3284 14 17.5 14Z" })), ql = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12.5002 2C12.2241 2 12.0002 2.22386 12.0002 2.5V12H10.0002V4.5C10.0002 4.22386 9.77634 4 9.5002 4C9.22405 4 9.0002 4.22386 9.0002 4.5V14C8.64653 14 7.00024 14 7.00024 14C6.61911 12.3792 5.64236 11.4407 4.5954 11.3216C4.87926 12.0664 5.36117 13.2592 6.16634 15.0995C7.02511 17.0622 7.89128 18.5218 9.00374 19.4986C10.0783 20.442 11.4586 21 13.5002 21C16.5378 21 19.0002 18.5377 19.0002 15.5002V7C19.0002 6.72386 18.7763 6.5 18.5002 6.5C18.2241 6.5 18.0002 6.72386 18.0002 7V12H16.0002V4C16.0002 3.72386 15.7763 3.5 15.5002 3.5C15.2241 3.5 15.0002 3.72386 15.0002 4V12H13.0002V2.5C13.0002 2.22386 12.7763 2 12.5002 2ZM21.0002 15.5002C21.0002 19.6424 17.6423 23 13.5002 23C11.0417 23 9.17214 22.308 7.68416 21.0015C6.23411 19.7283 5.22528 17.9381 4.33405 15.9012C3.40393 13.7753 2.89004 12.4804 2.60991 11.7235C2.25318 10.7597 2.74616 9.41212 4.08583 9.31846C5.24076 9.23771 6.22061 9.61249 7.0002 10.2587V4.5C7.0002 3.11929 8.11949 2 9.5002 2C9.68522 2 9.86554 2.0201 10.0391 2.05823C10.2477 0.888227 11.2702 0 12.5002 0C13.5602 0 14.4661 0.659694 14.8298 1.59091C15.0431 1.53167 15.268 1.5 15.5002 1.5C16.8809 1.5 18.0002 2.61929 18.0002 4V4.55001C18.1618 4.51722 18.329 4.5 18.5002 4.5C19.8809 4.5 21.0002 5.61929 21.0002 7V15.5002Z" })), e2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M21 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3ZM12 16C10.3431 16 9 14.6569 9 13H4V5H20V13H15C15 14.6569 13.6569 16 12 16ZM16 9H13V6H11V9H8L12 13.5L16 9Z" })), t2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 9.5C12.8284 9.5 13.5 8.82843 13.5 8C13.5 7.17157 12.8284 6.5 12 6.5C11.1716 6.5 10.5 7.17157 10.5 8C10.5 8.82843 11.1716 9.5 12 9.5ZM14 15H13V10.5H10V12.5H11V15H10V17H14V15Z" })), n2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8 4C8 2.34315 9.34315 1 11 1C12.6569 1 14 2.34315 14 4C14 4.35064 13.9398 4.68722 13.8293 5H20C20.5523 5 21 5.44772 21 6V9.12602C21 9.43517 20.857 9.72694 20.6127 9.91635C20.3683 10.1058 20.0501 10.1715 19.7507 10.0945C19.5119 10.033 19.2605 10 19 10C17.3431 10 16 11.3431 16 13C16 14.6569 17.3431 16 19 16C19.2605 16 19.5119 15.967 19.7507 15.9055C20.0501 15.8285 20.3683 15.8942 20.6127 16.0836C20.857 16.2731 21 16.5648 21 16.874V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V6C3 5.44772 3.44772 5 4 5H8.17071C8.06015 4.68722 8 4.35064 8 4Z" })), r2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M7 5C7 2.79086 8.79086 1 11 1C13.2091 1 15 2.79086 15 5H20C20.5523 5 21 5.44772 21 6V10.1707C21 10.4953 20.8424 10.7997 20.5774 10.9872C20.3123 11.1746 19.9728 11.2217 19.6668 11.1135C19.4595 11.0403 19.2355 11 19 11C17.8954 11 17 11.8954 17 13C17 14.1046 17.8954 15 19 15C19.2355 15 19.4595 14.9597 19.6668 14.8865C19.9728 14.7783 20.3123 14.8254 20.5774 15.0128C20.8424 15.2003 21 15.5047 21 15.8293V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V6C3 5.44772 3.44772 5 4 5H7ZM11 3C9.89543 3 9 3.89543 9 5C9 5.23554 9.0403 5.45952 9.11355 5.66675C9.22172 5.97282 9.17461 6.31235 8.98718 6.57739C8.79974 6.84243 8.49532 7 8.17071 7H5V19H19V17C16.7909 17 15 15.2091 15 13C15 10.7909 16.7909 9 19 9V7H13.8293C13.5047 7 13.2003 6.84243 13.0128 6.57739C12.8254 6.31235 12.7783 5.97282 12.8865 5.66675C12.9597 5.45952 13 5.23555 13 5C13 3.89543 12.1046 3 11 3Z" })), i2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8 4C8 2.34315 9.34315 1 11 1C12.6569 1 14 2.34315 14 4C14 4.35064 13.9398 4.68722 13.8293 5H18C18.5523 5 19 5.44772 19 6V10.1707C19.3128 10.0602 19.6494 10 20 10C21.6569 10 23 11.3431 23 13C23 14.6569 21.6569 16 20 16C19.6494 16 19.3128 15.9398 19 15.8293V20C19 20.5523 18.5523 21 18 21H4C3.44772 21 3 20.5523 3 20V6C3 5.44772 3.44772 5 4 5H8.17071C8.06015 4.68722 8 4.35064 8 4Z" })), a2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M17.2073 2.29291L15.793 3.70712L18.0859 6.00002H13.0002V8.00001H18.0859L15.793 10.2929L17.2073 11.7071L21.9144 7.00001L17.2073 2.29291ZM9.50015 7.00001C9.50015 5.6193 8.38086 4.50001 7.00015 4.50001C5.61944 4.50001 4.50015 5.6193 4.50015 7.00001C4.50015 8.38073 5.61944 9.50001 7.00015 9.50001C8.38086 9.50001 9.50015 8.38073 9.50015 7.00001ZM11.5002 7.00001C11.5002 9.4853 9.48543 11.5 7.00015 11.5C4.51487 11.5 2.50015 9.4853 2.50015 7.00001C2.50015 4.51473 4.51487 2.50001 7.00015 2.50001C9.48543 2.50001 11.5002 4.51473 11.5002 7.00001ZM5.91436 18L8.20726 20.2929L6.79304 21.7071L2.08594 17L6.79304 12.2929L8.20726 13.7071L5.91436 16H11.0002V18H5.91436ZM15.0002 19H19.0002V15H15.0002V19ZM13.0002 14C13.0002 13.4477 13.4479 13 14.0002 13H20.0002C20.5524 13 21.0002 13.4477 21.0002 14V20C21.0002 20.5523 20.5524 21 20.0002 21H14.0002C13.4479 21 13.0002 20.5523 13.0002 20V14Z" })), o2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4ZM4 5V19H20V5H4ZM7 8H17V11H15V10H13V14H14.5V16H9.5V14H11V10H9V11H7V8Z" })), s2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H3ZM4 19V5H20V19H4ZM14 7H6V9H14V7ZM18 15V17H10V15H18ZM16 11H8V13H16V11Z" })), l2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z" })), c2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M9.00008 4.00008H11.0001V11.0001H4.00008V9.00008H7.58586L3.29297 4.70718L4.70718 3.29297L9.00008 7.58586V4.00008ZM20 15H16.4142L20.7071 19.2929L19.2929 20.7071L15 16.4142V20H13V13H20V15Z" })), u2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M6.41421 5H10V3H3V10H5V6.41421L9.29289 10.7071L10.7071 9.29289L6.41421 5ZM21 14H19V17.5858L14.7071 13.2929L13.2929 14.7071L17.5858 19H14V21H21V14Z" })), d2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11 2V22H13V2H11ZM2 6C2 4.89543 2.89543 4 4 4H7C8.10457 4 9 4.89543 9 6V18C9 19.1046 8.10457 20 7 20H4C2.89543 20 2 19.1046 2 18V6ZM20 6V18H17V6H20ZM17 4C15.8954 4 15 4.89543 15 6V18C15 19.1046 15.8954 20 17 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H17Z" })), f2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8.5 7C8.5 8.10457 7.60457 9 6.5 9C5.39543 9 4.5 8.10457 4.5 7C4.5 5.89543 5.39543 5 6.5 5C7.60457 5 8.5 5.89543 8.5 7ZM2.5 7C2.5 9.20914 4.29086 11 6.5 11C8.70914 11 10.5 9.20914 10.5 7C10.5 4.79086 8.70914 3 6.5 3C4.29086 3 2.5 4.79086 2.5 7ZM9 16.5C9 15.1193 7.88071 14 6.5 14C5.11929 14 4 15.1193 4 16.5V19H9V16.5ZM11 21H2V16.5C2 14.0147 4.01472 12 6.5 12C8.98528 12 11 14.0147 11 16.5V21ZM19.5 7C19.5 8.10457 18.6046 9 17.5 9C16.3954 9 15.5 8.10457 15.5 7C15.5 5.89543 16.3954 5 17.5 5C18.6046 5 19.5 5.89543 19.5 7ZM13.5 7C13.5 9.20914 15.2909 11 17.5 11C19.7091 11 21.5 9.20914 21.5 7C21.5 4.79086 19.7091 3 17.5 3C15.2909 3 13.5 4.79086 13.5 7ZM20 16.5C20 15.1193 18.8807 14 17.5 14C16.1193 14 15 15.1193 15 16.5V19H20V16.5ZM13 19V16.5C13 14.0147 15.0147 12 17.5 12C19.9853 12 22 14.0147 22 16.5V21H13V19Z" })), m2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M5 19H19V5H5V19ZM3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4ZM15 7V17H17V7H15ZM11 7L11 17H13V7H11ZM7 17L7 7L9 7L9 17H7Z" })), g2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M8.86874 14.1392C8.6556 14.4912 8.55014 14.7778 8.72043 15.2253C9.1905 16.4613 8.52737 17.664 7.28097 17.9905C6.10556 18.2985 4.96035 17.526 4.72713 16.2676C4.52048 15.1537 5.38488 14.0617 6.61294 13.8877C6.67963 13.8781 6.74717 13.874 6.83351 13.8688C6.88044 13.866 6.93293 13.8628 6.99384 13.8582L8.86194 10.7257C7.687 9.55742 6.98767 8.19164 7.14246 6.49936C7.25188 5.30308 7.72226 4.26933 8.58208 3.42201C10.2288 1.79945 12.7411 1.53667 14.68 2.78212C16.5423 3.97841 17.3951 6.30867 16.6681 8.30311L14.9611 7.84C15.1895 6.73115 15.0206 5.73536 14.2727 4.88234C13.7786 4.31914 13.1446 4.02394 12.4236 3.91516C10.9783 3.69681 9.55922 4.6254 9.13816 6.04399C8.66019 7.65406 9.38355 8.96924 11.3603 9.96029C10.5311 11.3541 9.70859 12.7518 8.86874 14.1392ZM13.7838 8.27337C14.3816 9.32798 14.9886 10.3986 15.5902 11.4593C18.631 10.5186 20.9237 12.2018 21.7462 14.004C22.7396 16.1809 22.0605 18.7593 20.1094 20.1023C18.1067 21.481 15.5741 21.2454 13.7997 19.4744L15.1919 18.3094C16.9444 19.4445 18.4772 19.3911 19.6151 18.047C20.5855 16.9003 20.5644 15.1906 19.5659 14.068C18.4136 12.7726 16.8701 12.7331 15.0044 13.9767C14.2305 12.6037 13.443 11.2413 12.6936 9.85845C12.4409 9.39233 12.1618 9.12196 11.5923 9.0233C10.6411 8.85839 10.027 8.04157 9.99016 7.12642C9.95395 6.22138 10.4871 5.4033 11.3205 5.08455C12.146 4.7688 13.1148 5.02367 13.6701 5.72554C14.1239 6.29901 14.2681 6.94443 14.0293 7.65167C13.9843 7.7852 13.9304 7.91584 13.8713 8.05885C13.8431 8.12694 13.8138 8.19801 13.7838 8.27337ZM11.552 16.895H15.2126C15.2636 16.963 15.3113 17.0303 15.3579 17.0959C15.4551 17.233 15.5474 17.3632 15.6551 17.4788C16.4304 18.3077 17.7395 18.3489 18.5682 17.5795C19.4271 16.7821 19.466 15.4426 18.6544 14.6101C17.8602 13.7955 16.5029 13.7177 15.7655 14.5802C15.3176 15.1044 14.8586 15.166 14.2641 15.1567C12.7414 15.1332 11.2177 15.149 9.69524 15.149C9.79406 17.2909 8.98436 18.6255 7.37841 18.9424C5.80582 19.2528 4.3575 18.4504 3.84759 16.9864C3.26842 15.3229 3.98467 13.9925 6.05421 12.9366C5.89847 12.3725 5.74115 11.8016 5.58541 11.236C3.32977 11.7276 1.63749 13.916 1.8122 16.378C1.96652 18.5514 3.71968 20.4815 5.86369 20.8273C7.02819 21.0153 8.12233 20.82 9.13741 20.2442C10.4433 19.5032 11.2011 18.3381 11.552 16.895Z" })), h2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M13.5 12 18.4497 7.05029 19.864 8.46451 17.3284 11H23V13H17.3284L19.8615 15.5331 18.4473 16.9473 13.5 12ZM1 13H6.67084L4.13584 15.535 5.55005 16.9493 10.5 11.9996 5.55025 7.0498 4.13604 8.46402 6.67206 11H1V13Z" })), C2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11.9995 13.4995 16.9492 18.4493 15.535 19.8635 12.9995 17.3279 12.9995 22.9995H10.9995L10.9995 17.3279 8.46643 19.861 7.05222 18.4468 11.9995 13.4995ZM10.9995.999512 10.9995 6.67035 8.46448 4.13535 7.05026 5.54956 12 10.4995 16.9497 5.54977 15.5355 4.13555 12.9995 6.67157V.999512L10.9995.999512Z" })), b2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M0.5 12L5.44975 7.05029L6.86396 8.46451L4.32843 11H10V13H4.32843L6.86148 15.5331L5.44727 16.9473L0.5 12ZM14 13H19.6708L17.1358 15.535L18.55 16.9493L23.5 11.9996L18.5503 7.0498L17.136 8.46402L19.6721 11H14V13Z" })), p2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M11.9995 0.499512L16.9492 5.44926L15.535 6.86347L12.9995 4.32794V9.99951H10.9995L10.9995 4.32794L8.46643 6.86099L7.05222 5.44678L11.9995 0.499512ZM10.9995 13.9995L10.9995 19.6704L8.46448 17.1353L7.05026 18.5496L12 23.4995L16.9497 18.5498L15.5355 17.1356L12.9995 19.6716V13.9995H10.9995Z" })), v2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M22 12C22 17.5228 17.5229 22 12 22C6.4772 22 2 17.5228 2 12C2 6.47715 6.4772 2 12 2V4C7.5817 4 4 7.58172 4 12C4 16.4183 7.5817 20 12 20C16.4183 20 20 16.4183 20 12C20 9.25022 18.6127 6.82447 16.4998 5.38451L16.5 8H14.5V2L20.5 2V4L18.0008 3.99989C20.4293 5.82434 22 8.72873 22 12Z" })), w2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2V4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.25022 5.38734 6.82447 7.50024 5.38451L7.5 8H9.5V2L3.5 2V4L5.99918 3.99989C3.57075 5.82434 2 8.72873 2 12Z" })), x2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M15 3H21V21H3V15H7V11H11V7H15V3ZM17 5V9H13V13H9V17H5V19H19V5H17Z" })), y2 = ({ color: t = "currentColor", size: e = 24, className: n, ...r }) => c.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...r, className: "remixicon " + (n || "") }, c.createElement("path", { d: "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM5 19V5H19V19H5ZM17.6569 12L12 17.6568L10.5858 16.2426L13.8284 13H6.34315V11L13.8284 11L10.5858 7.75732L12 6.34311L17.6569 12Z" })), I2 = {
  RiAccountPinBoxFill: Ya,
  RiAddFill: ja,
  RiAlertFill: Ja,
  RiAlertLine: _a,
  RiAlignCenter: Ua,
  RiAlignJustify: $a,
  RiAlignLeft: Qa,
  RiAlignRight: Ka,
  RiArrowDownLine: qa,
  RiArrowDownSLine: eo,
  RiArrowDropRightLine: to,
  RiArrowGoBackLine: no,
  RiArrowLeftDoubleFill: Rl,
  RiArrowLeftLine: ro,
  RiArrowLeftRightFill: io,
  RiArrowLeftRightLine: ao,
  RiArrowLeftSLine: oo,
  RiArrowRightBoxLine: y2,
  RiArrowRightLine: so,
  RiArrowRightSLine: lo,
  RiArrowRightUpLine: co,
  RiArrowUpLine: uo,
  RiArrowUpSLine: fo,
  RiArticleLine: mo,
  RiAttachmentLine: ho,
  RiAttachment2: go,
  RiBillLine: Co,
  RiBold: bo,
  RiBookmarkLine: po,
  RiBracesLine: vo,
  RiBriefcase4Line: wo,
  RiCalculatorFill: xo,
  RiCalendar2Line: yo,
  RiCalendarLine: Io,
  RiCheckboxCircleLine: Eo,
  RiCheckboxCircleFill: Mo,
  RiCheckboxFill: No,
  RiCheckboxLine: Lo,
  RiCheckboxMultipleFill: Ao,
  RiCheckFill: Vo,
  RiCheckLine: Ho,
  RiCircleFill: Yl,
  RiCloseFill: Zo,
  RiCloseLargeLine: l2,
  RiCloseLine: Ro,
  RiCoinLine: So,
  RiCollapseDiagonal2Line: c2,
  RiCollapseHorizontalLine: h2,
  RiCollapseVerticalLine: C2,
  RiContractRightLine: Sl,
  RiContractLeftLine: Bl,
  RiCpuLine: Go,
  RiCursorFill: Do,
  RiDatabase2Line: Oo,
  RiDeleteBin6Fill: To,
  RiDeleteBinFill: Po,
  RiDeleteBinLine: Wo,
  RiDossierLine: ko,
  RiDownloadLine: Xo,
  RiDraggable: Pl,
  RiEdit2Fill: zo,
  RiEditCircleLine: Yo,
  RiEqualizer2Line: Ul,
  RiErrorWarningFill: jo,
  RiErrorWarningLine: Jo,
  RiExpandDiagonal2Line: u2,
  RiExpandHorizontalLine: b2,
  RiExpandVerticalLine: p2,
  RiExternalLinkLine: _o,
  RiEyeFill: Uo,
  RiEyeLine: $o,
  RiEyeOffFill: Qo,
  RiEyeOffLine: Ko,
  RiFileCopyFill: qo,
  RiFileLine: es,
  RiFilter3Line: ts,
  RiFlashlightFill: ns,
  RiFlashlightLine: rs,
  RiFlowChart: as,
  RiFocus3Line: os,
  RiFolderCloudLine: Kl,
  RiGitMergeLine: ls,
  RiGlobalLine: cs,
  RiGlobeLine: us,
  RiGroup3Line: f2,
  RiH1: ds,
  RiH2: fs,
  RiH3: ms,
  RiH4: gs,
  RiH5: hs,
  RiH6: Cs,
  RiHeading: ps,
  RiHashtag: bs,
  RiHealthBookFill: vs,
  RiHeartPulseLine: ws,
  RiHistoryLine: xs,
  RiHomeLine: ys,
  RiInformation2Fill: t2,
  RiInformationLine: Is,
  RiItalic: Vs,
  RiNotification2Line: Os,
  RiNotification2Fill: Fs,
  RiLayout3Line: Hs,
  RiLifebuoyLine: Ms,
  RiLineChartLine: Es,
  RiListCheck: As,
  RiListCheck3: Wl,
  RiListOrdered2: kl,
  RiLockLine: Zs,
  RiLogoutBoxRLine: Rs,
  RiMailLine: Bs,
  RiMessage3Fill: Ss,
  RiMore2Line: Gs,
  RiNodeTree: Ds,
  RiPassExpiredLine: Ol,
  RiPassValidLine: Tl,
  RiPhoneFill: Ps,
  RiPhoneLine: Ws,
  RiPlayFill: ks,
  RiPriceTag3Fill: Xs,
  RiProfileLine: zs,
  RiPulseFill: Ys,
  RiPuzzleFill: i2,
  RiPuzzle2Fill: n2,
  RiPuzzle2Line: r2,
  RiQuestionFill: Js,
  RiQuestionLine: _s,
  RiQuoteText: zl,
  RiRadioButtonLine: Us,
  RiRefreshLine: $s,
  RiResetLeftLine: v2,
  RiResetRightLine: w2,
  RiRocket2Line: Qs,
  RiSaveLine: Ks,
  RiSearchLine: qs,
  RiServerLine: el,
  RiSettings4Line: tl,
  RiShareLine: nl,
  RiSkipForwardLine: il,
  RiSparklingFill: Dl,
  RiSparklingLine: Fl,
  RiSquareFill: Jl,
  RiSquareLine: _l,
  RiStairsLine: x2,
  RiStethoscopeLine: al,
  RiStickyNote2Fill: ol,
  RiStrikethrough: ll,
  RiStopCircleFill: sl,
  RiSubtractFill: cl,
  RiSurveyFill: ul,
  RiTerminalBoxFill: dl,
  RiTerminalWindowFill: fl,
  RiTestTubeFill: ml,
  RiTestTubeLine: gl,
  RiText: hl,
  RiTextSnippet: o2,
  RiTimerLine: yl,
  RiTimeFill: wl,
  RiTimeLine: xl,
  RiThumbDownFill: Cl,
  RiThumbDownLine: bl,
  RiThumbUpFill: pl,
  RiThumbUpLine: vl,
  RiToolsLine: Il,
  RiUnderline: Vl,
  RiUploadCloudFill: Hl,
  RiUploadLine: Ml,
  RiUserFill: El,
  RiUserLine: Nl,
  RiZoomInLine: Al,
  RiZoomOutLine: Zl,
  RiLinksLine: Ls,
  RiWebhookLine: g2,
  RiSwap2Line: a2,
  RiLink: Ns,
  RiHand: ql,
  RiDatabase2Fill: Fo,
  RiCodeFill: Bo,
  RiProhibitedLine: Xl,
  RiExportFill: Ql,
  RiImportFill: e2,
  RiFolder5Fill: ss,
  RiShapesFill: jl,
  RiPencilFill: Ts,
  RiWindowLine: Ll,
  RiShieldUserLine: rl,
  RiCopilotFill: Gl,
  RiRobot3Line: $l,
  RiFlaskLine: is,
  RiQrCodeLine: js,
  RiTimelineView: s2,
  RiLayoutVerticalLine: m2,
  RiFlipHorizontalLine: d2
};
var pn = /* @__PURE__ */ ((t) => (t[t.xxs = 12] = "xxs", t[t.xs = 16] = "xs", t[t.s = 20] = "s", t[t.m = 24] = "m", t[t.l = 28] = "l", t[t.xl = 32] = "xl", t))(pn || {});
const Ae = (t) => {
  const {
    icon: e,
    color: n = "default",
    className: r = "inline",
    size: i = pn.m,
    onClick: a = void 0
  } = t, o = I2[e];
  return /* @__PURE__ */ m.jsx(o, { size: i, color: n, className: r, onClick: a });
};
var Qe = /* @__PURE__ */ ((t) => (t.ApiCall = "API_CALL", t.ApiCallGraphql = "API_CALL_GRAPHQL", t.Calculation = "CALCULATION", t.Checklist = "CHECKLIST", t.ClinicalNote = "CLINICAL_NOTE", t.Form = "FORM", t.Message = "MESSAGE", t.Plugin = "PLUGIN", t.PushToEmr = "PUSH_TO_EMR", t))(Qe || {});
const V2 = A.forwardRef(({ ...t }, e) => {
  const n = {
    [Qe.ApiCall]: "RiTerminalBoxFill",
    [Qe.ApiCallGraphql]: "RiTerminalWindowFill",
    [Qe.Calculation]: "RiCalculatorFill",
    [Qe.Checklist]: "RiCheckboxMultipleFill",
    [Qe.ClinicalNote]: "RiHealthBookFill",
    [Qe.Form]: "RiSurveyFill",
    [Qe.Message]: "RiMessage3Fill",
    [Qe.Plugin]: "RiUploadCloudFill",
    [Qe.PushToEmr]: "RiUploadCloudFill"
  }, { icon_url: r, actionType: i, size: a = "sm" } = t, o = n[i] ?? "RiQuestionFill", s = o === "RiQuestionFill" ? "fill-slate-400" : "fill-slate-800", l = {
    sm: { icon: "w-4 h-4", container: "w-6 h-6" },
    lg: { icon: "w-6 h-6", container: "w-9 h-9" },
    xl: { icon: "w-8 h-8", container: "w-12 h-12" }
  }, u = l[a].icon, d = l[a].container;
  return i === Qe.Plugin && r ? /* @__PURE__ */ m.jsx("img", { className: `${d} rounded-md border border-slate-200`, src: r }) : /* @__PURE__ */ m.jsx(
    "div",
    {
      ref: e,
      className: `${d} flex bg-slate-100 rounded-md border border-slate-200 items-center justify-center`,
      children: /* @__PURE__ */ m.jsx(Ae, { icon: o, className: N(`${u}`, s) })
    }
  );
});
V2.displayName = "ActionIcon";
const H2 = tt("btn", {
  variants: {
    size: {
      sm: "btn-sm rounded-md px-3.5 py-2",
      lg: "btn-lg rounded-lg px-[18px] py-2.5 h-[46px]"
    },
    shape: {
      squareLg: "btn-square w-[46px] h-[46px] min-h-[46px] min-w-[46px] rounded-lg",
      squareSm: "btn-square w-8 h-8 min-w-8 min-h-8 rounded-md"
    },
    variant: {
      primary: "btn-primary hover:bg-blue-800 hover:border-blue-800 active:bg-blue-800 active:border-blue-800 disabled:bg-slate-200 disabled:border-slate-200 disabled:text-white",
      secondaryBlue: "text-blue-700 bg-blue-50 border-blue-200 hover:bg-blue-100 hover:border-blue-300 active:bg-blue-100 active:border-blue-300 disabled:bg-blue-50 disabled:border-blue-200 disabled:text-blue-200 outline-blue-500",
      secondary: "btn-secondary bg-white border-slate-300 hover:bg-slate-100 active:bg-slate-100 disabled:text-slate-200 disabled:border-slate-200 disabled:bg-white",
      link: "text-blue-700 text-sm bg-transparent border-none shadow-none hover:bg-transparent active:bg-transparent disabled:text-blue-200 disabled:bg-transparent outline-blue-700",
      ghost: "btn-ghost text-slate-600 hover:bg-slate-100 active:bg-slate-100 disabled:text-slate-200 disabled:bg-transparent outline-slate-300",
      error: "btn-error",
      success: "btn-success",
      warning: "btn-warning"
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "sm"
  }
}), ut = A.forwardRef(
  // eslint-disable-next-line
  ({ className: t, variant: e, size: n, shape: r, disabled: i = !1, ...a }, o) => /* @__PURE__ */ m.jsx(
    "button",
    {
      className: N(H2({ variant: e, size: n, shape: r, className: t })),
      ref: o,
      ...a,
      disabled: i
    }
  )
);
ut.displayName = "Button";
const W9 = (t) => {
  const { title: e, icon: n, text: r, button: i, children: a = null, onClose: o, secondaryButton: s, className: l } = t;
  return /* @__PURE__ */ m.jsxs(
    "div",
    {
      className: N("relative z-[9999]", l),
      "aria-labelledby": "modal-title",
      role: "dialog",
      "aria-modal": "true",
      children: [
        /* @__PURE__ */ m.jsx("div", { className: "fixed inset-0 bg-slate-700 bg-opacity-30 transition-opacity z-[9999]" }),
        /* @__PURE__ */ m.jsx("div", { className: "fixed inset-0 z-[9999] w-screen overflow-y-auto", children: /* @__PURE__ */ m.jsx("div", { className: "flex min-h-full items-center justify-center p-4 sm:items-center sm:p-0", children: /* @__PURE__ */ m.jsxs("div", { className: "relative transform overflow-hidden transition-all sm:my-8 sm:w-full sm:max-w-lg p-6 bg-white rounded-lg shadow", children: [
          /* @__PURE__ */ m.jsxs("div", { className: "flex flex-row", style: { gap: "20px" }, children: [
            o && /* @__PURE__ */ m.jsx(
              "div",
              {
                className: "absolute top-0 right-0 p-4 cursor-pointer text-slate-950",
                onClick: o,
                "data-testid": "close-handler",
                children: /* @__PURE__ */ m.jsx(Ae, { icon: "RiCloseLine" })
              }
            ),
            /* @__PURE__ */ m.jsxs("div", { className: "flex gap-5", children: [
              n && /* @__PURE__ */ m.jsx("div", { children: n }),
              /* @__PURE__ */ m.jsx("div", { children: /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col", children: [
                e && /* @__PURE__ */ m.jsx(
                  "h3",
                  {
                    className: "text-gray-900 text-lg text-gray-900 leading-7",
                    id: "modal-title",
                    children: e
                  }
                ),
                r && /* @__PURE__ */ m.jsx("div", { className: "mt-2", children: /* @__PURE__ */ m.jsx("p", { className: "text-gray-500 text-sm", children: r }) })
              ] }) })
            ] })
          ] }),
          a && /* @__PURE__ */ m.jsx("div", { children: a }),
          (i || s) && /* @__PURE__ */ m.jsxs(
            "div",
            {
              className: "flex justify-end pt-[32px] gap-3 items-center",
              style: { gap: "12px" },
              children: [
                s && /* @__PURE__ */ m.jsx(
                  ut,
                  {
                    type: "button",
                    variant: (s == null ? void 0 : s.buttonVariant) ?? "secondary",
                    onClick: s == null ? void 0 : s.buttonAction,
                    disabled: s == null ? void 0 : s.disabled,
                    children: s == null ? void 0 : s.label
                  }
                ),
                i && /* @__PURE__ */ m.jsx(
                  ut,
                  {
                    type: "button",
                    variant: (i == null ? void 0 : i.buttonVariant) ?? "primary",
                    onClick: i == null ? void 0 : i.buttonAction,
                    disabled: i == null ? void 0 : i.disabled,
                    children: i.label
                  }
                )
              ]
            }
          )
        ] }) }) })
      ]
    }
  );
}, M2 = tt("alert p-4 rounded-lg border gap-3 text-sm", {
  variants: {
    variant: {
      default: "bg-slate-50 border-slate-300 text-slate-600 [&h3]:text-slate-700",
      primary: "bg-blue-50 border-blue-300 text-blue-700 [&h3]:text-blue-800",
      warning: "bg-yellow-50 border-yellow-300 text-yellow-600 [&h3]:text-yellow-700",
      error: "bg-red-50 border-red-300 text-red-600 [&h3]:text-red-700"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), E2 = A.forwardRef(
  ({ className: t, variant: e, title: n, children: r, showIcon: i = !1, titleClassName: a = "", ...o }, s) => {
    const l = e === "error" || e === "warning" ? "RiAlertLine" : "RiInformationLine", u = N({
      "fill-slate-500": e === "default",
      "fill-blue-500": e === "primary",
      "fill-yellow-500": e === "warning",
      "fill-red-500": e === "error"
    });
    return /* @__PURE__ */ m.jsxs("div", { role: "alert", ref: s, className: N(M2({ variant: e }), t), ...o, children: [
      /* @__PURE__ */ m.jsx("div", { className: "flex self-start pt-0.5", children: i && /* @__PURE__ */ m.jsx(Ae, { icon: l, size: 16, className: u }) }),
      /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ m.jsx("h3", { className: N("font-medium", a), children: n }),
        r && /* @__PURE__ */ m.jsx("div", { className: "font-normal", children: r })
      ] })
    ] });
  }
);
E2.displayName = "Alert";
const nr = tt("", {
  variants: {
    variant: {
      circle: "rounded-full",
      square: "rounded-md"
    },
    size: {
      xs: "w-8",
      sm: "w-16",
      md: "w-20",
      lg: "w-32"
    }
  },
  defaultVariants: {
    variant: "circle",
    size: "sm"
  }
});
function k9({
  src: t,
  className: e,
  variant: n,
  size: r,
  placeholder: i = !1,
  text: a,
  ...o
}) {
  return /* @__PURE__ */ m.jsxs("div", { className: N("avatar", { placeholder: i }), children: [
    !i && /* @__PURE__ */ m.jsx("div", { className: N(nr({ variant: n, size: r }), e), ...o, children: /* @__PURE__ */ m.jsx("img", { src: t }) }),
    i && /* @__PURE__ */ m.jsx(
      "div",
      {
        className: N(
          "bg-neutral text-neutral-content w-24 rounded-full",
          nr({ size: r }),
          e
        ),
        ...o,
        children: /* @__PURE__ */ m.jsx(
          "span",
          {
            className: N({
              "text-xs": r === "xs",
              "text-sm": r === "sm",
              "text-xl": r === "md",
              "text-3xl": r === "lg"
            }),
            children: a
          }
        )
      }
    )
  ] });
}
const N2 = tt(
  "badge rounded-2xl inline-flex items-center justify-center overflow-hidden max-w-full min-w-0",
  {
    variants: {
      variant: {
        default: "bg-slate-100 text-slate-800 border-slate-100",
        primary: "bg-blue-100 text-blue-800 border-blue-100",
        error: "bg-red-100 text-red-800 border-red-100",
        warning: "bg-orange-100 text-orange-800 border-orange-100",
        success: "bg-green-100 text-green-800 border-green-100",
        yellow: "bg-yellow-100 text-yellow-800 border-yellow-100",
        lime: "bg-lime-100 text-lime-800 border-lime-100",
        cyan: "bg-cyan-100 text-cyan-800 border-cyan-100",
        teal: "bg-teal-100 text-teal-800 border-teal-100",
        violet: "bg-violet-100 text-violet-800 border-violet-100",
        pink: "bg-pink-100 text-pink-800 border-pink-100"
      },
      size: {
        sm: "badge-sm p-2 text-xs",
        lg: "badge-lg p-3 text-sm"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "sm"
    }
  }
);
function X9({ className: t, variant: e, size: n, children: r, ...i }) {
  return /* @__PURE__ */ m.jsx("div", { className: N(N2({ variant: e, size: n }), t), ...i, children: /* @__PURE__ */ m.jsx("span", { className: "flex gap-1 truncate px-1", children: r }) });
}
const L2 = A.forwardRef(({ className: t, children: e, ...n }, r) => /* @__PURE__ */ m.jsx("div", { ref: r, className: N("rounded-xl border shadow p-3", t), ...n, children: e }));
L2.displayName = "Card";
const z9 = ({
  text: t,
  children: e,
  copiedText: n,
  position: r = "inline",
  className: i,
  iconSize: a = pn.xxs
}) => {
  const [o, s] = $(!1);
  return Q(() => {
    if (o) {
      navigator.clipboard.writeText(t);
      const l = setTimeout(() => {
        s(!1);
      }, 2e3);
      return () => {
        clearTimeout(l);
      };
    }
  }, [o]), /* @__PURE__ */ m.jsxs(
    "span",
    {
      className: N(
        "group/copy-text relative cursor-pointer group-hover/copy-text:text-slate-800",
        {
          "flex items-center gap-1": r === "inline" || r === "right",
          "font-code": r === "inline"
        }
      ),
      onClick: () => s(!0),
      children: [
        e,
        /* @__PURE__ */ m.jsxs(
          "span",
          {
            className: N(
              "text-xs items-center gap-1 hidden group-hover/copy-text:flex",
              r === "right" && "hover:flex gap-1",
              r === "bottom" && "absolute",
              r === "overlay" && "absolute top-0 left-0 h-full bg-gray-200 opacity-95 rounded-md w-full px-2 py-0.5",
              r === "inline" && "flex items-center gap-1",
              i
            ),
            children: [
              !o && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
                /* @__PURE__ */ m.jsx(Ae, { icon: "RiFileCopyFill", className: " fill-slate-500", size: a }),
                r !== "inline" && /* @__PURE__ */ m.jsx("span", { className: "text-sm text-slate-600", children: "Click to copy" })
              ] }),
              o && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
                /* @__PURE__ */ m.jsx(Ae, { icon: "RiCheckFill", className: " fill-green-600", size: a }),
                r !== "inline" && /* @__PURE__ */ m.jsx("span", { className: "text-sm text-green-600", children: n ?? "Copied to clipboard" })
              ] })
            ]
          }
        )
      ]
    }
  );
}, A2 = A.forwardRef(({ ...t }, e) => {
  const n = {
    attachment: "RiAttachment2",
    attachments_array: "RiAttachment2",
    boolean: "RiCheckboxCircleLine",
    date: "RiCalendarLine",
    json: "RiBracesLine",
    number: "RiHashtag",
    numbers_array: "RiListOrdered2",
    string: "RiText",
    strings_array: "RiListCheck",
    telephone: "RiPhoneLine"
  }, { icon_url: r, dataPointValueType: i, size: a = "sm" } = t, o = n[i] ?? "RiQuestionFill", s = o === "RiQuestionFill" ? "fill-slate-400" : "fill-slate-800", l = {
    sm: { icon: "w-4 h-4", container: "w-6 h-6" },
    lg: { icon: "w-6 h-6", container: "w-9 h-9" },
    xl: { icon: "w-8 h-8", container: "w-12 h-12" }
  }, u = l[a].icon, d = l[a].container;
  return i === "attachment" && r ? /* @__PURE__ */ m.jsx("img", { className: `${d} rounded-md border border-slate-200`, src: r }) : /* @__PURE__ */ m.jsx(
    "div",
    {
      ref: e,
      className: `${d} flex bg-slate-100 rounded-md border border-slate-200 items-center justify-center`,
      children: /* @__PURE__ */ m.jsx(Ae, { icon: o, className: N(`${u}`, s) })
    }
  );
});
A2.displayName = "DataPointIcon";
var Z2 = function() {
};
function si(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  t && t.addEventListener && t.addEventListener.apply(t, e);
}
function li(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  t && t.removeEventListener && t.removeEventListener.apply(t, e);
}
var R2 = typeof window < "u", B2 = ["mousedown", "touchstart"], ci = function(t, e, n) {
  n === void 0 && (n = B2);
  var r = pe(e);
  Q(function() {
    r.current = e;
  }, [e]), Q(function() {
    for (var i = function(l) {
      var u = t.current;
      u && !u.contains(l.target) && r.current(l);
    }, a = 0, o = n; a < o.length; a++) {
      var s = o[a];
      si(document, s, i);
    }
    return function() {
      for (var l = 0, u = n; l < u.length; l++) {
        var d = u[l];
        li(document, d, i);
      }
    };
  }, [n, t]);
}, S2 = R2 ? window : null, rr = function(t) {
  return !!t.addEventListener;
}, ir = function(t) {
  return !!t.on;
}, G2 = function(t, e, n, r) {
  n === void 0 && (n = S2), Q(function() {
    if (e && n)
      return rr(n) ? si(n, t, e, r) : ir(n) && n.on(t, e, r), function() {
        rr(n) ? li(n, t, e, r) : ir(n) && n.off(t, e, r);
      };
  }, [t, e, n, JSON.stringify(r)]);
}, D2 = function(t) {
  return function(e) {
    return e.key === t;
  };
}, F2 = function(t, e, n, r) {
  e === void 0 && (e = Z2), n === void 0 && (n = {}), r === void 0 && (r = [t]);
  var i = n.event, a = i === void 0 ? "keydown" : i, o = n.target, s = n.options, l = lt(function() {
    var u = D2(t), d = function(f) {
      if (u(f))
        return e(f);
    };
    return d;
  }, r);
  G2(a, l, o, s);
}, G;
(function(t) {
  t.Root = "root", t.Chevron = "chevron", t.Day = "day", t.DayButton = "day_button", t.CaptionLabel = "caption_label", t.Dropdowns = "dropdowns", t.Dropdown = "dropdown", t.DropdownRoot = "dropdown_root", t.Footer = "footer", t.MonthGrid = "month_grid", t.MonthCaption = "month_caption", t.MonthsDropdown = "months_dropdown", t.Month = "month", t.Months = "months", t.Nav = "nav", t.NextMonthButton = "button_next", t.PreviousMonthButton = "button_previous", t.Week = "week", t.Weeks = "weeks", t.Weekday = "weekday", t.Weekdays = "weekdays", t.WeekNumber = "week_number", t.WeekNumberHeader = "week_number_header", t.YearsDropdown = "years_dropdown";
})(G || (G = {}));
var ge;
(function(t) {
  t.disabled = "disabled", t.hidden = "hidden", t.outside = "outside", t.focused = "focused", t.today = "today";
})(ge || (ge = {}));
var Ke;
(function(t) {
  t.range_end = "range_end", t.range_middle = "range_middle", t.range_start = "range_start", t.selected = "selected";
})(Ke || (Ke = {}));
const s1 = {}, gn = {};
function bn(t, e) {
  try {
    const r = (s1[t] || (s1[t] = new Intl.DateTimeFormat("en-GB", {
      timeZone: t,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(e).split("GMT")[1] || "";
    return r in gn ? gn[r] : ar(r, r.split(":"));
  } catch {
    if (t in gn) return gn[t];
    const n = t == null ? void 0 : t.match(O2);
    return n ? ar(t, n.slice(1)) : NaN;
  }
}
const O2 = /([+-]\d\d):?(\d\d)?/;
function ar(t, e) {
  const n = +e[0], r = +(e[1] || 0);
  return gn[t] = n > 0 ? n * 60 + r : n * 60 - r;
}
class ct extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(bn(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), ui(this), v1(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new ct(...n, e) : new ct(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new ct(+this, e);
  }
  getTimezoneOffset() {
    return -bn(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), v1(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new ct(+new Date(e), this.timeZone);
  }
  //#endregion
}
const or = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!or.test(t)) return;
  const e = t.replace(or, "$1UTC");
  ct.prototype[e] && (t.startsWith("get") ? ct.prototype[t] = function() {
    return this.internal[e]();
  } : (ct.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), T2(this), +this;
  }, ct.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), v1(this), +this;
  }));
});
function v1(t) {
  t.internal.setTime(+t), t.internal.setUTCMinutes(t.internal.getUTCMinutes() - t.getTimezoneOffset());
}
function T2(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), ui(t);
}
function ui(t) {
  const e = bn(t.timeZone, t), n = /* @__PURE__ */ new Date(+t);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), a = r - i, o = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  a && o && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + a);
  const s = r - e;
  s && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + s);
  const l = bn(t.timeZone, t), d = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - l, f = l !== e, p = d - s;
  if (f && p) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + p);
    const h = bn(t.timeZone, t), b = l - h;
    b && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + b), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + b));
  }
}
class Tt extends ct {
  //#region static
  static tz(e, ...n) {
    return n.length ? new Tt(...n, e) : new Tt(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, r] = this.tzComponents(), i = `${e}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, r, i] = this.internal.toUTCString().split(" ");
    return `${e == null ? void 0 : e.slice(0, -1)} ${r} ${n} ${i}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, r, i] = this.tzComponents();
    return `${e} GMT${n}${r}${i} (${P2(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", r = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), i = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, r, i];
  }
  //#endregion
  withTimeZone(e) {
    return new Tt(+this, e);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new Tt(+new Date(e), this.timeZone);
  }
  //#endregion
}
function P2(t, e) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: t,
    timeZoneName: "long"
  }).format(e).slice(12);
}
const di = 6048e5, W2 = 864e5, fi = 6e4, mi = 36e5, sr = Symbol.for("constructDateFrom");
function He(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && sr in t ? t[sr](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function le(t, e) {
  return He(e || t, t);
}
function gi(t, e, n) {
  const r = le(t, n == null ? void 0 : n.in);
  return isNaN(e) ? He(t, NaN) : (e && r.setDate(r.getDate() + e), r);
}
function hi(t, e, n) {
  const r = le(t, n == null ? void 0 : n.in);
  if (isNaN(e)) return He(t, NaN);
  if (!e)
    return r;
  const i = r.getDate(), a = He(t, r.getTime());
  a.setMonth(r.getMonth() + e + 1, 0);
  const o = a.getDate();
  return i >= o ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    i
  ), r);
}
let k2 = {};
function Hn() {
  return k2;
}
function Kt(t, e) {
  var s, l, u, d;
  const n = Hn(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, i = le(t, e == null ? void 0 : e.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function vn(t, e) {
  return Kt(t, { ...e, weekStartsOn: 1 });
}
function Ci(t, e) {
  const n = le(t, e == null ? void 0 : e.in), r = n.getFullYear(), i = He(n, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const a = vn(i), o = He(n, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const s = vn(o);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
function lr(t) {
  const e = le(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function rn(t, ...e) {
  const n = He.bind(
    null,
    e.find((r) => typeof r == "object")
  );
  return e.map(n);
}
function wn(t, e) {
  const n = le(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function bi(t, e, n) {
  const [r, i] = rn(
    n == null ? void 0 : n.in,
    t,
    e
  ), a = wn(r), o = wn(i), s = +a - lr(a), l = +o - lr(o);
  return Math.round((s - l) / W2);
}
function X2(t, e) {
  const n = Ci(t, e), r = He(t, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), vn(r);
}
function z2(t, e, n) {
  return gi(t, e * 7, n);
}
function Y2(t, e, n) {
  return hi(t, e * 12, n);
}
function j2(t, e) {
  let n, r = e == null ? void 0 : e.in;
  return t.forEach((i) => {
    !r && typeof i == "object" && (r = He.bind(null, i));
    const a = le(i, r);
    (!n || n < a || isNaN(+a)) && (n = a);
  }), He(r, n || NaN);
}
function J2(t, e) {
  let n, r = e == null ? void 0 : e.in;
  return t.forEach((i) => {
    !r && typeof i == "object" && (r = He.bind(null, i));
    const a = le(i, r);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), He(r, n || NaN);
}
function _2(t, e, n) {
  const [r, i] = rn(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return +wn(r) == +wn(i);
}
function pi(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function U2(t) {
  return !(!pi(t) && typeof t != "number" || isNaN(+le(t)));
}
function $2(t, e, n) {
  const [r, i] = rn(
    n == null ? void 0 : n.in,
    t,
    e
  ), a = r.getFullYear() - i.getFullYear(), o = r.getMonth() - i.getMonth();
  return a * 12 + o;
}
function Q2(t, e) {
  const n = le(t, e == null ? void 0 : e.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function K2(t, e) {
  const [n, r] = rn(t, e.start, e.end);
  return { start: n, end: r };
}
function q2(t, e) {
  const { start: n, end: r } = K2(e == null ? void 0 : e.in, t);
  let i = +n > +r;
  const a = i ? +n : +r, o = i ? r : n;
  o.setHours(0, 0, 0, 0), o.setDate(1);
  let s = 1;
  const l = [];
  for (; +o <= a; )
    l.push(He(n, o)), o.setMonth(o.getMonth() + s);
  return i ? l.reverse() : l;
}
function ec(t, e) {
  const n = le(t, e == null ? void 0 : e.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function tc(t, e) {
  const n = le(t, e == null ? void 0 : e.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function vi(t, e) {
  const n = le(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function wi(t, e) {
  var s, l, u, d;
  const n = Hn(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, i = le(t, e == null ? void 0 : e.in), a = i.getDay(), o = (a < r ? -7 : 0) + 6 - (a - r);
  return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
function nc(t, e) {
  return wi(t, { ...e, weekStartsOn: 1 });
}
const rc = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ic = (t, e, n) => {
  let r;
  const i = rc[t];
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function l1(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const ac = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, oc = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, sc = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lc = {
  date: l1({
    formats: ac,
    defaultWidth: "full"
  }),
  time: l1({
    formats: oc,
    defaultWidth: "full"
  }),
  dateTime: l1({
    formats: sc,
    defaultWidth: "full"
  })
}, cc = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, uc = (t, e, n, r) => cc[t];
function cn(t) {
  return (e, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && t.formattingValues) {
      const o = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : o;
      i = t.formattingValues[s] || t.formattingValues[o];
    } else {
      const o = t.defaultWidth, s = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[s] || t.values[o];
    }
    const a = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[a];
  };
}
const dc = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, fc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, mc = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, gc = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, hc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Cc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, bc = (t, e) => {
  const n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, pc = {
  ordinalNumber: bc,
  era: cn({
    values: dc,
    defaultWidth: "wide"
  }),
  quarter: cn({
    values: fc,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: cn({
    values: mc,
    defaultWidth: "wide"
  }),
  day: cn({
    values: gc,
    defaultWidth: "wide"
  }),
  dayPeriod: cn({
    values: hc,
    defaultWidth: "wide",
    formattingValues: Cc,
    defaultFormattingWidth: "wide"
  })
};
function un(t) {
  return (e, n = {}) => {
    const r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], a = e.match(i);
    if (!a)
      return null;
    const o = a[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? wc(s, (f) => f.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      vc(s, (f) => f.test(o))
    );
    let u;
    u = t.valueCallback ? t.valueCallback(l) : l, u = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(u)
    ) : u;
    const d = e.slice(o.length);
    return { value: u, rest: d };
  };
}
function vc(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function wc(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function xc(t) {
  return (e, n = {}) => {
    const r = e.match(t.matchPattern);
    if (!r) return null;
    const i = r[0], a = e.match(t.parsePattern);
    if (!a) return null;
    let o = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const s = e.slice(i.length);
    return { value: o, rest: s };
  };
}
const yc = /^(\d+)(th|st|nd|rd)?/i, Ic = /\d+/i, Vc = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Hc = {
  any: [/^b/i, /^(a|c)/i]
}, Mc = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ec = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Lc = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ac = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Zc = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Rc = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Bc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Sc = {
  ordinalNumber: xc({
    matchPattern: yc,
    parsePattern: Ic,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: un({
    matchPatterns: Vc,
    defaultMatchWidth: "wide",
    parsePatterns: Hc,
    defaultParseWidth: "any"
  }),
  quarter: un({
    matchPatterns: Mc,
    defaultMatchWidth: "wide",
    parsePatterns: Ec,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: un({
    matchPatterns: Nc,
    defaultMatchWidth: "wide",
    parsePatterns: Lc,
    defaultParseWidth: "any"
  }),
  day: un({
    matchPatterns: Ac,
    defaultMatchWidth: "wide",
    parsePatterns: Zc,
    defaultParseWidth: "any"
  }),
  dayPeriod: un({
    matchPatterns: Rc,
    defaultMatchWidth: "any",
    parsePatterns: Bc,
    defaultParseWidth: "any"
  })
}, G1 = {
  code: "en-US",
  formatDistance: ic,
  formatLong: lc,
  formatRelative: uc,
  localize: pc,
  match: Sc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Gc(t, e) {
  const n = le(t, e == null ? void 0 : e.in);
  return bi(n, vi(n)) + 1;
}
function xi(t, e) {
  const n = le(t, e == null ? void 0 : e.in), r = +vn(n) - +X2(n);
  return Math.round(r / di) + 1;
}
function yi(t, e) {
  var d, f, p, h;
  const n = le(t, e == null ? void 0 : e.in), r = n.getFullYear(), i = Hn(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((f = (d = e == null ? void 0 : e.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((h = (p = i.locale) == null ? void 0 : p.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = He((e == null ? void 0 : e.in) || t, 0);
  o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
  const s = Kt(o, e), l = He((e == null ? void 0 : e.in) || t, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const u = Kt(l, e);
  return +n >= +s ? r + 1 : +n >= +u ? r : r - 1;
}
function Dc(t, e) {
  var s, l, u, d;
  const n = Hn(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, i = yi(t, e), a = He((e == null ? void 0 : e.in) || t, 0);
  return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), Kt(a, e);
}
function Ii(t, e) {
  const n = le(t, e == null ? void 0 : e.in), r = +Kt(n, e) - +Dc(n, e);
  return Math.round(r / di) + 1;
}
function ue(t, e) {
  const n = t < 0 ? "-" : "", r = Math.abs(t).toString().padStart(e, "0");
  return n + r;
}
const Nt = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), r = n > 0 ? n : 1 - n;
    return ue(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : ue(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return ue(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return ue(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return ue(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return ue(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return ue(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, r = t.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return ue(i, e.length);
  }
}, Jt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, cr = {
  // Era
  G: function(t, e, n) {
    const r = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const r = t.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return Nt.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, r) {
    const i = yi(t, r), a = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const o = a % 100;
      return ue(o, 2);
    }
    return e === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : ue(a, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = Ci(t);
    return ue(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return ue(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(r);
      case "QQ":
        return ue(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const r = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(r);
      case "qq":
        return ue(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Nt.M(t, e);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const r = t.getMonth();
    switch (e) {
      case "L":
        return String(r + 1);
      case "LL":
        return ue(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, r) {
    const i = Ii(t, r);
    return e === "wo" ? n.ordinalNumber(i, { unit: "week" }) : ue(i, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const r = xi(t);
    return e === "Io" ? n.ordinalNumber(r, { unit: "week" }) : ue(r, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Nt.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const r = Gc(t);
    return e === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : ue(r, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const r = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, r) {
    const i = t.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(a);
      case "ee":
        return ue(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, r) {
    const i = t.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(a);
      case "cc":
        return ue(a, e.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const r = t.getDay(), i = r === 0 ? 7 : r;
    switch (e) {
      case "i":
        return String(i);
      case "ii":
        return ue(i, e.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r === 12 ? i = Jt.noon : r === 0 ? i = Jt.midnight : i = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const r = t.getHours();
    let i;
    switch (r >= 17 ? i = Jt.evening : r >= 12 ? i = Jt.afternoon : r >= 4 ? i = Jt.morning : i = Jt.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let r = t.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Nt.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Nt.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const r = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : ue(r, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let r = t.getHours();
    return r === 0 && (r = 24), e === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : ue(r, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Nt.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Nt.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Nt.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const r = t.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      case "X":
        return dr(r);
      case "XXXX":
      case "XX":
        return Ot(r);
      case "XXXXX":
      case "XXX":
      default:
        return Ot(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return dr(r);
      case "xxxx":
      case "xx":
        return Ot(r);
      case "xxxxx":
      case "xxx":
      default:
        return Ot(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ur(r, ":");
      case "OOOO":
      default:
        return "GMT" + Ot(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const r = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ur(r, ":");
      case "zzzz":
      default:
        return "GMT" + Ot(r, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const r = Math.trunc(+t / 1e3);
    return ue(r, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return ue(+t, e.length);
  }
};
function ur(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(i) : n + String(i) + e + ue(a, 2);
}
function dr(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + ue(Math.abs(t) / 60, 2) : Ot(t, e);
}
function Ot(t, e = "") {
  const n = t > 0 ? "-" : "+", r = Math.abs(t), i = ue(Math.trunc(r / 60), 2), a = ue(r % 60, 2);
  return n + i + e + a;
}
const fr = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Vi = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, Fc = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return fr(t, e);
  let a;
  switch (r) {
    case "P":
      a = e.dateTime({ width: "short" });
      break;
    case "PP":
      a = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = e.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", fr(r, e)).replace("{{time}}", Vi(i, e));
}, Oc = {
  p: Vi,
  P: Fc
}, Tc = /^D+$/, Pc = /^Y+$/, Wc = ["D", "DD", "YY", "YYYY"];
function kc(t) {
  return Tc.test(t);
}
function Xc(t) {
  return Pc.test(t);
}
function zc(t, e, n) {
  const r = Yc(t, e, n);
  if (console.warn(r), Wc.includes(t)) throw new RangeError(r);
}
function Yc(t, e, n) {
  const r = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const jc = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Jc = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, _c = /^'([^]*?)'?$/, Uc = /''/g, $c = /[a-zA-Z]/;
function hn(t, e, n) {
  var d, f, p, h, b, C, g, v;
  const r = Hn(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? G1, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = (n == null ? void 0 : n.weekStartsOn) ?? ((C = (b = n == null ? void 0 : n.locale) == null ? void 0 : b.options) == null ? void 0 : C.weekStartsOn) ?? r.weekStartsOn ?? ((v = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : v.weekStartsOn) ?? 0, s = le(t, n == null ? void 0 : n.in);
  if (!U2(s))
    throw new RangeError("Invalid time value");
  let l = e.match(Jc).map((w) => {
    const x = w[0];
    if (x === "p" || x === "P") {
      const V = Oc[x];
      return V(w, i.formatLong);
    }
    return w;
  }).join("").match(jc).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const x = w[0];
    if (x === "'")
      return { isToken: !1, value: Qc(w) };
    if (cr[x])
      return { isToken: !0, value: w };
    if (x.match($c))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: w };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(s, l));
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: o,
    locale: i
  };
  return l.map((w) => {
    if (!w.isToken) return w.value;
    const x = w.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Xc(x) || !(n != null && n.useAdditionalDayOfYearTokens) && kc(x)) && zc(x, e, String(t));
    const V = cr[x[0]];
    return V(s, x, i.localize, u);
  }).join("");
}
function Qc(t) {
  const e = t.match(_c);
  return e ? e[1].replace(Uc, "'") : t;
}
function Kc(t, e) {
  const n = le(t, e == null ? void 0 : e.in), r = n.getFullYear(), i = n.getMonth(), a = He(n, 0);
  return a.setFullYear(r, i + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function qc(t, e) {
  return le(t, e == null ? void 0 : e.in).getMonth();
}
function eu(t, e) {
  return le(t, e == null ? void 0 : e.in).getFullYear();
}
function tu(t, e) {
  return +le(t) > +le(e);
}
function nu(t, e) {
  return +le(t) < +le(e);
}
function ru(t, e, n) {
  const [r, i] = rn(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function iu(t, e, n) {
  const [r, i] = rn(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return r.getFullYear() === i.getFullYear();
}
function mr(t, e) {
  const n = () => He(e == null ? void 0 : e.in, NaN), i = lu(t);
  let a;
  if (i.date) {
    const u = cu(i.date, 2);
    a = uu(u.restDateString, u.year);
  }
  if (!a || isNaN(+a)) return n();
  const o = +a;
  let s = 0, l;
  if (i.time && (s = du(i.time), isNaN(s)))
    return n();
  if (i.timezone) {
    if (l = fu(i.timezone), isNaN(l)) return n();
  } else {
    const u = new Date(o + s), d = le(0, e == null ? void 0 : e.in);
    return d.setFullYear(
      u.getUTCFullYear(),
      u.getUTCMonth(),
      u.getUTCDate()
    ), d.setHours(
      u.getUTCHours(),
      u.getUTCMinutes(),
      u.getUTCSeconds(),
      u.getUTCMilliseconds()
    ), d;
  }
  return le(o + s + l, e == null ? void 0 : e.in);
}
const Zn = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, au = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, ou = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, su = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function lu(t) {
  const e = {}, n = t.split(Zn.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], Zn.timeZoneDelimiter.test(e.date) && (e.date = t.split(Zn.timeZoneDelimiter)[0], r = t.substr(
    e.date.length,
    t.length
  ))), r) {
    const i = Zn.timezone.exec(r);
    i ? (e.time = r.replace(i[1], ""), e.timezone = i[1]) : e.time = r;
  }
  return e;
}
function cu(t, e) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), r = t.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const i = r[1] ? parseInt(r[1]) : null, a = r[2] ? parseInt(r[2]) : null;
  return {
    year: a === null ? i : a * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function uu(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  const n = t.match(au);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], i = dn(n[1]), a = dn(n[2]) - 1, o = dn(n[3]), s = dn(n[4]), l = dn(n[5]) - 1;
  if (r)
    return bu(e, s, l) ? mu(e, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !hu(e, a, o) || !Cu(e, i) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(e, a, Math.max(i, o)), u);
  }
}
function dn(t) {
  return t ? parseInt(t) : 1;
}
function du(t) {
  const e = t.match(ou);
  if (!e) return NaN;
  const n = c1(e[1]), r = c1(e[2]), i = c1(e[3]);
  return pu(n, r, i) ? n * mi + r * fi + i * 1e3 : NaN;
}
function c1(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function fu(t) {
  if (t === "Z") return 0;
  const e = t.match(su);
  if (!e) return 0;
  const n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), i = e[3] && parseInt(e[3]) || 0;
  return vu(r, i) ? n * (r * mi + i * fi) : NaN;
}
function mu(t, e, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  const i = r.getUTCDay() || 7, a = (e - 1) * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
const gu = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Hi(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function hu(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (gu[e] || (Hi(t) ? 29 : 28));
}
function Cu(t, e) {
  return e >= 1 && e <= (Hi(t) ? 366 : 365);
}
function bu(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function pu(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function vu(t, e) {
  return e >= 0 && e <= 59;
}
function wu(t, e, n) {
  const r = le(t, n == null ? void 0 : n.in), i = r.getFullYear(), a = r.getDate(), o = He(t, 0);
  o.setFullYear(i, e, 15), o.setHours(0, 0, 0, 0);
  const s = Kc(o);
  return r.setMonth(e, Math.min(a, s)), r;
}
function xu(t, e, n) {
  const r = le(t, n == null ? void 0 : n.in);
  return isNaN(+r) ? He(t, NaN) : (r.setFullYear(e), r);
}
const gr = 5, yu = 4;
function Iu(t, e) {
  const n = e.startOfMonth(t), r = n.getDay() > 0 ? n.getDay() : 7, i = e.addDays(t, -r + 1), a = e.addDays(i, gr * 7 - 1);
  return e.getMonth(t) === e.getMonth(a) ? gr : yu;
}
function Mi(t, e) {
  const n = e.startOfMonth(t), r = n.getDay();
  return r === 1 ? n : r === 0 ? e.addDays(n, -1 * 6) : e.addDays(n, -1 * (r - 1));
}
function Vu(t, e) {
  const n = Mi(t, e), r = Iu(t, e);
  return e.addDays(n, r * 7 - 1);
}
class xt {
  /**
   * Creates an instance of DateLib.
   *
   * @param options The options for the date library.
   * @param overrides Overrides for the date library functions.
   */
  constructor(e, n) {
    this.Date = Date, this.today = () => {
      var r;
      return (r = this.overrides) != null && r.today ? this.overrides.today() : this.options.timeZone ? Tt.tz(this.options.timeZone) : new this.Date();
    }, this.newDate = (r, i, a) => {
      var o;
      return (o = this.overrides) != null && o.newDate ? this.overrides.newDate(r, i, a) : this.options.timeZone ? new Tt(r, i, a, this.options.timeZone) : new Date(r, i, a);
    }, this.addDays = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.addDays ? this.overrides.addDays(r, i) : gi(r, i);
    }, this.addMonths = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.addMonths ? this.overrides.addMonths(r, i) : hi(r, i);
    }, this.addWeeks = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.addWeeks ? this.overrides.addWeeks(r, i) : z2(r, i);
    }, this.addYears = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.addYears ? this.overrides.addYears(r, i) : Y2(r, i);
    }, this.differenceInCalendarDays = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, i) : bi(r, i);
    }, this.differenceInCalendarMonths = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, i) : $2(r, i);
    }, this.eachMonthOfInterval = (r) => {
      var i;
      return (i = this.overrides) != null && i.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : q2(r);
    }, this.endOfBroadcastWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r, this) : Vu(r, this);
    }, this.endOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfISOWeek ? this.overrides.endOfISOWeek(r) : nc(r);
    }, this.endOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfMonth ? this.overrides.endOfMonth(r) : Q2(r);
    }, this.endOfWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfWeek ? this.overrides.endOfWeek(r, this.options) : wi(r, this.options);
    }, this.endOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfYear ? this.overrides.endOfYear(r) : tc(r);
    }, this.format = (r, i) => {
      var o;
      const a = (o = this.overrides) != null && o.format ? this.overrides.format(r, i, this.options) : hn(r, i, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(a) : a;
    }, this.getISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.getISOWeek ? this.overrides.getISOWeek(r) : xi(r);
    }, this.getMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.getMonth ? this.overrides.getMonth(r, this.options) : qc(r, this.options);
    }, this.getYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.getYear ? this.overrides.getYear(r, this.options) : eu(r, this.options);
    }, this.getWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.getWeek ? this.overrides.getWeek(r, this.options) : Ii(r, this.options);
    }, this.isAfter = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isAfter ? this.overrides.isAfter(r, i) : tu(r, i);
    }, this.isBefore = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isBefore ? this.overrides.isBefore(r, i) : nu(r, i);
    }, this.isDate = (r) => {
      var i;
      return (i = this.overrides) != null && i.isDate ? this.overrides.isDate(r) : pi(r);
    }, this.isSameDay = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isSameDay ? this.overrides.isSameDay(r, i) : _2(r, i);
    }, this.isSameMonth = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isSameMonth ? this.overrides.isSameMonth(r, i) : ru(r, i);
    }, this.isSameYear = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isSameYear ? this.overrides.isSameYear(r, i) : iu(r, i);
    }, this.max = (r) => {
      var i;
      return (i = this.overrides) != null && i.max ? this.overrides.max(r) : j2(r);
    }, this.min = (r) => {
      var i;
      return (i = this.overrides) != null && i.min ? this.overrides.min(r) : J2(r);
    }, this.setMonth = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.setMonth ? this.overrides.setMonth(r, i) : wu(r, i);
    }, this.setYear = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.setYear ? this.overrides.setYear(r, i) : xu(r, i);
    }, this.startOfBroadcastWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : Mi(r, this);
    }, this.startOfDay = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfDay ? this.overrides.startOfDay(r) : wn(r);
    }, this.startOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfISOWeek ? this.overrides.startOfISOWeek(r) : vn(r);
    }, this.startOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfMonth ? this.overrides.startOfMonth(r) : ec(r);
    }, this.startOfWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfWeek ? this.overrides.startOfWeek(r, this.options) : Kt(r, this.options);
    }, this.startOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfYear ? this.overrides.startOfYear(r) : vi(r);
    }, this.options = { locale: G1, ...e }, this.overrides = n;
  }
  /**
   * Generate digit map dynamically using Intl.NumberFormat.
   *
   * @since 9.5.0
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), r = {};
    for (let i = 0; i < 10; i++)
      r[i.toString()] = n.format(i);
    return r;
  }
  /**
   * Replace Arabic digits with the target numbering system digits.
   *
   * @since 9.5.0
   */
  replaceDigits(e) {
    const n = this.getDigitMap();
    return e.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Format number using the custom numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
}
const yt = new xt();
function Hu(t, e, n = {}) {
  return Object.entries(t).filter(([, i]) => i === !0).reduce((i, [a]) => (n[a] ? i.push(n[a]) : e[ge[a]] ? i.push(e[ge[a]]) : e[Ke[a]] && i.push(e[Ke[a]]), i), [e[G.Day]]);
}
function Mu(t) {
  return c.createElement("button", { ...t });
}
function Eu(t) {
  return c.createElement("span", { ...t });
}
function Nu(t) {
  const { size: e = 24, orientation: n = "left", className: r } = t;
  return c.createElement(
    "svg",
    { className: r, width: e, height: e, viewBox: "0 0 24 24" },
    n === "up" && c.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && c.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && c.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && c.createElement("polygon", { points: "8 18.612 14.1888889 12.5 8 6.37733333 9.91111111 4.5 18 12.5 9.91111111 20.5" })
  );
}
function Lu(t) {
  const { day: e, modifiers: n, ...r } = t;
  return c.createElement("td", { ...r });
}
function Au(t) {
  const { day: e, modifiers: n, ...r } = t, i = c.useRef(null);
  return c.useEffect(() => {
    var a;
    n.focused && ((a = i.current) == null || a.focus());
  }, [n.focused]), c.createElement("button", { ref: i, ...r });
}
function Zu(t) {
  const { options: e, className: n, components: r, classNames: i, ...a } = t, o = [i[G.Dropdown], n].join(" "), s = e == null ? void 0 : e.find(({ value: l }) => l === a.value);
  return c.createElement(
    "span",
    { "data-disabled": a.disabled, className: i[G.DropdownRoot] },
    c.createElement(r.Select, { className: o, ...a }, e == null ? void 0 : e.map(({ value: l, label: u, disabled: d }) => c.createElement(r.Option, { key: l, value: l, disabled: d }, u))),
    c.createElement(
      "span",
      { className: i[G.CaptionLabel], "aria-hidden": !0 },
      s == null ? void 0 : s.label,
      c.createElement(r.Chevron, { orientation: "down", size: 18, className: i[G.Chevron] })
    )
  );
}
function Ru(t) {
  return c.createElement("div", { ...t });
}
function Bu(t) {
  return c.createElement("div", { ...t });
}
function Su(t) {
  const { calendarMonth: e, displayIndex: n, ...r } = t;
  return c.createElement("div", { ...r }, t.children);
}
function Gu(t) {
  const { calendarMonth: e, displayIndex: n, ...r } = t;
  return c.createElement("div", { ...r });
}
function Du(t) {
  return c.createElement("table", { ...t });
}
function Fu(t) {
  return c.createElement("div", { ...t });
}
const Ei = S1(void 0);
function Mn() {
  const t = $n(Ei);
  if (t === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return t;
}
function Ou(t) {
  const { components: e } = Mn();
  return c.createElement(e.Dropdown, { ...t });
}
function Tu(t) {
  const { onPreviousClick: e, onNextClick: n, previousMonth: r, nextMonth: i, ...a } = t, { components: o, classNames: s, labels: { labelPrevious: l, labelNext: u } } = Mn();
  return c.createElement(
    "nav",
    { ...a },
    c.createElement(
      o.PreviousMonthButton,
      { type: "button", className: s[G.PreviousMonthButton], tabIndex: r ? void 0 : -1, disabled: r ? void 0 : !0, "aria-label": l(r), onClick: t.onPreviousClick },
      c.createElement(o.Chevron, { disabled: r ? void 0 : !0, className: s[G.Chevron], orientation: "left" })
    ),
    c.createElement(
      o.NextMonthButton,
      { type: "button", className: s[G.NextMonthButton], tabIndex: i ? void 0 : -1, disabled: i ? void 0 : !0, "aria-label": u(i), onClick: t.onNextClick },
      c.createElement(o.Chevron, { disabled: i ? void 0 : !0, orientation: "right", className: s[G.Chevron] })
    )
  );
}
function Pu(t) {
  const { components: e } = Mn();
  return c.createElement(e.Button, { ...t });
}
function Wu(t) {
  return c.createElement("option", { ...t });
}
function ku(t) {
  const { components: e } = Mn();
  return c.createElement(e.Button, { ...t });
}
function Xu(t) {
  return c.createElement("div", { ...t });
}
function zu(t) {
  return c.createElement("select", { ...t });
}
function Yu(t) {
  const { week: e, ...n } = t;
  return c.createElement("tr", { ...n });
}
function ju(t) {
  return c.createElement("th", { ...t });
}
function Ju(t) {
  return c.createElement(
    "thead",
    { "aria-hidden": !0 },
    c.createElement("tr", { ...t })
  );
}
function _u(t) {
  const { week: e, ...n } = t;
  return c.createElement("th", { ...n });
}
function Uu(t) {
  return c.createElement("th", { ...t });
}
function $u(t) {
  return c.createElement("tbody", { ...t });
}
function Qu(t) {
  const { components: e } = Mn();
  return c.createElement(e.Dropdown, { ...t });
}
const Ku = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Mu,
  CaptionLabel: Eu,
  Chevron: Nu,
  Day: Lu,
  DayButton: Au,
  Dropdown: Zu,
  DropdownNav: Ru,
  Footer: Bu,
  Month: Su,
  MonthCaption: Gu,
  MonthGrid: Du,
  Months: Fu,
  MonthsDropdown: Ou,
  Nav: Tu,
  NextMonthButton: Pu,
  Option: Wu,
  PreviousMonthButton: ku,
  Root: Xu,
  Select: zu,
  Week: Yu,
  WeekNumber: _u,
  WeekNumberHeader: Uu,
  Weekday: ju,
  Weekdays: Ju,
  Weeks: $u,
  YearsDropdown: Qu
}, Symbol.toStringTag, { value: "Module" }));
function qu(t) {
  return {
    ...Ku,
    ...t
  };
}
function e0(t) {
  const e = {
    "data-mode": t.mode ?? void 0,
    "data-required": "required" in t ? t.required : void 0,
    "data-multiple-months": t.numberOfMonths && t.numberOfMonths > 1 || void 0,
    "data-week-numbers": t.showWeekNumber || void 0,
    "data-broadcast-calendar": t.broadcastCalendar || void 0
  };
  return Object.entries(t).forEach(([n, r]) => {
    n.startsWith("data-") && (e[n] = r);
  }), e;
}
function Ni() {
  const t = {};
  for (const e in G)
    t[G[e]] = `rdp-${G[e]}`;
  for (const e in ge)
    t[ge[e]] = `rdp-${ge[e]}`;
  for (const e in Ke)
    t[Ke[e]] = `rdp-${Ke[e]}`;
  return t;
}
function Li(t, e, n) {
  return (n ?? new xt(e)).format(t, "LLLL y");
}
const t0 = Li;
function n0(t, e, n) {
  return (n ?? new xt(e)).format(t, "d");
}
function r0(t, e = yt) {
  return e.format(t, "LLLL");
}
function i0(t) {
  return t < 10 ? `0${t.toLocaleString()}` : `${t.toLocaleString()}`;
}
function a0() {
  return "";
}
function o0(t, e, n) {
  return (n ?? new xt(e)).format(t, "cccccc");
}
function Ai(t, e = yt) {
  return e.format(t, "yyyy");
}
const s0 = Ai, l0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Li,
  formatDay: n0,
  formatMonthCaption: t0,
  formatMonthDropdown: r0,
  formatWeekNumber: i0,
  formatWeekNumberHeader: a0,
  formatWeekdayName: o0,
  formatYearCaption: s0,
  formatYearDropdown: Ai
}, Symbol.toStringTag, { value: "Module" }));
function c0(t) {
  return t != null && t.formatMonthCaption && !t.formatCaption && (t.formatCaption = t.formatMonthCaption), t != null && t.formatYearCaption && !t.formatYearDropdown && (t.formatYearDropdown = t.formatYearCaption), {
    ...l0,
    ...t
  };
}
function u0(t, e, n, r, i) {
  const { startOfMonth: a, startOfYear: o, endOfYear: s, eachMonthOfInterval: l, getMonth: u } = i;
  return l({
    start: o(t),
    end: s(t)
  }).map((p) => {
    const h = r.formatMonthDropdown(p, i), b = u(p), C = e && p < a(e) || n && p > a(n) || !1;
    return { value: b, label: h, disabled: C };
  });
}
function d0(t, e = {}, n = {}) {
  let r = { ...e == null ? void 0 : e[G.Day] };
  return Object.entries(t).filter(([, i]) => i === !0).forEach(([i]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[i]
    };
  }), r;
}
function f0(t, e, n) {
  const r = t.today(), i = e ? t.startOfISOWeek(r) : t.startOfWeek(r), a = [];
  for (let o = 0; o < 7; o++) {
    const s = t.addDays(i, o);
    a.push(s);
  }
  return a;
}
function m0(t, e, n, r) {
  if (!t || !e)
    return;
  const { startOfYear: i, endOfYear: a, addYears: o, getYear: s, isBefore: l, isSameYear: u } = r, d = i(t), f = a(e), p = [];
  let h = d;
  for (; l(h, f) || u(h, f); )
    p.push(h), h = o(h, 1);
  return p.map((b) => {
    const C = n.formatYearDropdown(b, r);
    return {
      value: s(b),
      label: C,
      disabled: !1
    };
  });
}
function Zi(t, e, n) {
  return (n ?? new xt(e)).format(t, "LLLL y");
}
const g0 = Zi;
function h0(t, e, n, r) {
  let i = (r ?? new xt(n)).format(t, "PPPP");
  return e != null && e.today && (i = `Today, ${i}`), i;
}
function Ri(t, e, n, r) {
  let i = (r ?? new xt(n)).format(t, "PPPP");
  return e.today && (i = `Today, ${i}`), e.selected && (i = `${i}, selected`), i;
}
const C0 = Ri;
function b0() {
  return "";
}
function p0(t) {
  return "Choose the Month";
}
function v0(t) {
  return "Go to the Next Month";
}
function w0(t) {
  return "Go to the Previous Month";
}
function x0(t, e, n) {
  return (n ?? new xt(e)).format(t, "cccc");
}
function y0(t, e) {
  return `Week ${t}`;
}
function I0(t) {
  return "Week Number";
}
function V0(t) {
  return "Choose the Year";
}
const H0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: g0,
  labelDay: C0,
  labelDayButton: Ri,
  labelGrid: Zi,
  labelGridcell: h0,
  labelMonthDropdown: p0,
  labelNav: b0,
  labelNext: v0,
  labelPrevious: w0,
  labelWeekNumber: y0,
  labelWeekNumberHeader: I0,
  labelWeekday: x0,
  labelYearDropdown: V0
}, Symbol.toStringTag, { value: "Module" }));
function M0(t, e, n, r) {
  const i = t[0], a = t[t.length - 1], { ISOWeek: o, fixedWeeks: s, broadcastCalendar: l } = n ?? {}, { addDays: u, differenceInCalendarDays: d, differenceInCalendarMonths: f, endOfBroadcastWeek: p, endOfISOWeek: h, endOfMonth: b, endOfWeek: C, isAfter: g, startOfBroadcastWeek: v, startOfISOWeek: w, startOfWeek: x } = r, V = l ? v(i, r) : o ? w(i) : x(i), y = l ? p(a, r) : o ? h(b(a)) : C(b(a)), H = d(y, V), I = f(a, i) + 1, M = [];
  for (let W = 0; W <= H; W++) {
    const O = u(V, W);
    if (e && g(O, e))
      break;
    M.push(O);
  }
  const Z = (l ? 35 : 42) * I;
  if (s && M.length < Z) {
    const W = Z - M.length;
    for (let O = 0; O < W; O++) {
      const ae = u(M[M.length - 1], 1);
      M.push(ae);
    }
  }
  return M;
}
function E0(t) {
  const e = [];
  return t.reduce((n, r) => {
    const i = [], a = r.weeks.reduce((o, s) => [...o, ...s.days], i);
    return [...n, ...a];
  }, e);
}
function N0(t, e, n, r) {
  const { numberOfMonths: i = 1 } = n, a = [];
  for (let o = 0; o < i; o++) {
    const s = r.addMonths(t, o);
    if (e && s > e)
      break;
    a.push(s);
  }
  return a;
}
function hr(t, e) {
  const { month: n, defaultMonth: r, today: i = e.today(), numberOfMonths: a = 1, endMonth: o, startMonth: s } = t;
  let l = n || r || i;
  const { differenceInCalendarMonths: u, addMonths: d, startOfMonth: f } = e;
  if (o && u(o, l) < 0) {
    const p = -1 * (a - 1);
    l = d(o, p);
  }
  return s && u(l, s) < 0 && (l = s), f(l);
}
class Bi {
  constructor(e, n, r = yt) {
    this.date = e, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(e, n)), this.dateLib = r;
  }
  /**
   * Check if the day is the same as the given day: considering if it is in the
   * same display month.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class L0 {
  constructor(e, n) {
    this.date = e, this.weeks = n;
  }
}
class A0 {
  constructor(e, n) {
    this.days = n, this.weekNumber = e;
  }
}
function Z0(t, e, n, r) {
  const { addDays: i, endOfBroadcastWeek: a, endOfISOWeek: o, endOfMonth: s, endOfWeek: l, getISOWeek: u, getWeek: d, startOfBroadcastWeek: f, startOfISOWeek: p, startOfWeek: h } = r, b = t.reduce((C, g) => {
    const v = n.broadcastCalendar ? f(g, r) : n.ISOWeek ? p(g) : h(g), w = n.broadcastCalendar ? a(g, r) : n.ISOWeek ? o(s(g)) : l(s(g)), x = e.filter((I) => I >= v && I <= w), V = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && x.length < V) {
      const I = e.filter((M) => {
        const S = V - x.length;
        return M > w && M <= i(w, S);
      });
      x.push(...I);
    }
    const y = x.reduce((I, M) => {
      const S = n.ISOWeek ? u(M) : d(M), Z = I.find((O) => O.weekNumber === S), W = new Bi(M, g, r);
      return Z ? Z.days.push(W) : I.push(new A0(S, [W])), I;
    }, []), H = new L0(g, y);
    return C.push(H), C;
  }, []);
  return n.reverseMonths ? b.reverse() : b;
}
function R0(t, e) {
  let { startMonth: n, endMonth: r } = t;
  const { startOfYear: i, startOfDay: a, startOfMonth: o, endOfMonth: s, addYears: l, endOfYear: u, newDate: d, today: f } = e, { fromYear: p, toYear: h, fromMonth: b, toMonth: C } = t;
  !n && b && (n = b), !n && p && (n = e.newDate(p, 0, 1)), !r && C && (r = C), !r && h && (r = d(h, 11, 31));
  const g = t.captionLayout === "dropdown" || t.captionLayout === "dropdown-years";
  return n ? n = o(n) : p ? n = d(p, 0, 1) : !n && g && (n = i(l(t.today ?? f(), -100))), r ? r = s(r) : h ? r = d(h, 11, 31) : !r && g && (r = u(t.today ?? f())), [
    n && a(n),
    r && a(r)
  ];
}
function B0(t, e, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: a = 1 } = n, { startOfMonth: o, addMonths: s, differenceInCalendarMonths: l } = r, u = i ? a : 1, d = o(t);
  if (!e)
    return s(d, u);
  if (!(l(e, t) < a))
    return s(d, u);
}
function S0(t, e, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: a } = n, { startOfMonth: o, addMonths: s, differenceInCalendarMonths: l } = r, u = i ? a ?? 1 : 1, d = o(t);
  if (!e)
    return s(d, -u);
  if (!(l(d, e) <= 0))
    return s(d, -u);
}
function G0(t) {
  const e = [];
  return t.reduce((n, r) => [...n, ...r.weeks], e);
}
function Qn(t, e) {
  const [n, r] = $(t);
  return [e === void 0 ? n : e, r];
}
function D0(t, e) {
  const [n, r] = R0(t, e), { startOfMonth: i, endOfMonth: a } = e, o = hr(t, e), [s, l] = Qn(o, t.month ? i(t.month) : void 0);
  Q(() => {
    const H = hr(t, e);
    l(H);
  }, [t.timeZone]);
  const u = N0(s, r, t, e), d = M0(u, t.endMonth ? a(t.endMonth) : void 0, t, e), f = Z0(u, d, t, e), p = G0(f), h = E0(f), b = S0(s, n, t, e), C = B0(s, r, t, e), { disableNavigation: g, onMonthChange: v } = t, w = (H) => p.some((I) => I.days.some((M) => M.isEqualTo(H))), x = (H) => {
    if (g)
      return;
    let I = i(H);
    n && I < i(n) && (I = i(n)), r && I > i(r) && (I = i(r)), l(I), v == null || v(I);
  };
  return {
    months: f,
    weeks: p,
    days: h,
    navStart: n,
    navEnd: r,
    previousMonth: b,
    nextMonth: C,
    goToMonth: x,
    goToDay: (H) => {
      w(H) || x(H.date);
    }
  };
}
function F0(t, e, n, r) {
  let i, a = 0, o = !1;
  for (; a < t.length && !o; ) {
    const s = t[a], l = e(s);
    !l[ge.disabled] && !l[ge.hidden] && !l[ge.outside] && (l[ge.focused] || r != null && r.isEqualTo(s) || n(s.date) || l[ge.today]) && (i = s, o = !0), a++;
  }
  return i || (i = t.find((s) => {
    const l = e(s);
    return !l[ge.disabled] && !l[ge.hidden] && !l[ge.outside];
  })), i;
}
function pt(t, e, n = !1, r = yt) {
  let { from: i, to: a } = t;
  const { differenceInCalendarDays: o, isSameDay: s } = r;
  return i && a ? (o(a, i) < 0 && ([i, a] = [a, i]), o(e, i) >= (n ? 1 : 0) && o(a, e) >= (n ? 1 : 0)) : !n && a ? s(a, e) : !n && i ? s(i, e) : !1;
}
function Si(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function D1(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function Gi(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function Di(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function Fi(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function Oi(t, e) {
  return Array.isArray(t) && t.every(e.isDate);
}
function vt(t, e, n = yt) {
  const r = Array.isArray(e) ? e : [e], { isSameDay: i, differenceInCalendarDays: a, isAfter: o } = n;
  return r.some((s) => {
    if (typeof s == "boolean")
      return s;
    if (n.isDate(s))
      return i(t, s);
    if (Oi(s, n))
      return s.includes(t);
    if (D1(s))
      return pt(s, t, !1, n);
    if (Fi(s))
      return Array.isArray(s.dayOfWeek) ? s.dayOfWeek.includes(t.getDay()) : s.dayOfWeek === t.getDay();
    if (Si(s)) {
      const l = a(s.before, t), u = a(s.after, t), d = l > 0, f = u < 0;
      return o(s.before, s.after) ? f && d : d || f;
    }
    return Gi(s) ? a(t, s.after) > 0 : Di(s) ? a(s.before, t) > 0 : typeof s == "function" ? s(t) : !1;
  });
}
function O0(t, e, n, r, i, a, o) {
  const { ISOWeek: s, broadcastCalendar: l } = a, { addDays: u, addMonths: d, addWeeks: f, addYears: p, endOfBroadcastWeek: h, endOfISOWeek: b, endOfWeek: C, max: g, min: v, startOfBroadcastWeek: w, startOfISOWeek: x, startOfWeek: V } = o;
  let H = {
    day: u,
    week: f,
    month: d,
    year: p,
    startOfWeek: (I) => l ? w(I, o) : s ? x(I) : V(I),
    endOfWeek: (I) => l ? h(I, o) : s ? b(I) : C(I)
  }[t](n, e === "after" ? 1 : -1);
  return e === "before" && r ? H = g([r, H]) : e === "after" && i && (H = v([i, H])), H;
}
function Ti(t, e, n, r, i, a, o, s = 0) {
  if (s > 365)
    return;
  const l = O0(
    t,
    e,
    n.date,
    // should be refDay? or refDay.date?
    r,
    i,
    a,
    o
  ), u = !!(a.disabled && vt(l, a.disabled, o)), d = !!(a.hidden && vt(l, a.hidden, o)), f = l, p = new Bi(l, f, o);
  return !u && !d ? p : Ti(t, e, p, r, i, a, o, s + 1);
}
function T0(t, e, n, r, i) {
  const { autoFocus: a } = t, [o, s] = $(), l = F0(e.days, n, r || (() => !1), o), [u, d] = $(a ? l : void 0);
  return {
    isFocusTarget: (C) => !!(l != null && l.isEqualTo(C)),
    setFocused: d,
    focused: u,
    blur: () => {
      s(u), d(void 0);
    },
    moveFocus: (C, g) => {
      if (!u)
        return;
      const v = Ti(C, g, u, e.navStart, e.navEnd, t, i);
      v && (e.goToDay(v), d(v));
    }
  };
}
function P0(t, e, n) {
  const { disabled: r, hidden: i, modifiers: a, showOutsideDays: o, broadcastCalendar: s, today: l } = e, { isSameDay: u, isSameMonth: d, startOfMonth: f, isBefore: p, endOfMonth: h, isAfter: b } = n, C = e.startMonth && f(e.startMonth), g = e.endMonth && h(e.endMonth), v = {
    [ge.focused]: [],
    [ge.outside]: [],
    [ge.disabled]: [],
    [ge.hidden]: [],
    [ge.today]: []
  }, w = {};
  for (const x of t) {
    const { date: V, displayMonth: y } = x, H = !!(y && !d(V, y)), I = !!(C && p(V, C)), M = !!(g && b(V, g)), S = !!(r && vt(V, r, n)), Z = !!(i && vt(V, i, n)) || I || M || // Broadcast calendar will show outside days as default
    !s && !o && H || s && o === !1 && H, W = u(V, l ?? n.today());
    H && v.outside.push(x), S && v.disabled.push(x), Z && v.hidden.push(x), W && v.today.push(x), a && Object.keys(a).forEach((O) => {
      const ae = a == null ? void 0 : a[O];
      ae && vt(V, ae, n) && (w[O] ? w[O].push(x) : w[O] = [x]);
    });
  }
  return (x) => {
    const V = {
      [ge.focused]: !1,
      [ge.disabled]: !1,
      [ge.hidden]: !1,
      [ge.outside]: !1,
      [ge.today]: !1
    }, y = {};
    for (const H in v) {
      const I = v[H];
      V[H] = I.some((M) => M === x);
    }
    for (const H in w)
      y[H] = w[H].some((I) => I === x);
    return {
      ...V,
      // custom modifiers should override all the previous ones
      ...y
    };
  };
}
function W0(t, e) {
  const { selected: n, required: r, onSelect: i } = t, [a, o] = Qn(n, i ? n : void 0), s = i ? n : a, { isSameDay: l } = e, u = (h) => (s == null ? void 0 : s.some((b) => l(b, h))) ?? !1, { min: d, max: f } = t;
  return {
    selected: s,
    select: (h, b, C) => {
      let g = [...s ?? []];
      if (u(h)) {
        if ((s == null ? void 0 : s.length) === d || r && (s == null ? void 0 : s.length) === 1)
          return;
        g = s == null ? void 0 : s.filter((v) => !l(v, h));
      } else
        (s == null ? void 0 : s.length) === f ? g = [h] : g = [...g, h];
      return i || o(g), i == null || i(g, h, b, C), g;
    },
    isSelected: u
  };
}
function k0(t, e, n = 0, r = 0, i = !1, a = yt) {
  const { from: o, to: s } = e || {}, { isSameDay: l, isAfter: u, isBefore: d } = a;
  let f;
  if (!o && !s)
    f = { from: t, to: n > 0 ? void 0 : t };
  else if (o && !s)
    l(o, t) ? i ? f = { from: o, to: void 0 } : f = void 0 : d(t, o) ? f = { from: t, to: o } : f = { from: o, to: t };
  else if (o && s)
    if (l(o, t) && l(s, t))
      i ? f = { from: o, to: s } : f = void 0;
    else if (l(o, t))
      f = { from: o, to: n > 0 ? void 0 : t };
    else if (l(s, t))
      f = { from: t, to: n > 0 ? void 0 : t };
    else if (d(t, o))
      f = { from: t, to: s };
    else if (u(t, o))
      f = { from: o, to: t };
    else if (u(t, s))
      f = { from: o, to: t };
    else
      throw new Error("Invalid range");
  if (f != null && f.from && (f != null && f.to)) {
    const p = a.differenceInCalendarDays(f.to, f.from);
    r > 0 && p > r ? f = { from: t, to: void 0 } : n > 1 && p < n && (f = { from: t, to: void 0 });
  }
  return f;
}
function X0(t, e, n = yt) {
  const r = Array.isArray(e) ? e : [e];
  let i = t.from;
  const a = n.differenceInCalendarDays(t.to, t.from), o = Math.min(a, 6);
  for (let s = 0; s <= o; s++) {
    if (r.includes(i.getDay()))
      return !0;
    i = n.addDays(i, 1);
  }
  return !1;
}
function Cr(t, e, n = yt) {
  return pt(t, e.from, !1, n) || pt(t, e.to, !1, n) || pt(e, t.from, !1, n) || pt(e, t.to, !1, n);
}
function z0(t, e, n = yt) {
  const r = Array.isArray(e) ? e : [e];
  if (r.filter((s) => typeof s != "function").some((s) => typeof s == "boolean" ? s : n.isDate(s) ? pt(t, s, !1, n) : Oi(s, n) ? s.some((l) => pt(t, l, !1, n)) : D1(s) ? s.from && s.to ? Cr(t, { from: s.from, to: s.to }, n) : !1 : Fi(s) ? X0(t, s.dayOfWeek, n) : Si(s) ? n.isAfter(s.before, s.after) ? Cr(t, {
    from: n.addDays(s.after, 1),
    to: n.addDays(s.before, -1)
  }, n) : vt(t.from, s, n) || vt(t.to, s, n) : Gi(s) || Di(s) ? vt(t.from, s, n) || vt(t.to, s, n) : !1))
    return !0;
  const o = r.filter((s) => typeof s == "function");
  if (o.length) {
    let s = t.from;
    const l = n.differenceInCalendarDays(t.to, t.from);
    for (let u = 0; u <= l; u++) {
      if (o.some((d) => d(s)))
        return !0;
      s = n.addDays(s, 1);
    }
  }
  return !1;
}
function Y0(t, e) {
  const { disabled: n, excludeDisabled: r, selected: i, required: a, onSelect: o } = t, [s, l] = Qn(i, o ? i : void 0), u = o ? i : s;
  return {
    selected: u,
    select: (p, h, b) => {
      const { min: C, max: g } = t, v = p ? k0(p, u, C, g, a, e) : void 0;
      return r && n && (v != null && v.from) && v.to && z0({ from: v.from, to: v.to }, n, e) && (v.from = p, v.to = void 0), o || l(v), o == null || o(v, p, h, b), v;
    },
    isSelected: (p) => u && pt(u, p, !1, e)
  };
}
function j0(t, e) {
  const { selected: n, required: r, onSelect: i } = t, [a, o] = Qn(n, i ? n : void 0), s = i ? n : a, { isSameDay: l } = e;
  return {
    selected: s,
    select: (f, p, h) => {
      let b = f;
      return !r && s && s && l(f, s) && (b = void 0), i || o(b), i == null || i(b, f, p, h), b;
    },
    isSelected: (f) => s ? l(s, f) : !1
  };
}
function J0(t, e) {
  const n = j0(t, e), r = W0(t, e), i = Y0(t, e);
  switch (t.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return i;
    default:
      return;
  }
}
function _0(t) {
  const { components: e, formatters: n, labels: r, dateLib: i, locale: a, classNames: o } = lt(() => {
    const _ = { ...G1, ...t.locale };
    return {
      dateLib: new xt({
        locale: _,
        weekStartsOn: t.broadcastCalendar ? 1 : t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
        timeZone: t.timeZone,
        numerals: t.numerals
      }, t.dateLib),
      components: qu(t.components),
      formatters: c0(t.formatters),
      labels: { ...H0, ...t.labels },
      locale: _,
      classNames: { ...Ni(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]), { captionLayout: s, mode: l, onDayBlur: u, onDayClick: d, onDayFocus: f, onDayKeyDown: p, onDayMouseEnter: h, onDayMouseLeave: b, onNextClick: C, onPrevClick: g, showWeekNumber: v, styles: w } = t, { formatCaption: x, formatDay: V, formatMonthDropdown: y, formatWeekNumber: H, formatWeekNumberHeader: I, formatWeekdayName: M, formatYearDropdown: S } = n, Z = D0(t, i), { days: W, months: O, navStart: ae, navEnd: z, previousMonth: Y, nextMonth: k, goToMonth: j } = Z, J = P0(W, t, i), { isSelected: ee, select: de, selected: te } = J0(t, i) ?? {}, { blur: ne, focused: Ce, isFocusTarget: Ee, moveFocus: Ne, setFocused: ve } = T0(t, Z, J, ee ?? (() => !1), i), { labelDayButton: Le, labelGridcell: ce, labelGrid: Te, labelMonthDropdown: Ze, labelNav: Pe, labelWeekday: L, labelWeekNumber: Ge, labelWeekNumberHeader: Xe, labelYearDropdown: Ie } = r, zt = lt(() => f0(i, t.ISOWeek), [i, t.ISOWeek]), nt = l !== void 0 || d !== void 0, ht = me(() => {
    Y && (j(Y), g == null || g(Y));
  }, [Y, j, g]), he = me(() => {
    k && (j(k), C == null || C(k));
  }, [j, k, C]), At = me((_, q) => (T) => {
    T.preventDefault(), T.stopPropagation(), ve(_), de == null || de(_.date, q, T), d == null || d(_.date, q, T);
  }, [de, d, ve]), Zt = me((_, q) => (T) => {
    ve(_), f == null || f(_.date, q, T);
  }, [f, ve]), Rt = me((_, q) => (T) => {
    ne(), u == null || u(_.date, q, T);
  }, [ne, u]), Bt = me((_, q) => (T) => {
    const ze = {
      ArrowLeft: ["day", t.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", t.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [T.shiftKey ? "year" : "month", "before"],
      PageDown: [T.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (ze[T.key]) {
      T.preventDefault(), T.stopPropagation();
      const [Re, $e] = ze[T.key];
      Ne(Re, $e);
    }
    p == null || p(_.date, q, T);
  }, [Ne, p, t.dir]), Yt = me((_, q) => (T) => {
    h == null || h(_.date, q, T);
  }, [h]), Vt = me((_, q) => (T) => {
    b == null || b(_.date, q, T);
  }, [b]), rt = me((_) => (q) => {
    const T = Number(q.target.value), ze = i.setMonth(i.startOfMonth(_), T);
    j(ze);
  }, [i, j]), St = me((_) => (q) => {
    const T = Number(q.target.value), ze = i.setYear(i.startOfMonth(_), T);
    j(ze);
  }, [i, j]), { className: Ct, style: Ht } = lt(() => ({
    className: [o[G.Root], t.className].filter(Boolean).join(" "),
    style: { ...w == null ? void 0 : w[G.Root], ...t.style }
  }), [o, t.className, t.style, w]), Gt = e0(t), Mt = {
    dayPickerProps: t,
    selected: te,
    select: de,
    isSelected: ee,
    months: O,
    nextMonth: k,
    previousMonth: Y,
    goToMonth: j,
    getModifiers: J,
    components: e,
    classNames: o,
    styles: w,
    labels: r,
    formatters: n
  };
  return c.createElement(
    Ei.Provider,
    { value: Mt },
    c.createElement(
      e.Root,
      { className: Ct, style: Ht, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], ...Gt },
      c.createElement(
        e.Months,
        { className: o[G.Months], style: w == null ? void 0 : w[G.Months] },
        !t.hideNavigation && c.createElement(e.Nav, { className: o[G.Nav], style: w == null ? void 0 : w[G.Nav], "aria-label": Pe(), onPreviousClick: ht, onNextClick: he, previousMonth: Y, nextMonth: k }),
        O.map((_, q) => {
          const T = u0(_.date, ae, z, n, i), ze = m0(ae, z, n, i);
          return c.createElement(
            e.Month,
            { className: o[G.Month], style: w == null ? void 0 : w[G.Month], key: q, displayIndex: q, calendarMonth: _ },
            c.createElement(e.MonthCaption, { className: o[G.MonthCaption], style: w == null ? void 0 : w[G.MonthCaption], calendarMonth: _, displayIndex: q }, s != null && s.startsWith("dropdown") ? c.createElement(
              e.DropdownNav,
              { className: o[G.Dropdowns], style: w == null ? void 0 : w[G.Dropdowns] },
              s === "dropdown" || s === "dropdown-months" ? c.createElement(e.MonthsDropdown, { className: o[G.MonthsDropdown], "aria-label": Ze(), classNames: o, components: e, disabled: !!t.disableNavigation, onChange: rt(_.date), options: T, style: w == null ? void 0 : w[G.Dropdown], value: i.getMonth(_.date) }) : c.createElement("span", { role: "status", "aria-live": "polite" }, y(_.date, i)),
              s === "dropdown" || s === "dropdown-years" ? c.createElement(e.YearsDropdown, { className: o[G.YearsDropdown], "aria-label": Ie(i.options), classNames: o, components: e, disabled: !!t.disableNavigation, onChange: St(_.date), options: ze, style: w == null ? void 0 : w[G.Dropdown], value: i.getYear(_.date) }) : c.createElement("span", { role: "status", "aria-live": "polite" }, S(_.date, i))
            ) : c.createElement(e.CaptionLabel, { className: o[G.CaptionLabel], role: "status", "aria-live": "polite" }, x(_.date, i.options, i))),
            c.createElement(
              e.MonthGrid,
              { role: "grid", "aria-multiselectable": l === "multiple" || l === "range", "aria-label": Te(_.date, i.options, i) || void 0, className: o[G.MonthGrid], style: w == null ? void 0 : w[G.MonthGrid] },
              !t.hideWeekdays && c.createElement(
                e.Weekdays,
                { className: o[G.Weekdays], style: w == null ? void 0 : w[G.Weekdays] },
                v && c.createElement(e.WeekNumberHeader, { "aria-label": Xe(i.options), className: o[G.WeekNumberHeader], style: w == null ? void 0 : w[G.WeekNumberHeader], scope: "col" }, I()),
                zt.map((Re, $e) => c.createElement(e.Weekday, { "aria-label": L(Re, i.options, i), className: o[G.Weekday], key: $e, style: w == null ? void 0 : w[G.Weekday], scope: "col" }, M(Re, i.options, i)))
              ),
              c.createElement(e.Weeks, { className: o[G.Weeks], style: w == null ? void 0 : w[G.Weeks] }, _.weeks.map((Re, $e) => c.createElement(
                e.Week,
                { className: o[G.Week], key: Re.weekNumber, style: w == null ? void 0 : w[G.Week], week: Re },
                v && c.createElement(e.WeekNumber, { week: Re, style: w == null ? void 0 : w[G.WeekNumber], "aria-label": Ge(Re.weekNumber, {
                  locale: a
                }), className: o[G.WeekNumber], scope: "row", role: "rowheader" }, H(Re.weekNumber)),
                Re.days.map((we) => {
                  const { date: Be } = we, U = J(we);
                  if (U[ge.focused] = !U.hidden && !!(Ce != null && Ce.isEqualTo(we)), U[Ke.selected] = !U.disabled && ((ee == null ? void 0 : ee(Be)) || U.selected), D1(te)) {
                    const { from: xe, to: De } = te;
                    U[Ke.range_start] = !!(xe && De && i.isSameDay(Be, xe)), U[Ke.range_end] = !!(xe && De && i.isSameDay(Be, De)), U[Ke.range_middle] = pt(te, Be, !0, i);
                  }
                  const Et = d0(U, w, t.modifiersStyles), Dt = Hu(U, o, t.modifiersClassNames), jt = !nt && !U.hidden ? ce(Be, U, i.options, i) : void 0;
                  return c.createElement(e.Day, { key: `${i.format(Be, "yyyy-MM-dd")}_${i.format(we.displayMonth, "yyyy-MM")}`, day: we, modifiers: U, className: Dt.join(" "), style: Et, role: "gridcell", "aria-selected": U.selected || void 0, "aria-label": jt, "data-day": i.format(Be, "yyyy-MM-dd"), "data-month": we.outside ? i.format(Be, "yyyy-MM") : void 0, "data-selected": U.selected || void 0, "data-disabled": U.disabled || void 0, "data-hidden": U.hidden || void 0, "data-outside": we.outside || void 0, "data-focused": U.focused || void 0, "data-today": U.today || void 0 }, !U.hidden && nt ? c.createElement(e.DayButton, { className: o[G.DayButton], style: w == null ? void 0 : w[G.DayButton], type: "button", day: we, modifiers: U, disabled: U.disabled || void 0, tabIndex: Ee(we) ? 0 : -1, "aria-label": Le(Be, U, i.options, i), onClick: At(we, U), onBlur: Rt(we, U), onFocus: Zt(we, U), onKeyDown: Bt(we, U), onMouseEnter: Yt(we, U), onMouseLeave: Vt(we, U) }, V(Be, i.options, i)) : !U.hidden && V(we.date, i.options, i));
                })
              )))
            )
          );
        })
      ),
      t.footer && c.createElement(e.Footer, { className: o[G.Footer], style: w == null ? void 0 : w[G.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const F1 = ({ label: t, sublabel: e, className: n, required: r }) => /* @__PURE__ */ m.jsx(m.Fragment, { children: /* @__PURE__ */ m.jsxs("div", { className: N("label", "flex flex-col gap-1 items-start", n), children: [
  /* @__PURE__ */ m.jsxs("span", { className: " label-text text-slate-600 text-sm font-medium", children: [
    t,
    r && /* @__PURE__ */ m.jsx("span", { className: "text-red-600 ml-0.5", children: "*" })
  ] }),
  e && /* @__PURE__ */ m.jsx("span", { className: "label-text text-slate-400 text-xs font-normal", children: e })
] }) }), Pi = A.forwardRef(
  ({
    className: t,
    label: e,
    helpText: n,
    suffixIcon: r,
    prefixIcon: i,
    hasError: a,
    onChange: o,
    type: s = "text",
    labelClassName: l,
    minVal: u,
    maxVal: d,
    required: f,
    sublabel: p,
    ...h
  }, b) => {
    const C = (g, v) => /* @__PURE__ */ m.jsx(
      "span",
      {
        className: N(
          "absolute h-[40px] flex items-center",
          v === "left" && "left-2.5",
          v === "right" && "right-2.5"
        ),
        children: A.cloneElement(g, {
          size: "16",
          className: a ? "fill-red-600" : "fill-slate-500"
        })
      }
    );
    return /* @__PURE__ */ m.jsxs("div", { className: "", children: [
      e && /* @__PURE__ */ m.jsx(F1, { label: e, sublabel: p, className: l, required: f }),
      /* @__PURE__ */ m.jsxs("label", { className: "form-control w-full flex relative", children: [
        i && C(i, "left"),
        /* @__PURE__ */ m.jsx(
          "input",
          {
            type: s,
            min: s === "number" ? u : void 0,
            max: s === "number" ? d : void 0,
            className: N(
              s !== "file" && "px-3.5 py-2.5",
              "h-[38px] min-h-[38px] rounded-lg gap-2 w-full border-box",
              "text-sm font-normal",
              "shadow border border-slate-300 text-black placeholder:text-slate-400",
              "focus:outline-0 focus:border focus:border-blue-500",
              "disabled:bg-slate-50 disabled:text-slate-400",
              i && "pl-8",
              r && "pr-8",
              a && "border-red-500 focus:border-red-500",
              s === "file" && "file-input file-input-bordered file-input-primary",
              t
            ),
            onChange: o,
            ref: b,
            required: f,
            ...h
          }
        ),
        r && C(r, "right")
      ] }),
      n && /* @__PURE__ */ m.jsx("div", { className: "label", children: /* @__PURE__ */ m.jsx(
        "span",
        {
          className: N(
            "label-text-alt text-slate-500 text-xs font-normal",
            a && "text-red-600"
          ),
          children: n
        }
      ) })
    ] });
  }
);
Pi.displayName = "Input";
const Y9 = (t) => {
  const { onSelect: e, defaultDateRange: n } = t, [r, i] = $(() => {
    if (n)
      return {
        from: mr(n.from),
        to: mr(n.to)
      };
  }), [a, o] = $(!1), s = Ni(), l = pe(null);
  ci(l, () => {
    o(!1);
  }), Q(() => {
    !a && (r != null && r.from) && (r != null && r.to) && e(hn(r.from, "yyyy-MM-dd"), hn(r.to, "yyyy-MM-dd"));
  }, [r, a, e]);
  const u = {
    before: new Date(2024, 0, 1),
    after: /* @__PURE__ */ new Date()
  }, d = "d LLL, yyyy", f = () => !(r != null && r.from) || !(r != null && r.to) ? "Select Dates" : `${hn(r.from, d)} - ${hn(r.to, d)}`, p = (C) => {
    if (C === null)
      return new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1);
    if (typeof C != "number")
      return /* @__PURE__ */ new Date();
    const g = /* @__PURE__ */ new Date();
    return g.setDate(g.getDate() - C), g;
  }, h = [
    {
      label: "7 days",
      value: 7
    },
    {
      label: "30 days",
      value: 30
    },
    {
      label: "3 months",
      value: 90
    },
    {
      label: "6 months",
      value: 180
    },
    {
      label: "This year",
      value: null
    }
  ], b = (C) => {
    i({ from: p(C), to: /* @__PURE__ */ new Date() }), o(!1);
  };
  return /* @__PURE__ */ m.jsxs("div", { className: "relative w-56", ref: l, children: [
    /* @__PURE__ */ m.jsx(
      "div",
      {
        className: ri(
          "absolute top-10 left-0 z-10 bg-white w-[46rem]",
          "shadow-lg p-4 border border-slate-200 rounded-lg",
          "transition-opacity ease-in-out delay-150 duration-300",
          {
            "opacity-100 block": a,
            "opacity-0 hidden": !a
          }
        ),
        children: /* @__PURE__ */ m.jsxs("div", { className: "flex justify-between", children: [
          /* @__PURE__ */ m.jsx(
            _0,
            {
              disabled: u,
              selected: r,
              onSelect: i,
              captionLayout: "label",
              min: 0,
              mode: "range",
              numberOfMonths: 2,
              pagedNavigation: !0,
              required: !0,
              "data-testid": "date-range-picker",
              classNames: {
                ...s,
                root: `${s.root}`,
                // Add a shadow to the root element
                chevron: "fill-blue-500",
                day_button: "w-6 h-6 hover:font-semibold",
                day: "p-2",
                today: `${s.today} text-blue-500`,
                selected: "bg-blue-500 border-blue-500 text-white hover:text-blue-800",
                range_end: "bg-blue-500 rounded-r-[50%]",
                range_middle: "bg-blue-400",
                range_start: "bg-blue-500 rounded-l-[50%]"
              }
            }
          ),
          /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col gap-2 pt-4", children: [
            /* @__PURE__ */ m.jsx("span", { className: "text-sm text-slate-500", children: "Last" }),
            h.map((C) => /* @__PURE__ */ m.jsx(
              ut,
              {
                variant: "secondary",
                size: "sm",
                className: "text-xs",
                onClick: () => b(C.value),
                children: C.label
              },
              C.value
            )),
            /* @__PURE__ */ m.jsx(
              ut,
              {
                variant: "primary",
                size: "sm",
                className: "text-xs",
                onClick: () => o(!1),
                children: "Apply"
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ m.jsx(
      Pi,
      {
        type: "text",
        prefixIcon: /* @__PURE__ */ m.jsx(Ae, { icon: "RiCalendarLine" }),
        readOnly: !0,
        className: "cursor-pointer",
        onClick: () => o(!0),
        value: f()
      }
    )
  ] });
}, j9 = () => /* @__PURE__ */ m.jsx("div", { className: "h-[1.5px] bg-gray-200 w-full" }), J9 = ({ isOpen: t, children: e, size: n = "md", side: r = "right", className: i }) => /* @__PURE__ */ m.jsx(
  "div",
  {
    className: ri(
      {
        "w-[300px]": n === "sm",
        "w-[460px]": n === "md",
        "w-[600px]": n === "lg"
      },
      "absolute top-0 h-full bg-white",
      "transition-all duration-300 ease-in-out",
      r === "left" ? "left-0" : "right-0",
      {
        "shadow-none": !t,
        "shadow-lg": t
      },
      {
        "translate-x-0": t && r === "right",
        "translate-x-full": !t && r === "right",
        "-translate-x-0": t && r === "left",
        "-translate-x-full": !t && r === "left"
      },
      i
    ),
    children: e
  }
), U0 = tt("dropdown", {
  variants: {
    placement: {
      default: "",
      top: "dropdown-top dropdown-start",
      left: "dropdown-left",
      right: "dropdown-right",
      bottom: "dropdown-bottom dropdown-start",
      "bottom-end": "dropdown-bottom dropdown-end",
      "top-end": "dropdown-top dropdown-end"
    }
  },
  defaultVariants: {
    placement: "default"
  }
});
function _9(t) {
  const { items: e, buttonLabel: n, buttonClassNames: r, itemClassNames: i, placement: a, className: o } = t, s = ({ label: l, onClick: u, disabled: d }, f) => /* @__PURE__ */ m.jsx("li", { className: N(i), children: /* @__PURE__ */ m.jsx(
    "a",
    {
      onClick: d ? void 0 : u,
      className: N(
        d && "opacity-50 cursor-not-allowed pointer-events-none text-slate-500"
      ),
      children: l
    }
  ) }, f);
  return /* @__PURE__ */ m.jsxs("div", { className: N(U0({ placement: a, className: o })), children: [
    /* @__PURE__ */ m.jsx("div", { tabIndex: 0, role: "button", className: N("btn m-1", r), children: n }),
    /* @__PURE__ */ m.jsx(
      "ul",
      {
        tabIndex: 0,
        className: "dropdown-content z-[9999] menu p-2 shadow bg-base-100 rounded-box w-52",
        children: e.map(s)
      }
    )
  ] });
}
const U9 = ({ files: t, onDelete: e, generalProgress: n = void 0 }) => {
  const r = (i, a) => {
    const o = !i.error && i.progress && i.progress > 0 && i.progress < 100;
    return /* @__PURE__ */ m.jsxs(
      "div",
      {
        className: "flex flex-row items-center gap-4 px-4 py-2 border border-gray-200 rounded-md file-list-item",
        children: [
          /* @__PURE__ */ m.jsx("div", { children: /* @__PURE__ */ m.jsx(Ae, { icon: "RiFileLine" }) }),
          /* @__PURE__ */ m.jsxs("div", { className: "flex flex-1 flex-col", children: [
            /* @__PURE__ */ m.jsx("div", { children: i.name }),
            /* @__PURE__ */ m.jsxs("div", { className: "w-full pr-4", children: [
              i.error && /* @__PURE__ */ m.jsx("div", { className: "text-red-600 text-sm", children: i.error }),
              o && /* @__PURE__ */ m.jsx("progress", { className: "progress progress-info", value: i.progress, max: "100" }),
              !o && !i.error && /* @__PURE__ */ m.jsxs("div", { className: "text-sm text-gray-500", children: [
                i.size ? (i.size / 1024 / 1024).toFixed(2) : "0.00",
                "MB"
              ] })
            ] })
          ] }),
          /* @__PURE__ */ m.jsx("div", { className: "ml-auto", children: /* @__PURE__ */ m.jsx(ut, { variant: "secondary", size: null, shape: "squareSm", onClick: () => e(i), children: /* @__PURE__ */ m.jsx(Ae, { icon: "RiDeleteBinLine", size: 16, className: "fill-red-600" }) }) })
        ]
      },
      a
    );
  };
  return /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col gap-2", children: [
    n && /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col gap-1 pb-2", children: [
      /* @__PURE__ */ m.jsx("div", { children: "Uploading files..." }),
      /* @__PURE__ */ m.jsx("progress", { className: "progress progress-info", value: n, max: "100" })
    ] }),
    t.map((i, a) => r(i, a))
  ] });
}, $9 = ({
  label: t,
  onChange: e,
  isMultiple: n = !1,
  accept: r = [".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx", ".txt"],
  maxSizeMb: i = 2,
  // Default max size to 2MB
  onError: a = void 0,
  translations: o = {
    dropFilesHere: "Drop files here or",
    chooseFiles: "Choose Files",
    someFilesExceedMaxSize: "Some files exceed the maximum size of",
    supportedFileTypes: "Supported file types:",
    maxFileSize: "Maximum file size"
  }
}) => {
  const s = pe(null), [l, u] = $(!1), [d, f] = $(null);
  Q(() => {
    d && (a == null || a(d));
  }, [d, a]);
  const p = (g) => {
    const v = g.target.files;
    if (v) {
      const w = Array.from(v).filter((x) => x.size <= i * 1024 * 1024);
      if (w.length !== v.length) {
        f(`Some files exceed the maximum size of ${i}MB.`);
        return;
      }
      n ? e(w) : w.length > 0 && e([w[0]]);
    }
  }, h = (g) => {
    g.preventDefault(), g.stopPropagation(), u(!0);
  }, b = (g) => {
    g.preventDefault(), g.stopPropagation();
    const v = g.currentTarget.getBoundingClientRect(), w = g.clientX, x = g.clientY;
    (w <= v.left || w >= v.right || x <= v.top || x >= v.bottom) && u(!1);
  }, C = (g) => {
    g.preventDefault(), g.stopPropagation();
    const v = g.dataTransfer.files;
    if (v) {
      const w = Array.from(v).filter((x) => x.size <= i * 1024 * 1024);
      if (w.length !== v.length && f(`Some files exceed the maximum size of ${i}MB.`), w.length > 0) {
        const x = new Event("change", { bubbles: !0 });
        Object.defineProperty(x, "target", {
          value: { files: w }
        }), p({ target: { files: w } });
      }
    }
    u(!1);
  };
  return /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col gap-2", children: [
    t && /* @__PURE__ */ m.jsx("label", { className: "text-sm font-medium text-gray-700", children: t }),
    /* @__PURE__ */ m.jsx(
      "input",
      {
        type: "file",
        onChange: p,
        className: "invisible",
        ref: s,
        multiple: n,
        accept: r.join(",")
      }
    ),
    /* @__PURE__ */ m.jsxs(
      "div",
      {
        className: N(
          "flex flex-col items-center justify-center gap-4 border border-dashed border-gray-200 rounded-md p-4 relative w-full",
          {
            "border-blue-500": l
          }
        ),
        onDragOver: h,
        onDragLeave: b,
        onDrop: C,
        children: [
          /* @__PURE__ */ m.jsx("div", { children: o.dropFilesHere }),
          /* @__PURE__ */ m.jsx(
            ut,
            {
              variant: "secondaryBlue",
              size: "sm",
              onClick: (g) => {
                var v;
                g.preventDefault(), (v = s.current) == null || v.click();
              },
              children: o.chooseFiles
            }
          ),
          /* @__PURE__ */ m.jsxs("div", { className: "text-sm text-gray-500 text-center", children: [
            o.maxFileSize,
            " ",
            i,
            "MB ",
            /* @__PURE__ */ m.jsx("br", {}),
            o.supportedFileTypes,
            " ",
            r.join(", ")
          ] }),
          /* @__PURE__ */ m.jsx(
            "div",
            {
              className: N(
                "absolute inset-0 bg-white/90 rounded-md transition-opacity duration-300 z-10",
                {
                  hidden: !l
                }
              ),
              children: /* @__PURE__ */ m.jsx("div", { className: "flex items-center justify-center h-full", children: /* @__PURE__ */ m.jsx("p", { className: "text-gray-500 text-sm block", children: o.dropFilesHere }) })
            }
          )
        ]
      }
    ),
    d && /* @__PURE__ */ m.jsx("p", { className: "text-red-500 text-sm", children: d })
  ] });
}, br = tt("", {
  variants: {
    inputSize: {
      md: "w-5 h-5",
      sm: "w-4 h-4"
    }
  },
  defaultVariants: {
    inputSize: "sm"
  }
}), Q9 = ({
  className: t,
  label: e,
  disabled: n,
  helpText: r,
  indeterminate: i = !1,
  inputSize: a,
  checked: o = !1,
  onChange: s,
  type: l,
  ...u
}) => {
  const d = A.useRef(null);
  A.useEffect(() => {
    d.current.indeterminate = i;
  }, [i]);
  const f = "shadow-[0px_0px_0px_2px_rgb(219,234,254)]";
  return /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ m.jsxs("label", { className: "flex items-center gap-2 cursor-pointer relative", children: [
      l === "checkbox" && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
        o && /* @__PURE__ */ m.jsx(
          Ae,
          {
            icon: "RiCheckFill",
            className: N(
              "fill-white z-10 absolute",
              a === "md" ? "left-[2px] top-[2px]" : "left-0 top-0"
            ),
            size: pn.xs
          }
        ),
        i && !o && /* @__PURE__ */ m.jsx(
          Ae,
          {
            icon: "RiSubtractFill",
            className: N(
              "fill-white z-10 absolute",
              a === "md" ? "left-[2px] top-[2px]" : "left-0 top-0"
            ),
            size: pn.xs
          }
        )
      ] }),
      l === "radio" && o && /* @__PURE__ */ m.jsx(
        "div",
        {
          className: N(
            "bg-blue-700 rounded-full absolute z-10",
            a === "md" ? "w-2 h-2 left-[6px] top-[6px]" : "w-1.5 h-1.5 left-[5px]"
          )
        }
      ),
      /* @__PURE__ */ m.jsx(
        "input",
        {
          type: l,
          className: N(
            "appearance-none cursor-pointer",
            br({ inputSize: a }),
            "relative bg-white border border-slate-300 rounded outline-none",
            "flex items-center justify-center",
            !o && "hover:bg-blue-50 hover:border-blue-800",
            o && "hover:border-blue-800",
            `active:border-blue-300 active:${f}`,
            `focus:border-blue-300 focus:${f}`,
            "disabled:!bg-slate-100 disabled:!border-slate-200",
            "checked:border-blue-700",
            l === "checkbox" && "checked:bg-blue-700 indeterminate:bg-blue-700 indeterminate:border-blue-700",
            l === "radio" && "rounded-full hover:bg-blue-50 checked:bg-blue-50",
            t
          ),
          onChange: s,
          ref: d,
          disabled: n,
          checked: o,
          ...u
        }
      ),
      e && /* @__PURE__ */ m.jsx(
        "span",
        {
          className: N(
            "text-slate-700 text-sm font-medium leading-tight",
            n && "text-slate-300"
          ),
          children: e
        }
      )
    ] }),
    r && /* @__PURE__ */ m.jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ m.jsx("div", { className: N(br({ inputSize: a }), "flex-shrink-0") }),
      /* @__PURE__ */ m.jsx("span", { className: "text-slate-500 text-sm font-normal", children: r })
    ] })
  ] });
}, K9 = ({
  children: t,
  title: e,
  hint: n = null,
  isRequired: r = !1,
  className: i,
  showSeparator: a = !1
}) => /* @__PURE__ */ m.jsxs("div", { className: N("py-4 flex flex-col gap-2", i), children: [
  /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ m.jsxs("h5", { className: "text-lg font-medium leading-5 text-gray-600", children: [
      e,
      r && /* @__PURE__ */ m.jsx("span", { className: "text-red-500 ml-0.5", children: "*" })
    ] }),
    n !== null && /* @__PURE__ */ m.jsx("div", { className: "text-gray-400", children: n })
  ] }),
  t,
  a && /* @__PURE__ */ m.jsx("hr", { className: "mt-4" })
] }), q9 = ({
  value: t,
  pillClassName: e,
  className: n,
  onChange: r,
  error: i,
  required: a,
  label: o,
  placeholder: s = "Type to add an item",
  helperText: l = "Hit enter or click + to add a new item"
}) => {
  const [u, d] = $(t ?? []), [f, p] = $("");
  Q(() => {
    r && r(u);
  }, [u]);
  const h = () => {
    f && (d([...u, f]), p(""));
  }, b = (C) => {
    const g = [...u].filter((v, w) => w !== C);
    d(g);
  };
  return /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col gap-1", children: [
    o && /* @__PURE__ */ m.jsxs("div", { className: "text-sm font-medium text-slate-700", children: [
      o,
      " ",
      a && /* @__PURE__ */ m.jsx("span", { className: "text-red-500", children: "*" })
    ] }),
    /* @__PURE__ */ m.jsxs(
      "div",
      {
        className: N(
          "relative flex gap-2 items-center",
          "shadow border border-slate-300 px-1 py-1 min-h-[38px] rounded-lg",
          i && "border-red-500",
          n
        ),
        children: [
          /* @__PURE__ */ m.jsx("div", { className: "flex gap-2 flex-wrap", children: u.map((C, g) => /* @__PURE__ */ m.jsxs(
            "div",
            {
              className: N(
                "bg-slate-100 rounded-lg flex gap-1 px-1 text-sm items-center",
                e
              ),
              children: [
                /* @__PURE__ */ m.jsx("span", { className: "py-0.5 px-1.5", children: C }),
                /* @__PURE__ */ m.jsx(
                  Ae,
                  {
                    icon: "RiCloseFill",
                    className: "cursor-pointer rounded-full hover:bg-slate-300",
                    size: 16,
                    onClick: () => b(g)
                  }
                )
              ]
            },
            g
          )) }),
          /* @__PURE__ */ m.jsx(
            "input",
            {
              className: N(
                "text-sm font-normal",
                "border-none shadow-none",
                "focus:outline-none focus:ring-0 focus:ring-offset-0",
                "placeholder:text-xs"
              ),
              placeholder: s,
              value: f,
              onChange: (C) => p(C.target.value),
              onKeyDown: (C) => {
                C.key === "Enter" && (h(), C.preventDefault());
              }
            }
          ),
          /* @__PURE__ */ m.jsx("div", { className: "ml-auto", children: /* @__PURE__ */ m.jsx(
            Ae,
            {
              icon: "RiAddFill",
              size: 16,
              className: "cursor-pointer rounded-full hover:bg-slate-300",
              onClick: h
            }
          ) })
        ]
      }
    ),
    l && /* @__PURE__ */ m.jsx("div", { className: "text-xs text-slate-500", children: l }),
    i && /* @__PURE__ */ m.jsx("div", { className: "text-xs text-red-500", children: i })
  ] });
};
function Wt(t) {
  "@babel/helpers - typeof";
  return Wt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Wt(t);
}
function $0(t, e) {
  if (Wt(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (Wt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Wi(t) {
  var e = $0(t, "string");
  return Wt(e) == "symbol" ? e : e + "";
}
function Cn(t, e, n) {
  return (e = Wi(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function pr(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function B(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? pr(Object(n), !0).forEach(function(r) {
      Cn(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : pr(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Q0(t) {
  if (Array.isArray(t)) return t;
}
function K0(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], l = !0, u = !1;
    try {
      if (a = (n = n.call(t)).next, e === 0) {
        if (Object(n) !== n) return;
        l = !1;
      } else for (; !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== e); l = !0) ;
    } catch (d) {
      u = !0, i = d;
    } finally {
      try {
        if (!l && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (u) throw i;
      }
    }
    return s;
  }
}
function w1(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function ki(t, e) {
  if (t) {
    if (typeof t == "string") return w1(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? w1(t, e) : void 0;
  }
}
function q0() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wt(t, e) {
  return Q0(t) || K0(t, e) || ki(t, e) || q0();
}
function e4(t, e) {
  if (t == null) return {};
  var n = {};
  for (var r in t) if ({}.hasOwnProperty.call(t, r)) {
    if (e.includes(r)) continue;
    n[r] = t[r];
  }
  return n;
}
function It(t, e) {
  if (t == null) return {};
  var n, r, i = e4(t, e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (r = 0; r < a.length; r++) n = a[r], e.includes(n) || {}.propertyIsEnumerable.call(t, n) && (i[n] = t[n]);
  }
  return i;
}
var t4 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function n4(t) {
  var e = t.defaultInputValue, n = e === void 0 ? "" : e, r = t.defaultMenuIsOpen, i = r === void 0 ? !1 : r, a = t.defaultValue, o = a === void 0 ? null : a, s = t.inputValue, l = t.menuIsOpen, u = t.onChange, d = t.onInputChange, f = t.onMenuClose, p = t.onMenuOpen, h = t.value, b = It(t, t4), C = $(s !== void 0 ? s : n), g = wt(C, 2), v = g[0], w = g[1], x = $(l !== void 0 ? l : i), V = wt(x, 2), y = V[0], H = V[1], I = $(h !== void 0 ? h : o), M = wt(I, 2), S = M[0], Z = M[1], W = me(function(J, ee) {
    typeof u == "function" && u(J, ee), Z(J);
  }, [u]), O = me(function(J, ee) {
    var de;
    typeof d == "function" && (de = d(J, ee)), w(de !== void 0 ? de : J);
  }, [d]), ae = me(function() {
    typeof p == "function" && p(), H(!0);
  }, [p]), z = me(function() {
    typeof f == "function" && f(), H(!1);
  }, [f]), Y = s !== void 0 ? s : v, k = l !== void 0 ? l : y, j = h !== void 0 ? h : S;
  return B(B({}, b), {}, {
    inputValue: Y,
    menuIsOpen: k,
    onChange: W,
    onInputChange: O,
    onMenuClose: z,
    onMenuOpen: ae,
    value: j
  });
}
function D() {
  return D = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, D.apply(null, arguments);
}
function r4(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function vr(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, Wi(r.key), r);
  }
}
function i4(t, e, n) {
  return vr(t.prototype, e), vr(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function x1(t, e) {
  return x1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, x1(t, e);
}
function a4(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && x1(t, e);
}
function kn(t) {
  return kn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, kn(t);
}
function Xi() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Xi = function() {
    return !!t;
  })();
}
function o4(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function s4(t, e) {
  if (e && (Wt(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return o4(t);
}
function l4(t) {
  var e = Xi();
  return function() {
    var n, r = kn(t);
    if (e) {
      var i = kn(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return s4(this, n);
  };
}
function c4(t) {
  if (Array.isArray(t)) return w1(t);
}
function u4(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function d4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function O1(t) {
  return c4(t) || u4(t) || ki(t) || d4();
}
function f4(t) {
  if (t.sheet)
    return t.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === t)
      return document.styleSheets[e];
}
function m4(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var g4 = /* @__PURE__ */ function() {
  function t(n) {
    var r = this;
    this._insertTag = function(i) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, a), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, e.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(m4(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = f4(i);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(r) {
      var i;
      return (i = r.parentNode) == null ? void 0 : i.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(), Oe = "-ms-", Xn = "-moz-", re = "-webkit-", zi = "comm", T1 = "rule", P1 = "decl", h4 = "@import", Yi = "@keyframes", C4 = "@layer", b4 = Math.abs, Kn = String.fromCharCode, p4 = Object.assign;
function v4(t, e) {
  return Se(t, 0) ^ 45 ? (((e << 2 ^ Se(t, 0)) << 2 ^ Se(t, 1)) << 2 ^ Se(t, 2)) << 2 ^ Se(t, 3) : 0;
}
function ji(t) {
  return t.trim();
}
function w4(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function ie(t, e, n) {
  return t.replace(e, n);
}
function y1(t, e) {
  return t.indexOf(e);
}
function Se(t, e) {
  return t.charCodeAt(e) | 0;
}
function xn(t, e, n) {
  return t.slice(e, n);
}
function ot(t) {
  return t.length;
}
function W1(t) {
  return t.length;
}
function Rn(t, e) {
  return e.push(t), t;
}
function x4(t, e) {
  return t.map(e).join("");
}
var qn = 1, qt = 1, Ji = 0, ke = 0, Ve = 0, an = "";
function e1(t, e, n, r, i, a, o) {
  return { value: t, root: e, parent: n, type: r, props: i, children: a, line: qn, column: qt, length: o, return: "" };
}
function fn(t, e) {
  return p4(e1("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function y4() {
  return Ve;
}
function I4() {
  return Ve = ke > 0 ? Se(an, --ke) : 0, qt--, Ve === 10 && (qt = 1, qn--), Ve;
}
function je() {
  return Ve = ke < Ji ? Se(an, ke++) : 0, qt++, Ve === 10 && (qt = 1, qn++), Ve;
}
function dt() {
  return Se(an, ke);
}
function Fn() {
  return ke;
}
function En(t, e) {
  return xn(an, t, e);
}
function yn(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function _i(t) {
  return qn = qt = 1, Ji = ot(an = t), ke = 0, [];
}
function Ui(t) {
  return an = "", t;
}
function On(t) {
  return ji(En(ke - 1, I1(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function V4(t) {
  for (; (Ve = dt()) && Ve < 33; )
    je();
  return yn(t) > 2 || yn(Ve) > 3 ? "" : " ";
}
function H4(t, e) {
  for (; --e && je() && !(Ve < 48 || Ve > 102 || Ve > 57 && Ve < 65 || Ve > 70 && Ve < 97); )
    ;
  return En(t, Fn() + (e < 6 && dt() == 32 && je() == 32));
}
function I1(t) {
  for (; je(); )
    switch (Ve) {
      case t:
        return ke;
      case 34:
      case 39:
        t !== 34 && t !== 39 && I1(Ve);
        break;
      case 40:
        t === 41 && I1(t);
        break;
      case 92:
        je();
        break;
    }
  return ke;
}
function M4(t, e) {
  for (; je() && t + Ve !== 57; )
    if (t + Ve === 84 && dt() === 47)
      break;
  return "/*" + En(e, ke - 1) + "*" + Kn(t === 47 ? t : je());
}
function E4(t) {
  for (; !yn(dt()); )
    je();
  return En(t, ke);
}
function N4(t) {
  return Ui(Tn("", null, null, null, [""], t = _i(t), 0, [0], t));
}
function Tn(t, e, n, r, i, a, o, s, l) {
  for (var u = 0, d = 0, f = o, p = 0, h = 0, b = 0, C = 1, g = 1, v = 1, w = 0, x = "", V = i, y = a, H = r, I = x; g; )
    switch (b = w, w = je()) {
      case 40:
        if (b != 108 && Se(I, f - 1) == 58) {
          y1(I += ie(On(w), "&", "&\f"), "&\f") != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        I += On(w);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        I += V4(b);
        break;
      case 92:
        I += H4(Fn() - 1, 7);
        continue;
      case 47:
        switch (dt()) {
          case 42:
          case 47:
            Rn(L4(M4(je(), Fn()), e, n), l);
            break;
          default:
            I += "/";
        }
        break;
      case 123 * C:
        s[u++] = ot(I) * v;
      case 125 * C:
      case 59:
      case 0:
        switch (w) {
          case 0:
          case 125:
            g = 0;
          case 59 + d:
            v == -1 && (I = ie(I, /\f/g, "")), h > 0 && ot(I) - f && Rn(h > 32 ? xr(I + ";", r, n, f - 1) : xr(ie(I, " ", "") + ";", r, n, f - 2), l);
            break;
          case 59:
            I += ";";
          default:
            if (Rn(H = wr(I, e, n, u, d, i, s, x, V = [], y = [], f), a), w === 123)
              if (d === 0)
                Tn(I, e, H, H, V, a, f, s, y);
              else
                switch (p === 99 && Se(I, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Tn(t, H, H, r && Rn(wr(t, H, H, 0, 0, i, s, x, i, V = [], f), y), i, y, f, s, r ? V : y);
                    break;
                  default:
                    Tn(I, H, H, H, [""], y, 0, s, y);
                }
        }
        u = d = h = 0, C = v = 1, x = I = "", f = o;
        break;
      case 58:
        f = 1 + ot(I), h = b;
      default:
        if (C < 1) {
          if (w == 123)
            --C;
          else if (w == 125 && C++ == 0 && I4() == 125)
            continue;
        }
        switch (I += Kn(w), w * C) {
          case 38:
            v = d > 0 ? 1 : (I += "\f", -1);
            break;
          case 44:
            s[u++] = (ot(I) - 1) * v, v = 1;
            break;
          case 64:
            dt() === 45 && (I += On(je())), p = dt(), d = f = ot(x = I += E4(Fn())), w++;
            break;
          case 45:
            b === 45 && ot(I) == 2 && (C = 0);
        }
    }
  return a;
}
function wr(t, e, n, r, i, a, o, s, l, u, d) {
  for (var f = i - 1, p = i === 0 ? a : [""], h = W1(p), b = 0, C = 0, g = 0; b < r; ++b)
    for (var v = 0, w = xn(t, f + 1, f = b4(C = o[b])), x = t; v < h; ++v)
      (x = ji(C > 0 ? p[v] + " " + w : ie(w, /&\f/g, p[v]))) && (l[g++] = x);
  return e1(t, e, n, i === 0 ? T1 : s, l, u, d);
}
function L4(t, e, n) {
  return e1(t, e, n, zi, Kn(y4()), xn(t, 2, -2), 0);
}
function xr(t, e, n, r) {
  return e1(t, e, n, P1, xn(t, 0, r), xn(t, r + 1, -1), r);
}
function $t(t, e) {
  for (var n = "", r = W1(t), i = 0; i < r; i++)
    n += e(t[i], i, t, e) || "";
  return n;
}
function A4(t, e, n, r) {
  switch (t.type) {
    case C4:
      if (t.children.length) break;
    case h4:
    case P1:
      return t.return = t.return || t.value;
    case zi:
      return "";
    case Yi:
      return t.return = t.value + "{" + $t(t.children, r) + "}";
    case T1:
      t.value = t.props.join(",");
  }
  return ot(n = $t(t.children, r)) ? t.return = t.value + "{" + n + "}" : "";
}
function Z4(t) {
  var e = W1(t);
  return function(n, r, i, a) {
    for (var o = "", s = 0; s < e; s++)
      o += t[s](n, r, i, a) || "";
    return o;
  };
}
function R4(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function B4(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var S4 = function(e, n, r) {
  for (var i = 0, a = 0; i = a, a = dt(), i === 38 && a === 12 && (n[r] = 1), !yn(a); )
    je();
  return En(e, ke);
}, G4 = function(e, n) {
  var r = -1, i = 44;
  do
    switch (yn(i)) {
      case 0:
        i === 38 && dt() === 12 && (n[r] = 1), e[r] += S4(ke - 1, n, r);
        break;
      case 2:
        e[r] += On(i);
        break;
      case 4:
        if (i === 44) {
          e[++r] = dt() === 58 ? "&\f" : "", n[r] = e[r].length;
          break;
        }
      default:
        e[r] += Kn(i);
    }
  while (i = je());
  return e;
}, D4 = function(e, n) {
  return Ui(G4(_i(e), n));
}, yr = /* @__PURE__ */ new WeakMap(), F4 = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var n = e.value, r = e.parent, i = e.column === r.column && e.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(e.props.length === 1 && n.charCodeAt(0) !== 58 && !yr.get(r)) && !i) {
      yr.set(e, !0);
      for (var a = [], o = D4(n, a), s = r.props, l = 0, u = 0; l < o.length; l++)
        for (var d = 0; d < s.length; d++, u++)
          e.props[u] = a[l] ? o[l].replace(/&\f/g, s[d]) : s[d] + " " + o[l];
    }
  }
}, O4 = function(e) {
  if (e.type === "decl") {
    var n = e.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
};
function $i(t, e) {
  switch (v4(t, e)) {
    case 5103:
      return re + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return re + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return re + t + Xn + t + Oe + t + t;
    case 6828:
    case 4268:
      return re + t + Oe + t + t;
    case 6165:
      return re + t + Oe + "flex-" + t + t;
    case 5187:
      return re + t + ie(t, /(\w+).+(:[^]+)/, re + "box-$1$2" + Oe + "flex-$1$2") + t;
    case 5443:
      return re + t + Oe + "flex-item-" + ie(t, /flex-|-self/, "") + t;
    case 4675:
      return re + t + Oe + "flex-line-pack" + ie(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return re + t + Oe + ie(t, "shrink", "negative") + t;
    case 5292:
      return re + t + Oe + ie(t, "basis", "preferred-size") + t;
    case 6060:
      return re + "box-" + ie(t, "-grow", "") + re + t + Oe + ie(t, "grow", "positive") + t;
    case 4554:
      return re + ie(t, /([^-])(transform)/g, "$1" + re + "$2") + t;
    case 6187:
      return ie(ie(ie(t, /(zoom-|grab)/, re + "$1"), /(image-set)/, re + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return ie(t, /(image-set\([^]*)/, re + "$1$`$1");
    case 4968:
      return ie(ie(t, /(.+:)(flex-)?(.*)/, re + "box-pack:$3" + Oe + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + re + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ie(t, /(.+)-inline(.+)/, re + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ot(t) - 1 - e > 6) switch (Se(t, e + 1)) {
        case 109:
          if (Se(t, e + 4) !== 45) break;
        case 102:
          return ie(t, /(.+:)(.+)-([^]+)/, "$1" + re + "$2-$3$1" + Xn + (Se(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
        case 115:
          return ~y1(t, "stretch") ? $i(ie(t, "stretch", "fill-available"), e) + t : t;
      }
      break;
    case 4949:
      if (Se(t, e + 1) !== 115) break;
    case 6444:
      switch (Se(t, ot(t) - 3 - (~y1(t, "!important") && 10))) {
        case 107:
          return ie(t, ":", ":" + re) + t;
        case 101:
          return ie(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + re + (Se(t, 14) === 45 ? "inline-" : "") + "box$3$1" + re + "$2$3$1" + Oe + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (Se(t, e + 11)) {
        case 114:
          return re + t + Oe + ie(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return re + t + Oe + ie(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return re + t + Oe + ie(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return re + t + Oe + t + t;
  }
  return t;
}
var T4 = function(e, n, r, i) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case P1:
      e.return = $i(e.value, e.length);
      break;
    case Yi:
      return $t([fn(e, {
        value: ie(e.value, "@", "@" + re)
      })], i);
    case T1:
      if (e.length) return x4(e.props, function(a) {
        switch (w4(a, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return $t([fn(e, {
              props: [ie(a, /:(read-\w+)/, ":" + Xn + "$1")]
            })], i);
          case "::placeholder":
            return $t([fn(e, {
              props: [ie(a, /:(plac\w+)/, ":" + re + "input-$1")]
            }), fn(e, {
              props: [ie(a, /:(plac\w+)/, ":" + Xn + "$1")]
            }), fn(e, {
              props: [ie(a, /:(plac\w+)/, Oe + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, P4 = [T4], W4 = function(e) {
  var n = e.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(C) {
      var g = C.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(C), C.setAttribute("data-s", ""));
    });
  }
  var i = e.stylisPlugins || P4, a = {}, o, s = [];
  o = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(C) {
      for (var g = C.getAttribute("data-emotion").split(" "), v = 1; v < g.length; v++)
        a[g[v]] = !0;
      s.push(C);
    }
  );
  var l, u = [F4, O4];
  {
    var d, f = [A4, R4(function(C) {
      d.insert(C);
    })], p = Z4(u.concat(i, f)), h = function(g) {
      return $t(N4(g), p);
    };
    l = function(g, v, w, x) {
      d = w, h(g ? g + "{" + v.styles + "}" : v.styles), x && (b.inserted[v.name] = !0);
    };
  }
  var b = {
    key: n,
    sheet: new g4({
      key: n,
      container: o,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: a,
    registered: {},
    insert: l
  };
  return b.sheet.hydrate(s), b;
}, V1 = { exports: {} }, oe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function k4() {
  if (Ir) return oe;
  Ir = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, b = t ? Symbol.for("react.lazy") : 60116, C = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, w = t ? Symbol.for("react.scope") : 60119;
  function x(y) {
    if (typeof y == "object" && y !== null) {
      var H = y.$$typeof;
      switch (H) {
        case e:
          switch (y = y.type, y) {
            case l:
            case u:
            case r:
            case a:
            case i:
            case f:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case d:
                case b:
                case h:
                case o:
                  return y;
                default:
                  return H;
              }
          }
        case n:
          return H;
      }
    }
  }
  function V(y) {
    return x(y) === u;
  }
  return oe.AsyncMode = l, oe.ConcurrentMode = u, oe.ContextConsumer = s, oe.ContextProvider = o, oe.Element = e, oe.ForwardRef = d, oe.Fragment = r, oe.Lazy = b, oe.Memo = h, oe.Portal = n, oe.Profiler = a, oe.StrictMode = i, oe.Suspense = f, oe.isAsyncMode = function(y) {
    return V(y) || x(y) === l;
  }, oe.isConcurrentMode = V, oe.isContextConsumer = function(y) {
    return x(y) === s;
  }, oe.isContextProvider = function(y) {
    return x(y) === o;
  }, oe.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, oe.isForwardRef = function(y) {
    return x(y) === d;
  }, oe.isFragment = function(y) {
    return x(y) === r;
  }, oe.isLazy = function(y) {
    return x(y) === b;
  }, oe.isMemo = function(y) {
    return x(y) === h;
  }, oe.isPortal = function(y) {
    return x(y) === n;
  }, oe.isProfiler = function(y) {
    return x(y) === a;
  }, oe.isStrictMode = function(y) {
    return x(y) === i;
  }, oe.isSuspense = function(y) {
    return x(y) === f;
  }, oe.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === u || y === a || y === i || y === f || y === p || typeof y == "object" && y !== null && (y.$$typeof === b || y.$$typeof === h || y.$$typeof === o || y.$$typeof === s || y.$$typeof === d || y.$$typeof === g || y.$$typeof === v || y.$$typeof === w || y.$$typeof === C);
  }, oe.typeOf = x, oe;
}
var se = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function X4() {
  return Vr || (Vr = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, a = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, b = t ? Symbol.for("react.lazy") : 60116, C = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, w = t ? Symbol.for("react.scope") : 60119;
    function x(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === r || L === u || L === a || L === i || L === f || L === p || typeof L == "object" && L !== null && (L.$$typeof === b || L.$$typeof === h || L.$$typeof === o || L.$$typeof === s || L.$$typeof === d || L.$$typeof === g || L.$$typeof === v || L.$$typeof === w || L.$$typeof === C);
    }
    function V(L) {
      if (typeof L == "object" && L !== null) {
        var Ge = L.$$typeof;
        switch (Ge) {
          case e:
            var Xe = L.type;
            switch (Xe) {
              case l:
              case u:
              case r:
              case a:
              case i:
              case f:
                return Xe;
              default:
                var Ie = Xe && Xe.$$typeof;
                switch (Ie) {
                  case s:
                  case d:
                  case b:
                  case h:
                  case o:
                    return Ie;
                  default:
                    return Ge;
                }
            }
          case n:
            return Ge;
        }
      }
    }
    var y = l, H = u, I = s, M = o, S = e, Z = d, W = r, O = b, ae = h, z = n, Y = a, k = i, j = f, J = !1;
    function ee(L) {
      return J || (J = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), de(L) || V(L) === l;
    }
    function de(L) {
      return V(L) === u;
    }
    function te(L) {
      return V(L) === s;
    }
    function ne(L) {
      return V(L) === o;
    }
    function Ce(L) {
      return typeof L == "object" && L !== null && L.$$typeof === e;
    }
    function Ee(L) {
      return V(L) === d;
    }
    function Ne(L) {
      return V(L) === r;
    }
    function ve(L) {
      return V(L) === b;
    }
    function Le(L) {
      return V(L) === h;
    }
    function ce(L) {
      return V(L) === n;
    }
    function Te(L) {
      return V(L) === a;
    }
    function Ze(L) {
      return V(L) === i;
    }
    function Pe(L) {
      return V(L) === f;
    }
    se.AsyncMode = y, se.ConcurrentMode = H, se.ContextConsumer = I, se.ContextProvider = M, se.Element = S, se.ForwardRef = Z, se.Fragment = W, se.Lazy = O, se.Memo = ae, se.Portal = z, se.Profiler = Y, se.StrictMode = k, se.Suspense = j, se.isAsyncMode = ee, se.isConcurrentMode = de, se.isContextConsumer = te, se.isContextProvider = ne, se.isElement = Ce, se.isForwardRef = Ee, se.isFragment = Ne, se.isLazy = ve, se.isMemo = Le, se.isPortal = ce, se.isProfiler = Te, se.isStrictMode = Ze, se.isSuspense = Pe, se.isValidElementType = x, se.typeOf = V;
  }()), se;
}
process.env.NODE_ENV === "production" ? V1.exports = k4() : V1.exports = X4();
var z4 = V1.exports, Qi = z4, Y4 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, j4 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Ki = {};
Ki[Qi.ForwardRef] = Y4;
Ki[Qi.Memo] = j4;
var J4 = !0;
function _4(t, e, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    t[i] !== void 0 ? e.push(t[i] + ";") : i && (r += i + " ");
  }), r;
}
var qi = function(e, n, r) {
  var i = e.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  J4 === !1) && e.registered[i] === void 0 && (e.registered[i] = n.styles);
}, U4 = function(e, n, r) {
  qi(e, n, r);
  var i = e.key + "-" + n.name;
  if (e.inserted[n.name] === void 0) {
    var a = n;
    do
      e.insert(n === a ? "." + i : "", a, e.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function $4(t) {
  for (var e = 0, n, r = 0, i = t.length; i >= 4; ++r, i -= 4)
    n = t.charCodeAt(r) & 255 | (t.charCodeAt(++r) & 255) << 8 | (t.charCodeAt(++r) & 255) << 16 | (t.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, e = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      e ^= (t.charCodeAt(r + 2) & 255) << 16;
    case 2:
      e ^= (t.charCodeAt(r + 1) & 255) << 8;
    case 1:
      e ^= t.charCodeAt(r) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var Q4 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, K4 = /[A-Z]|^ms/g, q4 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ea = function(e) {
  return e.charCodeAt(1) === 45;
}, Hr = function(e) {
  return e != null && typeof e != "boolean";
}, u1 = /* @__PURE__ */ B4(function(t) {
  return ea(t) ? t : t.replace(K4, "-$&").toLowerCase();
}), Mr = function(e, n) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(q4, function(r, i, a) {
          return st = {
            name: i,
            styles: a,
            next: st
          }, i;
        });
  }
  return Q4[e] !== 1 && !ea(e) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function In(t, e, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return st = {
          name: i.name,
          styles: i.styles,
          next: st
        }, i.name;
      var a = n;
      if (a.styles !== void 0) {
        var o = a.next;
        if (o !== void 0)
          for (; o !== void 0; )
            st = {
              name: o.name,
              styles: o.styles,
              next: st
            }, o = o.next;
        var s = a.styles + ";";
        return s;
      }
      return ed(t, e, n);
    }
    case "function": {
      if (t !== void 0) {
        var l = st, u = n(t);
        return st = l, In(t, e, u);
      }
      break;
    }
  }
  var d = n;
  return d;
}
function ed(t, e, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += In(t, e, n[i]) + ";";
  else
    for (var a in n) {
      var o = n[a];
      if (typeof o != "object") {
        var s = o;
        Hr(s) && (r += u1(a) + ":" + Mr(a, s) + ";");
      } else if (Array.isArray(o) && typeof o[0] == "string" && e == null)
        for (var l = 0; l < o.length; l++)
          Hr(o[l]) && (r += u1(a) + ":" + Mr(a, o[l]) + ";");
      else {
        var u = In(t, e, o);
        switch (a) {
          case "animation":
          case "animationName": {
            r += u1(a) + ":" + u + ";";
            break;
          }
          default:
            r += a + "{" + u + "}";
        }
      }
    }
  return r;
}
var Er = /label:\s*([^\s;{]+)\s*(;|$)/g, st;
function ta(t, e, n) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var r = !0, i = "";
  st = void 0;
  var a = t[0];
  if (a == null || a.raw === void 0)
    r = !1, i += In(n, e, a);
  else {
    var o = a;
    i += o[0];
  }
  for (var s = 1; s < t.length; s++)
    if (i += In(n, e, t[s]), r) {
      var l = a;
      i += l[s];
    }
  Er.lastIndex = 0;
  for (var u = "", d; (d = Er.exec(i)) !== null; )
    u += "-" + d[1];
  var f = $4(i) + u;
  return {
    name: f,
    styles: i,
    next: st
  };
}
var td = function(e) {
  return e();
}, nd = A.useInsertionEffect ? A.useInsertionEffect : !1, rd = nd || td, na = /* @__PURE__ */ A.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ W4({
    key: "css"
  }) : null
);
na.Provider;
var id = function(e) {
  return /* @__PURE__ */ ii(function(n, r) {
    var i = $n(na);
    return e(n, i, r);
  });
}, ad = /* @__PURE__ */ A.createContext({}), k1 = {}.hasOwnProperty, H1 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", od = function(e, n) {
  var r = {};
  for (var i in n)
    k1.call(n, i) && (r[i] = n[i]);
  return r[H1] = e, r;
}, sd = function(e) {
  var n = e.cache, r = e.serialized, i = e.isStringTag;
  return qi(n, r, i), rd(function() {
    return U4(n, r, i);
  }), null;
}, ld = /* @__PURE__ */ id(function(t, e, n) {
  var r = t.css;
  typeof r == "string" && e.registered[r] !== void 0 && (r = e.registered[r]);
  var i = t[H1], a = [r], o = "";
  typeof t.className == "string" ? o = _4(e.registered, a, t.className) : t.className != null && (o = t.className + " ");
  var s = ta(a, void 0, A.useContext(ad));
  o += e.key + "-" + s.name;
  var l = {};
  for (var u in t)
    k1.call(t, u) && u !== "css" && u !== H1 && (l[u] = t[u]);
  return l.className = o, n && (l.ref = n), /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(sd, {
    cache: e,
    serialized: s,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ A.createElement(i, l));
}), cd = ld, R = function(e, n) {
  var r = arguments;
  if (n == null || !k1.call(n, "css"))
    return A.createElement.apply(void 0, r);
  var i = r.length, a = new Array(i);
  a[0] = cd, a[1] = od(e, n);
  for (var o = 2; o < i; o++)
    a[o] = r[o];
  return A.createElement.apply(null, a);
};
(function(t) {
  var e;
  e || (e = t.JSX || (t.JSX = {}));
})(R);
function X1() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return ta(e);
}
function ud() {
  var t = X1.apply(void 0, arguments), e = "animation-" + t.name;
  return {
    name: e,
    styles: "@keyframes " + e + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function dd(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
const en = Math.min, Pt = Math.max, zn = Math.round, Bn = Math.floor, ft = (t) => ({
  x: t,
  y: t
}), fd = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, md = {
  start: "end",
  end: "start"
};
function M1(t, e, n) {
  return Pt(t, en(e, n));
}
function Nn(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function kt(t) {
  return t.split("-")[0];
}
function Ln(t) {
  return t.split("-")[1];
}
function ra(t) {
  return t === "x" ? "y" : "x";
}
function z1(t) {
  return t === "y" ? "height" : "width";
}
function tn(t) {
  return ["top", "bottom"].includes(kt(t)) ? "y" : "x";
}
function Y1(t) {
  return ra(tn(t));
}
function gd(t, e, n) {
  n === void 0 && (n = !1);
  const r = Ln(t), i = Y1(t), a = z1(i);
  let o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (o = Yn(o)), [o, Yn(o)];
}
function hd(t) {
  const e = Yn(t);
  return [E1(t), e, E1(e)];
}
function E1(t) {
  return t.replace(/start|end/g, (e) => md[e]);
}
function Cd(t, e, n) {
  const r = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : r : e ? r : i;
    case "left":
    case "right":
      return e ? a : o;
    default:
      return [];
  }
}
function bd(t, e, n, r) {
  const i = Ln(t);
  let a = Cd(kt(t), n === "start", r);
  return i && (a = a.map((o) => o + "-" + i), e && (a = a.concat(a.map(E1)))), a;
}
function Yn(t) {
  return t.replace(/left|right|bottom|top/g, (e) => fd[e]);
}
function pd(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function ia(t) {
  return typeof t != "number" ? pd(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function jn(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: i
  } = t;
  return {
    width: r,
    height: i,
    top: n,
    left: e,
    right: e + r,
    bottom: n + i,
    x: e,
    y: n
  };
}
function Nr(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const a = tn(e), o = Y1(e), s = z1(o), l = kt(e), u = a === "y", d = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, p = r[s] / 2 - i[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: d,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Ln(e)) {
    case "start":
      h[o] -= p * (n && u ? -1 : 1);
      break;
    case "end":
      h[o] += p * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const vd = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = n, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let u = await o.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: d,
    y: f
  } = Nr(u, r, l), p = r, h = {}, b = 0;
  for (let C = 0; C < s.length; C++) {
    const {
      name: g,
      fn: v
    } = s[C], {
      x: w,
      y: x,
      data: V,
      reset: y
    } = await v({
      x: d,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: i,
      middlewareData: h,
      rects: u,
      platform: o,
      elements: {
        reference: t,
        floating: e
      }
    });
    d = w ?? d, f = x ?? f, h = {
      ...h,
      [g]: {
        ...h[g],
        ...V
      }
    }, y && b <= 50 && (b++, typeof y == "object" && (y.placement && (p = y.placement), y.rects && (u = y.rects === !0 ? await o.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : y.rects), {
      x: d,
      y: f
    } = Nr(u, p, l)), C = -1);
  }
  return {
    x: d,
    y: f,
    placement: p,
    strategy: i,
    middlewareData: h
  };
};
async function aa(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = Nn(e, t), b = ia(h), g = s[p ? f === "floating" ? "reference" : "floating" : f], v = jn(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(g))) == null || n ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), w = f === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), V = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = jn(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: x,
    strategy: l
  }) : w);
  return {
    top: (v.top - y.top + b.top) / V.y,
    bottom: (y.bottom - v.bottom + b.bottom) / V.y,
    left: (v.left - y.left + b.left) / V.x,
    right: (y.right - v.right + b.right) / V.x
  };
}
const wd = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = e, {
      element: u,
      padding: d = 0
    } = Nn(t, e) || {};
    if (u == null)
      return {};
    const f = ia(d), p = {
      x: n,
      y: r
    }, h = Y1(i), b = z1(h), C = await o.getDimensions(u), g = h === "y", v = g ? "top" : "left", w = g ? "bottom" : "right", x = g ? "clientHeight" : "clientWidth", V = a.reference[b] + a.reference[h] - p[h] - a.floating[b], y = p[h] - a.reference[h], H = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u));
    let I = H ? H[x] : 0;
    (!I || !await (o.isElement == null ? void 0 : o.isElement(H))) && (I = s.floating[x] || a.floating[b]);
    const M = V / 2 - y / 2, S = I / 2 - C[b] / 2 - 1, Z = en(f[v], S), W = en(f[w], S), O = Z, ae = I - C[b] - W, z = I / 2 - C[b] / 2 + M, Y = M1(O, z, ae), k = !l.arrow && Ln(i) != null && z !== Y && a.reference[b] / 2 - (z < O ? Z : W) - C[b] / 2 < 0, j = k ? z < O ? z - O : z - ae : 0;
    return {
      [h]: p[h] + j,
      data: {
        [h]: Y,
        centerOffset: z - Y - j,
        ...k && {
          alignmentOffset: j
        }
      },
      reset: k
    };
  }
}), xd = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: u
      } = e, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: C = !0,
        ...g
      } = Nn(t, e);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const v = kt(i), w = tn(s), x = kt(s) === s, V = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), y = p || (x || !C ? [Yn(s)] : hd(s)), H = b !== "none";
      !p && H && y.push(...bd(s, C, b, V));
      const I = [s, ...y], M = await aa(e, g), S = [];
      let Z = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (d && S.push(M[v]), f) {
        const z = gd(i, o, V);
        S.push(M[z[0]], M[z[1]]);
      }
      if (Z = [...Z, {
        placement: i,
        overflows: S
      }], !S.every((z) => z <= 0)) {
        var W, O;
        const z = (((W = a.flip) == null ? void 0 : W.index) || 0) + 1, Y = I[z];
        if (Y)
          return {
            data: {
              index: z,
              overflows: Z
            },
            reset: {
              placement: Y
            }
          };
        let k = (O = Z.filter((j) => j.overflows[0] <= 0).sort((j, J) => j.overflows[1] - J.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!k)
          switch (h) {
            case "bestFit": {
              var ae;
              const j = (ae = Z.filter((J) => {
                if (H) {
                  const ee = tn(J.placement);
                  return ee === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ee === "y";
                }
                return !0;
              }).map((J) => [J.placement, J.overflows.filter((ee) => ee > 0).reduce((ee, de) => ee + de, 0)]).sort((J, ee) => J[1] - ee[1])[0]) == null ? void 0 : ae[0];
              j && (k = j);
              break;
            }
            case "initialPlacement":
              k = s;
              break;
          }
        if (i !== k)
          return {
            reset: {
              placement: k
            }
          };
      }
      return {};
    }
  };
};
async function yd(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = kt(n), s = Ln(n), l = tn(n) === "y", u = ["left", "top"].includes(o) ? -1 : 1, d = a && l ? -1 : 1, f = Nn(e, t);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: b
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof b == "number" && (h = s === "end" ? b * -1 : b), l ? {
    x: h * d,
    y: p * u
  } : {
    x: p * u,
    y: h * d
  };
}
const Id = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = e, l = await yd(e, t);
      return o === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, Vd = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: v,
              y: w
            } = g;
            return {
              x: v,
              y: w
            };
          }
        },
        ...l
      } = Nn(t, e), u = {
        x: n,
        y: r
      }, d = await aa(e, l), f = tn(kt(i)), p = ra(f);
      let h = u[p], b = u[f];
      if (a) {
        const g = p === "y" ? "top" : "left", v = p === "y" ? "bottom" : "right", w = h + d[g], x = h - d[v];
        h = M1(w, h, x);
      }
      if (o) {
        const g = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", w = b + d[g], x = b - d[v];
        b = M1(w, b, x);
      }
      const C = s.fn({
        ...e,
        [p]: h,
        [f]: b
      });
      return {
        ...C,
        data: {
          x: C.x - n,
          y: C.y - r,
          enabled: {
            [p]: a,
            [f]: o
          }
        }
      };
    }
  };
};
function t1() {
  return typeof window < "u";
}
function on(t) {
  return oa(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Je(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function gt(t) {
  var e;
  return (e = (oa(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function oa(t) {
  return t1() ? t instanceof Node || t instanceof Je(t).Node : !1;
}
function qe(t) {
  return t1() ? t instanceof Element || t instanceof Je(t).Element : !1;
}
function mt(t) {
  return t1() ? t instanceof HTMLElement || t instanceof Je(t).HTMLElement : !1;
}
function Lr(t) {
  return !t1() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Je(t).ShadowRoot;
}
function An(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = et(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function Hd(t) {
  return ["table", "td", "th"].includes(on(t));
}
function n1(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function j1(t) {
  const e = J1(), n = qe(t) ? et(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Md(t) {
  let e = Lt(t);
  for (; mt(e) && !nn(e); ) {
    if (j1(e))
      return e;
    if (n1(e))
      return null;
    e = Lt(e);
  }
  return null;
}
function J1() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function nn(t) {
  return ["html", "body", "#document"].includes(on(t));
}
function et(t) {
  return Je(t).getComputedStyle(t);
}
function r1(t) {
  return qe(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Lt(t) {
  if (on(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Lr(t) && t.host || // Fallback.
    gt(t)
  );
  return Lr(e) ? e.host : e;
}
function sa(t) {
  const e = Lt(t);
  return nn(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : mt(e) && An(e) ? e : sa(e);
}
function Vn(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = sa(t), a = i === ((r = t.ownerDocument) == null ? void 0 : r.body), o = Je(i);
  if (a) {
    const s = N1(o);
    return e.concat(o, o.visualViewport || [], An(i) ? i : [], s && n ? Vn(s) : []);
  }
  return e.concat(i, Vn(i, [], n));
}
function N1(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function la(t) {
  const e = et(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = mt(t), a = i ? t.offsetWidth : n, o = i ? t.offsetHeight : r, s = zn(n) !== a || zn(r) !== o;
  return s && (n = a, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function _1(t) {
  return qe(t) ? t : t.contextElement;
}
function Qt(t) {
  const e = _1(t);
  if (!mt(e))
    return ft(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = la(e);
  let o = (a ? zn(n.width) : n.width) / r, s = (a ? zn(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const Ed = /* @__PURE__ */ ft(0);
function ca(t) {
  const e = Je(t);
  return !J1() || !e.visualViewport ? Ed : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Nd(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Je(t) ? !1 : e;
}
function Xt(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), a = _1(t);
  let o = ft(1);
  e && (r ? qe(r) && (o = Qt(r)) : o = Qt(t));
  const s = Nd(a, n, r) ? ca(a) : ft(0);
  let l = (i.left + s.x) / o.x, u = (i.top + s.y) / o.y, d = i.width / o.x, f = i.height / o.y;
  if (a) {
    const p = Je(a), h = r && qe(r) ? Je(r) : r;
    let b = p, C = N1(b);
    for (; C && r && h !== b; ) {
      const g = Qt(C), v = C.getBoundingClientRect(), w = et(C), x = v.left + (C.clientLeft + parseFloat(w.paddingLeft)) * g.x, V = v.top + (C.clientTop + parseFloat(w.paddingTop)) * g.y;
      l *= g.x, u *= g.y, d *= g.x, f *= g.y, l += x, u += V, b = Je(C), C = N1(b);
    }
  }
  return jn({
    width: d,
    height: f,
    x: l,
    y: u
  });
}
function U1(t, e) {
  const n = r1(t).scrollLeft;
  return e ? e.left + n : Xt(gt(t)).left + n;
}
function ua(t, e, n) {
  n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = r.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    U1(t, r)
  )), a = r.top + e.scrollTop;
  return {
    x: i,
    y: a
  };
}
function Ld(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: i
  } = t;
  const a = i === "fixed", o = gt(r), s = e ? n1(e.floating) : !1;
  if (r === o || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = ft(1);
  const d = ft(0), f = mt(r);
  if ((f || !f && !a) && ((on(r) !== "body" || An(o)) && (l = r1(r)), mt(r))) {
    const h = Xt(r);
    u = Qt(r), d.x = h.x + r.clientLeft, d.y = h.y + r.clientTop;
  }
  const p = o && !f && !a ? ua(o, l, !0) : ft(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x + p.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y + p.y
  };
}
function Ad(t) {
  return Array.from(t.getClientRects());
}
function Zd(t) {
  const e = gt(t), n = r1(t), r = t.ownerDocument.body, i = Pt(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), a = Pt(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + U1(t);
  const s = -n.scrollTop;
  return et(r).direction === "rtl" && (o += Pt(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function Rd(t, e) {
  const n = Je(t), r = gt(t), i = n.visualViewport;
  let a = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    const u = J1();
    (!u || u && e === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function Bd(t, e) {
  const n = Xt(t, !0, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, a = mt(t) ? Qt(t) : ft(1), o = t.clientWidth * a.x, s = t.clientHeight * a.y, l = i * a.x, u = r * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: u
  };
}
function Ar(t, e, n) {
  let r;
  if (e === "viewport")
    r = Rd(t, n);
  else if (e === "document")
    r = Zd(gt(t));
  else if (qe(e))
    r = Bd(e, n);
  else {
    const i = ca(t);
    r = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return jn(r);
}
function da(t, e) {
  const n = Lt(t);
  return n === e || !qe(n) || nn(n) ? !1 : et(n).position === "fixed" || da(n, e);
}
function Sd(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = Vn(t, [], !1).filter((s) => qe(s) && on(s) !== "body"), i = null;
  const a = et(t).position === "fixed";
  let o = a ? Lt(t) : t;
  for (; qe(o) && !nn(o); ) {
    const s = et(o), l = j1(o);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || An(o) && !l && da(t, o)) ? r = r.filter((d) => d !== o) : i = s, o = Lt(o);
  }
  return e.set(t, r), r;
}
function Gd(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const o = [...n === "clippingAncestors" ? n1(e) ? [] : Sd(e, this._c) : [].concat(n), r], s = o[0], l = o.reduce((u, d) => {
    const f = Ar(e, d, i);
    return u.top = Pt(f.top, u.top), u.right = en(f.right, u.right), u.bottom = en(f.bottom, u.bottom), u.left = Pt(f.left, u.left), u;
  }, Ar(e, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Dd(t) {
  const {
    width: e,
    height: n
  } = la(t);
  return {
    width: e,
    height: n
  };
}
function Fd(t, e, n) {
  const r = mt(e), i = gt(e), a = n === "fixed", o = Xt(t, !0, a, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ft(0);
  if (r || !r && !a)
    if ((on(e) !== "body" || An(i)) && (s = r1(e)), r) {
      const p = Xt(e, !0, a, e);
      l.x = p.x + e.clientLeft, l.y = p.y + e.clientTop;
    } else i && (l.x = U1(i));
  const u = i && !r && !a ? ua(i, s) : ft(0), d = o.left + s.scrollLeft - l.x - u.x, f = o.top + s.scrollTop - l.y - u.y;
  return {
    x: d,
    y: f,
    width: o.width,
    height: o.height
  };
}
function d1(t) {
  return et(t).position === "static";
}
function Zr(t, e) {
  if (!mt(t) || et(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return gt(t) === n && (n = n.ownerDocument.body), n;
}
function fa(t, e) {
  const n = Je(t);
  if (n1(t))
    return n;
  if (!mt(t)) {
    let i = Lt(t);
    for (; i && !nn(i); ) {
      if (qe(i) && !d1(i))
        return i;
      i = Lt(i);
    }
    return n;
  }
  let r = Zr(t, e);
  for (; r && Hd(r) && d1(r); )
    r = Zr(r, e);
  return r && nn(r) && d1(r) && !j1(r) ? n : r || Md(t) || n;
}
const Od = async function(t) {
  const e = this.getOffsetParent || fa, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: Fd(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Td(t) {
  return et(t).direction === "rtl";
}
const Pd = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ld,
  getDocumentElement: gt,
  getClippingRect: Gd,
  getOffsetParent: fa,
  getElementRects: Od,
  getClientRects: Ad,
  getDimensions: Dd,
  getScale: Qt,
  isElement: qe,
  isRTL: Td
};
function ma(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function Wd(t, e) {
  let n = null, r;
  const i = gt(t);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const u = t.getBoundingClientRect(), {
      left: d,
      top: f,
      width: p,
      height: h
    } = u;
    if (s || e(), !p || !h)
      return;
    const b = Bn(f), C = Bn(i.clientWidth - (d + p)), g = Bn(i.clientHeight - (f + h)), v = Bn(d), x = {
      rootMargin: -b + "px " + -C + "px " + -g + "px " + -v + "px",
      threshold: Pt(0, en(1, l)) || 1
    };
    let V = !0;
    function y(H) {
      const I = H[0].intersectionRatio;
      if (I !== l) {
        if (!V)
          return o();
        I ? o(!1, I) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      I === 1 && !ma(u, t.getBoundingClientRect()) && o(), V = !1;
    }
    try {
      n = new IntersectionObserver(y, {
        ...x,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(y, x);
    }
    n.observe(t);
  }
  return o(!0), a;
}
function ga(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = _1(t), d = i || a ? [...u ? Vn(u) : [], ...Vn(e)] : [];
  d.forEach((v) => {
    i && v.addEventListener("scroll", n, {
      passive: !0
    }), a && v.addEventListener("resize", n);
  });
  const f = u && s ? Wd(u, n) : null;
  let p = -1, h = null;
  o && (h = new ResizeObserver((v) => {
    let [w] = v;
    w && w.target === u && h && (h.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(e);
    })), n();
  }), u && !l && h.observe(u), h.observe(e));
  let b, C = l ? Xt(t) : null;
  l && g();
  function g() {
    const v = Xt(t);
    C && !ma(C, v) && n(), C = v, b = requestAnimationFrame(g);
  }
  return n(), () => {
    var v;
    d.forEach((w) => {
      i && w.removeEventListener("scroll", n), a && w.removeEventListener("resize", n);
    }), f == null || f(), (v = h) == null || v.disconnect(), h = null, l && cancelAnimationFrame(b);
  };
}
const kd = Id, Xd = Vd, zd = xd, Yd = wd, Rr = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Pd,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return vd(t, e, {
    ...i,
    platform: a
  });
};
var L1 = ai, jd = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Jn = function() {
};
function Jd(t, e) {
  return e ? e[0] === "-" ? t + e : t + "__" + e : t;
}
function _d(t, e) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  var a = [].concat(r);
  if (e && t)
    for (var o in e)
      e.hasOwnProperty(o) && e[o] && a.push("".concat(Jd(t, o)));
  return a.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var Br = function(e) {
  return r5(e) ? e.filter(Boolean) : Wt(e) === "object" && e !== null ? [e] : [];
}, ha = function(e) {
  e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme;
  var n = It(e, jd);
  return B({}, n);
}, ye = function(e, n, r) {
  var i = e.cx, a = e.getStyles, o = e.getClassNames, s = e.className;
  return {
    css: a(n, e),
    className: i(r ?? {}, o(n, e), s)
  };
};
function i1(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}
function Ud(t) {
  return i1(t) ? window.innerHeight : t.clientHeight;
}
function Ca(t) {
  return i1(t) ? window.pageYOffset : t.scrollTop;
}
function _n(t, e) {
  if (i1(t)) {
    window.scrollTo(0, e);
    return;
  }
  t.scrollTop = e;
}
function $d(t) {
  var e = getComputedStyle(t), n = e.position === "absolute", r = /(auto|scroll)/;
  if (e.position === "fixed") return document.documentElement;
  for (var i = t; i = i.parentElement; )
    if (e = getComputedStyle(i), !(n && e.position === "static") && r.test(e.overflow + e.overflowY + e.overflowX))
      return i;
  return document.documentElement;
}
function Qd(t, e, n, r) {
  return n * ((t = t / r - 1) * t * t + 1) + e;
}
function Sn(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Jn, i = Ca(t), a = e - i, o = 10, s = 0;
  function l() {
    s += o;
    var u = Qd(s, i, a, n);
    _n(t, u), s < n ? window.requestAnimationFrame(l) : r(t);
  }
  l();
}
function Sr(t, e) {
  var n = t.getBoundingClientRect(), r = e.getBoundingClientRect(), i = e.offsetHeight / 3;
  r.bottom + i > n.bottom ? _n(t, Math.min(e.offsetTop + e.clientHeight - t.offsetHeight + i, t.scrollHeight)) : r.top - i < n.top && _n(t, Math.max(e.offsetTop - i, 0));
}
function Kd(t) {
  var e = t.getBoundingClientRect();
  return {
    bottom: e.bottom,
    height: e.height,
    left: e.left,
    right: e.right,
    top: e.top,
    width: e.width
  };
}
function Gr() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function qd() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var ba = !1, e5 = {
  get passive() {
    return ba = !0;
  }
}, Gn = typeof window < "u" ? window : {};
Gn.addEventListener && Gn.removeEventListener && (Gn.addEventListener("p", Jn, e5), Gn.removeEventListener("p", Jn, !1));
var t5 = ba;
function n5(t) {
  return t != null;
}
function r5(t) {
  return Array.isArray(t);
}
function Dn(t, e, n) {
  return t ? e : n;
}
var i5 = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  var a = Object.entries(e).filter(function(o) {
    var s = wt(o, 1), l = s[0];
    return !r.includes(l);
  });
  return a.reduce(function(o, s) {
    var l = wt(s, 2), u = l[0], d = l[1];
    return o[u] = d, o;
  }, {});
}, a5 = ["children", "innerProps"], o5 = ["children", "innerProps"];
function s5(t) {
  var e = t.maxHeight, n = t.menuEl, r = t.minHeight, i = t.placement, a = t.shouldScroll, o = t.isFixedPosition, s = t.controlHeight, l = $d(n), u = {
    placement: "bottom",
    maxHeight: e
  };
  if (!n || !n.offsetParent) return u;
  var d = l.getBoundingClientRect(), f = d.height, p = n.getBoundingClientRect(), h = p.bottom, b = p.height, C = p.top, g = n.offsetParent.getBoundingClientRect(), v = g.top, w = o ? window.innerHeight : Ud(l), x = Ca(l), V = parseInt(getComputedStyle(n).marginBottom, 10), y = parseInt(getComputedStyle(n).marginTop, 10), H = v - y, I = w - C, M = H + x, S = f - x - C, Z = h - w + x + V, W = x + C - y, O = 160;
  switch (i) {
    case "auto":
    case "bottom":
      if (I >= b)
        return {
          placement: "bottom",
          maxHeight: e
        };
      if (S >= b && !o)
        return a && Sn(l, Z, O), {
          placement: "bottom",
          maxHeight: e
        };
      if (!o && S >= r || o && I >= r) {
        a && Sn(l, Z, O);
        var ae = o ? I - V : S - V;
        return {
          placement: "bottom",
          maxHeight: ae
        };
      }
      if (i === "auto" || o) {
        var z = e, Y = o ? H : M;
        return Y >= r && (z = Math.min(Y - V - s, e)), {
          placement: "top",
          maxHeight: z
        };
      }
      if (i === "bottom")
        return a && _n(l, Z), {
          placement: "bottom",
          maxHeight: e
        };
      break;
    case "top":
      if (H >= b)
        return {
          placement: "top",
          maxHeight: e
        };
      if (M >= b && !o)
        return a && Sn(l, W, O), {
          placement: "top",
          maxHeight: e
        };
      if (!o && M >= r || o && H >= r) {
        var k = e;
        return (!o && M >= r || o && H >= r) && (k = o ? H - y : M - y), a && Sn(l, W, O), {
          placement: "top",
          maxHeight: k
        };
      }
      return {
        placement: "bottom",
        maxHeight: e
      };
    default:
      throw new Error('Invalid placement provided "'.concat(i, '".'));
  }
  return u;
}
function l5(t) {
  var e = {
    bottom: "top",
    top: "bottom"
  };
  return t ? e[t] : "bottom";
}
var pa = function(e) {
  return e === "auto" ? "bottom" : e;
}, c5 = function(e, n) {
  var r, i = e.placement, a = e.theme, o = a.borderRadius, s = a.spacing, l = a.colors;
  return B((r = {
    label: "menu"
  }, Cn(r, l5(i), "100%"), Cn(r, "position", "absolute"), Cn(r, "width", "100%"), Cn(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: l.neutral0,
    borderRadius: o,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, va = /* @__PURE__ */ S1(null), u5 = function(e) {
  var n = e.children, r = e.minMenuHeight, i = e.maxMenuHeight, a = e.menuPlacement, o = e.menuPosition, s = e.menuShouldScrollIntoView, l = e.theme, u = $n(va) || {}, d = u.setPortalPlacement, f = pe(null), p = $(i), h = wt(p, 2), b = h[0], C = h[1], g = $(null), v = wt(g, 2), w = v[0], x = v[1], V = l.spacing.controlHeight;
  return L1(function() {
    var y = f.current;
    if (y) {
      var H = o === "fixed", I = s && !H, M = s5({
        maxHeight: i,
        menuEl: y,
        minHeight: r,
        placement: a,
        shouldScroll: I,
        isFixedPosition: H,
        controlHeight: V
      });
      C(M.maxHeight), x(M.placement), d == null || d(M.placement);
    }
  }, [i, a, o, s, r, d, V]), n({
    ref: f,
    placerProps: B(B({}, e), {}, {
      placement: w || pa(a),
      maxHeight: b
    })
  });
}, d5 = function(e) {
  var n = e.children, r = e.innerRef, i = e.innerProps;
  return R("div", D({}, ye(e, "menu", {
    menu: !0
  }), {
    ref: r
  }, i), n);
}, f5 = d5, m5 = function(e, n) {
  var r = e.maxHeight, i = e.theme.spacing.baseUnit;
  return B({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: i,
    paddingTop: i
  });
}, g5 = function(e) {
  var n = e.children, r = e.innerProps, i = e.innerRef, a = e.isMulti;
  return R("div", D({}, ye(e, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: i
  }, r), n);
}, wa = function(e, n) {
  var r = e.theme, i = r.spacing.baseUnit, a = r.colors;
  return B({
    textAlign: "center"
  }, n ? {} : {
    color: a.neutral40,
    padding: "".concat(i * 2, "px ").concat(i * 3, "px")
  });
}, h5 = wa, C5 = wa, b5 = function(e) {
  var n = e.children, r = n === void 0 ? "No options" : n, i = e.innerProps, a = It(e, a5);
  return R("div", D({}, ye(B(B({}, a), {}, {
    children: r,
    innerProps: i
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), i), r);
}, p5 = function(e) {
  var n = e.children, r = n === void 0 ? "Loading..." : n, i = e.innerProps, a = It(e, o5);
  return R("div", D({}, ye(B(B({}, a), {}, {
    children: r,
    innerProps: i
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), i), r);
}, v5 = function(e) {
  var n = e.rect, r = e.offset, i = e.position;
  return {
    left: n.left,
    position: i,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, w5 = function(e) {
  var n = e.appendTo, r = e.children, i = e.controlElement, a = e.innerProps, o = e.menuPlacement, s = e.menuPosition, l = pe(null), u = pe(null), d = $(pa(o)), f = wt(d, 2), p = f[0], h = f[1], b = lt(function() {
    return {
      setPortalPlacement: h
    };
  }, []), C = $(null), g = wt(C, 2), v = g[0], w = g[1], x = me(function() {
    if (i) {
      var I = Kd(i), M = s === "fixed" ? 0 : window.pageYOffset, S = I[p] + M;
      (S !== (v == null ? void 0 : v.offset) || I.left !== (v == null ? void 0 : v.rect.left) || I.width !== (v == null ? void 0 : v.rect.width)) && w({
        offset: S,
        rect: I
      });
    }
  }, [i, s, p, v == null ? void 0 : v.offset, v == null ? void 0 : v.rect.left, v == null ? void 0 : v.rect.width]);
  L1(function() {
    x();
  }, [x]);
  var V = me(function() {
    typeof u.current == "function" && (u.current(), u.current = null), i && l.current && (u.current = ga(i, l.current, x, {
      elementResize: "ResizeObserver" in window
    }));
  }, [i, x]);
  L1(function() {
    V();
  }, [V]);
  var y = me(function(I) {
    l.current = I, V();
  }, [V]);
  if (!n && s !== "fixed" || !v) return null;
  var H = R("div", D({
    ref: y
  }, ye(B(B({}, e), {}, {
    offset: v.offset,
    position: s,
    rect: v.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), r);
  return R(va.Provider, {
    value: b
  }, n ? /* @__PURE__ */ za(H, n) : H);
}, x5 = function(e) {
  var n = e.isDisabled, r = e.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, y5 = function(e) {
  var n = e.children, r = e.innerProps, i = e.isDisabled, a = e.isRtl;
  return R("div", D({}, ye(e, "container", {
    "--is-disabled": i,
    "--is-rtl": a
  }), r), n);
}, I5 = function(e, n) {
  var r = e.theme.spacing, i = e.isMulti, a = e.hasValue, o = e.selectProps.controlShouldRenderValue;
  return B({
    alignItems: "center",
    display: i && a && o ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, V5 = function(e) {
  var n = e.children, r = e.innerProps, i = e.isMulti, a = e.hasValue;
  return R("div", D({}, ye(e, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": i,
    "value-container--has-value": a
  }), r), n);
}, H5 = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, M5 = function(e) {
  var n = e.children, r = e.innerProps;
  return R("div", D({}, ye(e, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, Dr, E5 = ["size"], N5 = ["innerProps", "isRtl", "size"];
function L5() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var A5 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGljYXRvcnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCSSIsImZpbGUiOiJpbmRpY2F0b3JzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWFjdE5vZGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3gsIGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0IHtcbiAgQ29tbW9uUHJvcHNBbmRDbGFzc05hbWUsXG4gIENTU09iamVjdFdpdGhMYWJlbCxcbiAgR3JvdXBCYXNlLFxufSBmcm9tICcuLi90eXBlcyc7XG5pbXBvcnQgeyBnZXRTdHlsZVByb3BzIH0gZnJvbSAnLi4vdXRpbHMnO1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIERyb3Bkb3duICYgQ2xlYXIgSWNvbnNcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5jb25zdCBTdmcgPSAoe1xuICBzaXplLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzdmcnXSAmIHsgc2l6ZTogbnVtYmVyIH0pID0+IChcbiAgPHN2Z1xuICAgIGhlaWdodD17c2l6ZX1cbiAgICB3aWR0aD17c2l6ZX1cbiAgICB2aWV3Qm94PVwiMCAwIDIwIDIwXCJcbiAgICBhcmlhLWhpZGRlbj1cInRydWVcIlxuICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICBjc3M9e3tcbiAgICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxuICAgICAgZmlsbDogJ2N1cnJlbnRDb2xvcicsXG4gICAgICBsaW5lSGVpZ2h0OiAxLFxuICAgICAgc3Ryb2tlOiAnY3VycmVudENvbG9yJyxcbiAgICAgIHN0cm9rZVdpZHRoOiAwLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IHR5cGUgQ3Jvc3NJY29uUHJvcHMgPSBKU1guSW50cmluc2ljRWxlbWVudHNbJ3N2ZyddICYgeyBzaXplPzogbnVtYmVyIH07XG5leHBvcnQgY29uc3QgQ3Jvc3NJY29uID0gKHByb3BzOiBDcm9zc0ljb25Qcm9wcykgPT4gKFxuICA8U3ZnIHNpemU9ezIwfSB7Li4ucHJvcHN9PlxuICAgIDxwYXRoIGQ9XCJNMTQuMzQ4IDE0Ljg0OWMtMC40NjkgMC40NjktMS4yMjkgMC40NjktMS42OTcgMGwtMi42NTEtMy4wMzAtMi42NTEgMy4wMjljLTAuNDY5IDAuNDY5LTEuMjI5IDAuNDY5LTEuNjk3IDAtMC40NjktMC40NjktMC40NjktMS4yMjkgMC0xLjY5N2wyLjc1OC0zLjE1LTIuNzU5LTMuMTUyYy0wLjQ2OS0wLjQ2OS0wLjQ2OS0xLjIyOCAwLTEuNjk3czEuMjI4LTAuNDY5IDEuNjk3IDBsMi42NTIgMy4wMzEgMi42NTEtMy4wMzFjMC40NjktMC40NjkgMS4yMjgtMC40NjkgMS42OTcgMHMwLjQ2OSAxLjIyOSAwIDEuNjk3bC0yLjc1OCAzLjE1MiAyLjc1OCAzLjE1YzAuNDY5IDAuNDY5IDAuNDY5IDEuMjI5IDAgMS42OTh6XCIgLz5cbiAgPC9Tdmc+XG4pO1xuZXhwb3J0IHR5cGUgRG93bkNoZXZyb25Qcm9wcyA9IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snc3ZnJ10gJiB7IHNpemU/OiBudW1iZXIgfTtcbmV4cG9ydCBjb25zdCBEb3duQ2hldnJvbiA9IChwcm9wczogRG93bkNoZXZyb25Qcm9wcykgPT4gKFxuICA8U3ZnIHNpemU9ezIwfSB7Li4ucHJvcHN9PlxuICAgIDxwYXRoIGQ9XCJNNC41MTYgNy41NDhjMC40MzYtMC40NDYgMS4wNDMtMC40ODEgMS41NzYgMGwzLjkwOCAzLjc0NyAzLjkwOC0zLjc0N2MwLjUzMy0wLjQ4MSAxLjE0MS0wLjQ0NiAxLjU3NCAwIDAuNDM2IDAuNDQ1IDAuNDA4IDEuMTk3IDAgMS42MTUtMC40MDYgMC40MTgtNC42OTUgNC41MDItNC42OTUgNC41MDItMC4yMTcgMC4yMjMtMC41MDIgMC4zMzUtMC43ODcgMC4zMzVzLTAuNTctMC4xMTItMC43ODktMC4zMzVjMCAwLTQuMjg3LTQuMDg0LTQuNjk1LTQuNTAycy0wLjQzNi0xLjE3IDAtMS42MTV6XCIgLz5cbiAgPC9Tdmc+XG4pO1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIERyb3Bkb3duICYgQ2xlYXIgQnV0dG9uc1xuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG5cbmV4cG9ydCBpbnRlcmZhY2UgRHJvcGRvd25JbmRpY2F0b3JQcm9wczxcbiAgT3B0aW9uID0gdW5rbm93bixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4gPSBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+ID0gR3JvdXBCYXNlPE9wdGlvbj5cbj4gZXh0ZW5kcyBDb21tb25Qcm9wc0FuZENsYXNzTmFtZTxPcHRpb24sIElzTXVsdGksIEdyb3VwPiB7XG4gIC8qKiBUaGUgY2hpbGRyZW4gdG8gYmUgcmVuZGVyZWQgaW5zaWRlIHRoZSBpbmRpY2F0b3IuICovXG4gIGNoaWxkcmVuPzogUmVhY3ROb2RlO1xuICAvKiogUHJvcHMgdGhhdCB3aWxsIGJlIHBhc3NlZCBvbiB0byB0aGUgY2hpbGRyZW4uICovXG4gIGlubmVyUHJvcHM6IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snZGl2J107XG4gIC8qKiBUaGUgZm9jdXNlZCBzdGF0ZSBvZiB0aGUgc2VsZWN0LiAqL1xuICBpc0ZvY3VzZWQ6IGJvb2xlYW47XG4gIGlzRGlzYWJsZWQ6IGJvb2xlYW47XG59XG5cbmNvbnN0IGJhc2VDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHtcbiAgICBpc0ZvY3VzZWQsXG4gICAgdGhlbWU6IHtcbiAgICAgIHNwYWNpbmc6IHsgYmFzZVVuaXQgfSxcbiAgICAgIGNvbG9ycyxcbiAgICB9LFxuICB9OlxuICAgIHwgRHJvcGRvd25JbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuICAgIHwgQ2xlYXJJbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPixcbiAgdW5zdHlsZWQ6IGJvb2xlYW5cbik6IENTU09iamVjdFdpdGhMYWJlbCA9PiAoe1xuICBsYWJlbDogJ2luZGljYXRvckNvbnRhaW5lcicsXG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgdHJhbnNpdGlvbjogJ2NvbG9yIDE1MG1zJyxcbiAgLi4uKHVuc3R5bGVkXG4gICAgPyB7fVxuICAgIDoge1xuICAgICAgICBjb2xvcjogaXNGb2N1c2VkID8gY29sb3JzLm5ldXRyYWw2MCA6IGNvbG9ycy5uZXV0cmFsMjAsXG4gICAgICAgIHBhZGRpbmc6IGJhc2VVbml0ICogMixcbiAgICAgICAgJzpob3Zlcic6IHtcbiAgICAgICAgICBjb2xvcjogaXNGb2N1c2VkID8gY29sb3JzLm5ldXRyYWw4MCA6IGNvbG9ycy5uZXV0cmFsNDAsXG4gICAgICAgIH0sXG4gICAgICB9KSxcbn0pO1xuXG5leHBvcnQgY29uc3QgZHJvcGRvd25JbmRpY2F0b3JDU1MgPSBiYXNlQ1NTO1xuZXhwb3J0IGNvbnN0IERyb3Bkb3duSW5kaWNhdG9yID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICBwcm9wczogRHJvcGRvd25JbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuKSA9PiB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5nZXRTdHlsZVByb3BzKHByb3BzLCAnZHJvcGRvd25JbmRpY2F0b3InLCB7XG4gICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgJ2Ryb3Bkb3duLWluZGljYXRvcic6IHRydWUsXG4gICAgICB9KX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8RG93bkNoZXZyb24gLz59XG4gICAgPC9kaXY+XG4gICk7XG59O1xuXG5leHBvcnQgaW50ZXJmYWNlIENsZWFySW5kaWNhdG9yUHJvcHM8XG4gIE9wdGlvbiA9IHVua25vd24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuID0gYm9vbGVhbixcbiAgR3JvdXAgZXh0ZW5kcyBHcm91cEJhc2U8T3B0aW9uPiA9IEdyb3VwQmFzZTxPcHRpb24+XG4+IGV4dGVuZHMgQ29tbW9uUHJvcHNBbmRDbGFzc05hbWU8T3B0aW9uLCBJc011bHRpLCBHcm91cD4ge1xuICAvKiogVGhlIGNoaWxkcmVuIHRvIGJlIHJlbmRlcmVkIGluc2lkZSB0aGUgaW5kaWNhdG9yLiAqL1xuICBjaGlsZHJlbj86IFJlYWN0Tm9kZTtcbiAgLyoqIFByb3BzIHRoYXQgd2lsbCBiZSBwYXNzZWQgb24gdG8gdGhlIGNoaWxkcmVuLiAqL1xuICBpbm5lclByb3BzOiBKU1guSW50cmluc2ljRWxlbWVudHNbJ2RpdiddO1xuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuO1xufVxuXG5leHBvcnQgY29uc3QgY2xlYXJJbmRpY2F0b3JDU1MgPSBiYXNlQ1NTO1xuZXhwb3J0IGNvbnN0IENsZWFySW5kaWNhdG9yID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICBwcm9wczogQ2xlYXJJbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuKSA9PiB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5nZXRTdHlsZVByb3BzKHByb3BzLCAnY2xlYXJJbmRpY2F0b3InLCB7XG4gICAgICAgIGluZGljYXRvcjogdHJ1ZSxcbiAgICAgICAgJ2NsZWFyLWluZGljYXRvcic6IHRydWUsXG4gICAgICB9KX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8Q3Jvc3NJY29uIC8+fVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBTZXBhcmF0b3Jcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5leHBvcnQgaW50ZXJmYWNlIEluZGljYXRvclNlcGFyYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgaXNEaXNhYmxlZDogYm9vbGVhbjtcbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpbm5lclByb3BzPzogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ107XG59XG5cbmV4cG9ydCBjb25zdCBpbmRpY2F0b3JTZXBhcmF0b3JDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHtcbiAgICBpc0Rpc2FibGVkLFxuICAgIHRoZW1lOiB7XG4gICAgICBzcGFjaW5nOiB7IGJhc2VVbml0IH0sXG4gICAgICBjb2xvcnMsXG4gICAgfSxcbiAgfTogSW5kaWNhdG9yU2VwYXJhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD4sXG4gIHVuc3R5bGVkOiBib29sZWFuXG4pOiBDU1NPYmplY3RXaXRoTGFiZWwgPT4gKHtcbiAgbGFiZWw6ICdpbmRpY2F0b3JTZXBhcmF0b3InLFxuICBhbGlnblNlbGY6ICdzdHJldGNoJyxcbiAgd2lkdGg6IDEsXG4gIC4uLih1bnN0eWxlZFxuICAgID8ge31cbiAgICA6IHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiBpc0Rpc2FibGVkID8gY29sb3JzLm5ldXRyYWwxMCA6IGNvbG9ycy5uZXV0cmFsMjAsXG4gICAgICAgIG1hcmdpbkJvdHRvbTogYmFzZVVuaXQgKiAyLFxuICAgICAgICBtYXJnaW5Ub3A6IGJhc2VVbml0ICogMixcbiAgICAgIH0pLFxufSk7XG5cbmV4cG9ydCBjb25zdCBJbmRpY2F0b3JTZXBhcmF0b3IgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHByb3BzOiBJbmRpY2F0b3JTZXBhcmF0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuKSA9PiB7XG4gIGNvbnN0IHsgaW5uZXJQcm9wcyB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPHNwYW5cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgey4uLmdldFN0eWxlUHJvcHMocHJvcHMsICdpbmRpY2F0b3JTZXBhcmF0b3InLCB7XG4gICAgICAgICdpbmRpY2F0b3Itc2VwYXJhdG9yJzogdHJ1ZSxcbiAgICAgIH0pfVxuICAgIC8+XG4gICk7XG59O1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIExvYWRpbmdcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5jb25zdCBsb2FkaW5nRG90QW5pbWF0aW9ucyA9IGtleWZyYW1lc2BcbiAgMCUsIDgwJSwgMTAwJSB7IG9wYWNpdHk6IDA7IH1cbiAgNDAlIHsgb3BhY2l0eTogMTsgfVxuYDtcblxuZXhwb3J0IGNvbnN0IGxvYWRpbmdJbmRpY2F0b3JDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHtcbiAgICBpc0ZvY3VzZWQsXG4gICAgc2l6ZSxcbiAgICB0aGVtZToge1xuICAgICAgY29sb3JzLFxuICAgICAgc3BhY2luZzogeyBiYXNlVW5pdCB9LFxuICAgIH0sXG4gIH06IExvYWRpbmdJbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPixcbiAgdW5zdHlsZWQ6IGJvb2xlYW5cbik6IENTU09iamVjdFdpdGhMYWJlbCA9PiAoe1xuICBsYWJlbDogJ2xvYWRpbmdJbmRpY2F0b3InLFxuICBkaXNwbGF5OiAnZmxleCcsXG4gIHRyYW5zaXRpb246ICdjb2xvciAxNTBtcycsXG4gIGFsaWduU2VsZjogJ2NlbnRlcicsXG4gIGZvbnRTaXplOiBzaXplLFxuICBsaW5lSGVpZ2h0OiAxLFxuICBtYXJnaW5SaWdodDogc2l6ZSxcbiAgdGV4dEFsaWduOiAnY2VudGVyJyxcbiAgdmVydGljYWxBbGlnbjogJ21pZGRsZScsXG4gIC4uLih1bnN0eWxlZFxuICAgID8ge31cbiAgICA6IHtcbiAgICAgICAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsNjAgOiBjb2xvcnMubmV1dHJhbDIwLFxuICAgICAgICBwYWRkaW5nOiBiYXNlVW5pdCAqIDIsXG4gICAgICB9KSxcbn0pO1xuXG5pbnRlcmZhY2UgTG9hZGluZ0RvdFByb3BzIHtcbiAgZGVsYXk6IG51bWJlcjtcbiAgb2Zmc2V0OiBib29sZWFuO1xufVxuY29uc3QgTG9hZGluZ0RvdCA9ICh7IGRlbGF5LCBvZmZzZXQgfTogTG9hZGluZ0RvdFByb3BzKSA9PiAoXG4gIDxzcGFuXG4gICAgY3NzPXt7XG4gICAgICBhbmltYXRpb246IGAke2xvYWRpbmdEb3RBbmltYXRpb25zfSAxcyBlYXNlLWluLW91dCAke2RlbGF5fW1zIGluZmluaXRlO2AsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6ICdjdXJyZW50Q29sb3InLFxuICAgICAgYm9yZGVyUmFkaXVzOiAnMWVtJyxcbiAgICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxuICAgICAgbWFyZ2luTGVmdDogb2Zmc2V0ID8gJzFlbScgOiB1bmRlZmluZWQsXG4gICAgICBoZWlnaHQ6ICcxZW0nLFxuICAgICAgdmVydGljYWxBbGlnbjogJ3RvcCcsXG4gICAgICB3aWR0aDogJzFlbScsXG4gICAgfX1cbiAgLz5cbik7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTG9hZGluZ0luZGljYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgLyoqIFByb3BzIHRoYXQgd2lsbCBiZSBwYXNzZWQgb24gdG8gdGhlIGNoaWxkcmVuLiAqL1xuICBpbm5lclByb3BzOiBKU1guSW50cmluc2ljRWxlbWVudHNbJ2RpdiddO1xuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpc0Rpc2FibGVkOiBib29sZWFuO1xuICAvKiogU2V0IHNpemUgb2YgdGhlIGNvbnRhaW5lci4gKi9cbiAgc2l6ZTogbnVtYmVyO1xufVxuZXhwb3J0IGNvbnN0IExvYWRpbmdJbmRpY2F0b3IgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oe1xuICBpbm5lclByb3BzLFxuICBpc1J0bCxcbiAgc2l6ZSA9IDQsXG4gIC4uLnJlc3RQcm9wc1xufTogTG9hZGluZ0luZGljYXRvclByb3BzPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgey4uLmdldFN0eWxlUHJvcHMoXG4gICAgICAgIHsgLi4ucmVzdFByb3BzLCBpbm5lclByb3BzLCBpc1J0bCwgc2l6ZSB9LFxuICAgICAgICAnbG9hZGluZ0luZGljYXRvcicsXG4gICAgICAgIHtcbiAgICAgICAgICBpbmRpY2F0b3I6IHRydWUsXG4gICAgICAgICAgJ2xvYWRpbmctaW5kaWNhdG9yJzogdHJ1ZSxcbiAgICAgICAgfVxuICAgICAgKX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIDxMb2FkaW5nRG90IGRlbGF5PXswfSBvZmZzZXQ9e2lzUnRsfSAvPlxuICAgICAgPExvYWRpbmdEb3QgZGVsYXk9ezE2MH0gb2Zmc2V0IC8+XG4gICAgICA8TG9hZGluZ0RvdCBkZWxheT17MzIwfSBvZmZzZXQ9eyFpc1J0bH0gLz5cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG4iXX0= */",
  toString: L5
}, xa = function(e) {
  var n = e.size, r = It(e, E5);
  return R("svg", D({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: A5
  }, r));
}, $1 = function(e) {
  return R(xa, D({
    size: 20
  }, e), R("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, ya = function(e) {
  return R(xa, D({
    size: 20
  }, e), R("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, Ia = function(e, n) {
  var r = e.isFocused, i = e.theme, a = i.spacing.baseUnit, o = i.colors;
  return B({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? o.neutral60 : o.neutral20,
    padding: a * 2,
    ":hover": {
      color: r ? o.neutral80 : o.neutral40
    }
  });
}, Z5 = Ia, R5 = function(e) {
  var n = e.children, r = e.innerProps;
  return R("div", D({}, ye(e, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || R(ya, null));
}, B5 = Ia, S5 = function(e) {
  var n = e.children, r = e.innerProps;
  return R("div", D({}, ye(e, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || R($1, null));
}, G5 = function(e, n) {
  var r = e.isDisabled, i = e.theme, a = i.spacing.baseUnit, o = i.colors;
  return B({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? o.neutral10 : o.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
}, D5 = function(e) {
  var n = e.innerProps;
  return R("span", D({}, n, ye(e, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, F5 = ud(Dr || (Dr = dd([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), O5 = function(e, n) {
  var r = e.isFocused, i = e.size, a = e.theme, o = a.colors, s = a.spacing.baseUnit;
  return B({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: i,
    lineHeight: 1,
    marginRight: i,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? o.neutral60 : o.neutral20,
    padding: s * 2
  });
}, f1 = function(e) {
  var n = e.delay, r = e.offset;
  return R("span", {
    css: /* @__PURE__ */ X1({
      animation: "".concat(F5, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, T5 = function(e) {
  var n = e.innerProps, r = e.isRtl, i = e.size, a = i === void 0 ? 4 : i, o = It(e, N5);
  return R("div", D({}, ye(B(B({}, o), {}, {
    innerProps: n,
    isRtl: r,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), R(f1, {
    delay: 0,
    offset: r
  }), R(f1, {
    delay: 160,
    offset: !0
  }), R(f1, {
    delay: 320,
    offset: !r
  }));
}, P5 = function(e, n) {
  var r = e.isDisabled, i = e.isFocused, a = e.theme, o = a.colors, s = a.borderRadius, l = a.spacing;
  return B({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: l.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? o.neutral5 : o.neutral0,
    borderColor: r ? o.neutral10 : i ? o.primary : o.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: i ? "0 0 0 1px ".concat(o.primary) : void 0,
    "&:hover": {
      borderColor: i ? o.primary : o.neutral30
    }
  });
}, W5 = function(e) {
  var n = e.children, r = e.isDisabled, i = e.isFocused, a = e.innerRef, o = e.innerProps, s = e.menuIsOpen;
  return R("div", D({
    ref: a
  }, ye(e, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": i,
    "control--menu-is-open": s
  }), o, {
    "aria-disabled": r || void 0
  }), n);
}, k5 = W5, X5 = ["data"], z5 = function(e, n) {
  var r = e.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, Y5 = function(e) {
  var n = e.children, r = e.cx, i = e.getStyles, a = e.getClassNames, o = e.Heading, s = e.headingProps, l = e.innerProps, u = e.label, d = e.theme, f = e.selectProps;
  return R("div", D({}, ye(e, "group", {
    group: !0
  }), l), R(o, D({}, s, {
    selectProps: f,
    theme: d,
    getStyles: i,
    getClassNames: a,
    cx: r
  }), u), R("div", null, n));
}, j5 = function(e, n) {
  var r = e.theme, i = r.colors, a = r.spacing;
  return B({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: i.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
}, J5 = function(e) {
  var n = ha(e);
  n.data;
  var r = It(n, X5);
  return R("div", D({}, ye(e, "groupHeading", {
    "group-heading": !0
  }), r));
}, _5 = Y5, U5 = ["innerRef", "isDisabled", "isHidden", "inputClassName"], $5 = function(e, n) {
  var r = e.isDisabled, i = e.value, a = e.theme, o = a.spacing, s = a.colors;
  return B(B({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: i ? "translateZ(0)" : ""
  }, Q5), n ? {} : {
    margin: o.baseUnit / 2,
    paddingBottom: o.baseUnit / 2,
    paddingTop: o.baseUnit / 2,
    color: s.neutral80
  });
}, Va = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, Q5 = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": B({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, Va)
}, K5 = function(e) {
  return B({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: e ? 0 : 1,
    width: "100%"
  }, Va);
}, q5 = function(e) {
  var n = e.cx, r = e.value, i = ha(e), a = i.innerRef, o = i.isDisabled, s = i.isHidden, l = i.inputClassName, u = It(i, U5);
  return R("div", D({}, ye(e, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), R("input", D({
    className: n({
      input: !0
    }, l),
    ref: a,
    style: K5(s),
    disabled: o
  }, u)));
}, e3 = q5, t3 = function(e, n) {
  var r = e.theme, i = r.spacing, a = r.borderRadius, o = r.colors;
  return B({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: o.neutral10,
    borderRadius: a / 2,
    margin: i.baseUnit / 2
  });
}, n3 = function(e, n) {
  var r = e.theme, i = r.borderRadius, a = r.colors, o = e.cropWithEllipsis;
  return B({
    overflow: "hidden",
    textOverflow: o || o === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: i / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, r3 = function(e, n) {
  var r = e.theme, i = r.spacing, a = r.borderRadius, o = r.colors, s = e.isFocused;
  return B({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: a / 2,
    backgroundColor: s ? o.dangerLight : void 0,
    paddingLeft: i.baseUnit,
    paddingRight: i.baseUnit,
    ":hover": {
      backgroundColor: o.dangerLight,
      color: o.danger
    }
  });
}, Ha = function(e) {
  var n = e.children, r = e.innerProps;
  return R("div", r, n);
}, i3 = Ha, a3 = Ha;
function o3(t) {
  var e = t.children, n = t.innerProps;
  return R("div", D({
    role: "button"
  }, n), e || R($1, {
    size: 14
  }));
}
var s3 = function(e) {
  var n = e.children, r = e.components, i = e.data, a = e.innerProps, o = e.isDisabled, s = e.removeProps, l = e.selectProps, u = r.Container, d = r.Label, f = r.Remove;
  return R(u, {
    data: i,
    innerProps: B(B({}, ye(e, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": o
    })), a),
    selectProps: l
  }, R(d, {
    data: i,
    innerProps: B({}, ye(e, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: l
  }, n), R(f, {
    data: i,
    innerProps: B(B({}, ye(e, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, s),
    selectProps: l
  }));
}, l3 = s3, c3 = function(e, n) {
  var r = e.isDisabled, i = e.isFocused, a = e.isSelected, o = e.theme, s = o.spacing, l = o.colors;
  return B({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: a ? l.primary : i ? l.primary25 : "transparent",
    color: r ? l.neutral20 : a ? l.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : a ? l.primary : l.primary50
    }
  });
}, u3 = function(e) {
  var n = e.children, r = e.isDisabled, i = e.isFocused, a = e.isSelected, o = e.innerRef, s = e.innerProps;
  return R("div", D({}, ye(e, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": i,
    "option--is-selected": a
  }), {
    ref: o,
    "aria-disabled": r
  }, s), n);
}, d3 = u3, f3 = function(e, n) {
  var r = e.theme, i = r.spacing, a = r.colors;
  return B({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: a.neutral50,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, m3 = function(e) {
  var n = e.children, r = e.innerProps;
  return R("div", D({}, ye(e, "placeholder", {
    placeholder: !0
  }), r), n);
}, g3 = m3, h3 = function(e, n) {
  var r = e.isDisabled, i = e.theme, a = i.spacing, o = i.colors;
  return B({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? o.neutral40 : o.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, C3 = function(e) {
  var n = e.children, r = e.isDisabled, i = e.innerProps;
  return R("div", D({}, ye(e, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), i), n);
}, b3 = C3, A1 = {
  ClearIndicator: S5,
  Control: k5,
  DropdownIndicator: R5,
  DownChevron: ya,
  CrossIcon: $1,
  Group: _5,
  GroupHeading: J5,
  IndicatorsContainer: M5,
  IndicatorSeparator: D5,
  Input: e3,
  LoadingIndicator: T5,
  Menu: f5,
  MenuList: g5,
  MenuPortal: w5,
  LoadingMessage: p5,
  NoOptionsMessage: b5,
  MultiValue: l3,
  MultiValueContainer: i3,
  MultiValueLabel: a3,
  MultiValueRemove: o3,
  Option: d3,
  Placeholder: g3,
  SelectContainer: y5,
  SingleValue: b3,
  ValueContainer: V5
}, p3 = function(e) {
  return B(B({}, A1), e.components);
}, Fr = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function v3(t, e) {
  return !!(t === e || Fr(t) && Fr(e));
}
function w3(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (!v3(t[n], e[n]))
      return !1;
  return !0;
}
function x3(t, e) {
  e === void 0 && (e = w3);
  var n = null;
  function r() {
    for (var i = [], a = 0; a < arguments.length; a++)
      i[a] = arguments[a];
    if (n && n.lastThis === this && e(i, n.lastArgs))
      return n.lastResult;
    var o = t.apply(this, i);
    return n = {
      lastResult: o,
      lastArgs: i,
      lastThis: this
    }, o;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function y3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var I3 = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: y3
}, V3 = function(e) {
  return R("span", D({
    css: I3
  }, e));
}, Or = V3, H3 = {
  guidance: function(e) {
    var n = e.isSearchable, r = e.isMulti, i = e.tabSelectsValue, a = e.context, o = e.isInitialFocus;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(i ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return o ? "".concat(e["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(e) {
    var n = e.action, r = e.label, i = r === void 0 ? "" : r, a = e.labels, o = e.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(i, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");
      case "select-option":
        return o ? "option ".concat(i, " is disabled. Select another option.") : "option ".concat(i, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(e) {
    var n = e.context, r = e.focused, i = e.options, a = e.label, o = a === void 0 ? "" : a, s = e.selectValue, l = e.isDisabled, u = e.isSelected, d = e.isAppleDevice, f = function(C, g) {
      return C && C.length ? "".concat(C.indexOf(g) + 1, " of ").concat(C.length) : "";
    };
    if (n === "value" && s)
      return "value ".concat(o, " focused, ").concat(f(s, r), ".");
    if (n === "menu" && d) {
      var p = l ? " disabled" : "", h = "".concat(u ? " selected" : "").concat(p);
      return "".concat(o).concat(h, ", ").concat(f(i, r), ".");
    }
    return "";
  },
  onFilter: function(e) {
    var n = e.inputValue, r = e.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, M3 = function(e) {
  var n = e.ariaSelection, r = e.focusedOption, i = e.focusedValue, a = e.focusableOptions, o = e.isFocused, s = e.selectValue, l = e.selectProps, u = e.id, d = e.isAppleDevice, f = l.ariaLiveMessages, p = l.getOptionLabel, h = l.inputValue, b = l.isMulti, C = l.isOptionDisabled, g = l.isSearchable, v = l.menuIsOpen, w = l.options, x = l.screenReaderStatus, V = l.tabSelectsValue, y = l.isLoading, H = l["aria-label"], I = l["aria-live"], M = lt(function() {
    return B(B({}, H3), f || {});
  }, [f]), S = lt(function() {
    var Y = "";
    if (n && M.onChange) {
      var k = n.option, j = n.options, J = n.removedValue, ee = n.removedValues, de = n.value, te = function(ce) {
        return Array.isArray(ce) ? null : ce;
      }, ne = J || k || te(de), Ce = ne ? p(ne) : "", Ee = j || ee || void 0, Ne = Ee ? Ee.map(p) : [], ve = B({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ne && C(ne, s),
        label: Ce,
        labels: Ne
      }, n);
      Y = M.onChange(ve);
    }
    return Y;
  }, [n, M, C, s, p]), Z = lt(function() {
    var Y = "", k = r || i, j = !!(r && s && s.includes(r));
    if (k && M.onFocus) {
      var J = {
        focused: k,
        label: p(k),
        isDisabled: C(k, s),
        isSelected: j,
        options: a,
        context: k === r ? "menu" : "value",
        selectValue: s,
        isAppleDevice: d
      };
      Y = M.onFocus(J);
    }
    return Y;
  }, [r, i, p, C, M, a, s, d]), W = lt(function() {
    var Y = "";
    if (v && w.length && !y && M.onFilter) {
      var k = x({
        count: a.length
      });
      Y = M.onFilter({
        inputValue: h,
        resultsMessage: k
      });
    }
    return Y;
  }, [a, h, v, M, w, x, y]), O = (n == null ? void 0 : n.action) === "initial-input-focus", ae = lt(function() {
    var Y = "";
    if (M.guidance) {
      var k = i ? "value" : v ? "menu" : "input";
      Y = M.guidance({
        "aria-label": H,
        context: k,
        isDisabled: r && C(r, s),
        isMulti: b,
        isSearchable: g,
        tabSelectsValue: V,
        isInitialFocus: O
      });
    }
    return Y;
  }, [H, r, i, b, C, g, v, M, s, V, O]), z = R(Wn, null, R("span", {
    id: "aria-selection"
  }, S), R("span", {
    id: "aria-focused"
  }, Z), R("span", {
    id: "aria-results"
  }, W), R("span", {
    id: "aria-guidance"
  }, ae));
  return R(Wn, null, R(Or, {
    id: u
  }, O && z), R(Or, {
    "aria-live": I,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, o && !O && z));
}, E3 = M3, Z1 = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], N3 = new RegExp("[" + Z1.map(function(t) {
  return t.letters;
}).join("") + "]", "g"), Ma = {};
for (var m1 = 0; m1 < Z1.length; m1++)
  for (var g1 = Z1[m1], h1 = 0; h1 < g1.letters.length; h1++)
    Ma[g1.letters[h1]] = g1.base;
var Ea = function(e) {
  return e.replace(N3, function(n) {
    return Ma[n];
  });
}, L3 = x3(Ea), Tr = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, A3 = function(e) {
  return "".concat(e.label, " ").concat(e.value);
}, Z3 = function(e) {
  return function(n, r) {
    if (n.data.__isNew__) return !0;
    var i = B({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: A3,
      trim: !0,
      matchFrom: "any"
    }, e), a = i.ignoreCase, o = i.ignoreAccents, s = i.stringify, l = i.trim, u = i.matchFrom, d = l ? Tr(r) : r, f = l ? Tr(s(n)) : s(n);
    return a && (d = d.toLowerCase(), f = f.toLowerCase()), o && (d = L3(d), f = Ea(f)), u === "start" ? f.substr(0, d.length) === d : f.indexOf(d) > -1;
  };
}, R3 = ["innerRef"];
function B3(t) {
  var e = t.innerRef, n = It(t, R3), r = i5(n, "onExited", "in", "enter", "exit", "appear");
  return R("input", D({
    ref: e
  }, r, {
    css: /* @__PURE__ */ X1({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var S3 = function(e) {
  e.cancelable && e.preventDefault(), e.stopPropagation();
};
function G3(t) {
  var e = t.isEnabled, n = t.onBottomArrive, r = t.onBottomLeave, i = t.onTopArrive, a = t.onTopLeave, o = pe(!1), s = pe(!1), l = pe(0), u = pe(null), d = me(function(g, v) {
    if (u.current !== null) {
      var w = u.current, x = w.scrollTop, V = w.scrollHeight, y = w.clientHeight, H = u.current, I = v > 0, M = V - y - x, S = !1;
      M > v && o.current && (r && r(g), o.current = !1), I && s.current && (a && a(g), s.current = !1), I && v > M ? (n && !o.current && n(g), H.scrollTop = V, S = !0, o.current = !0) : !I && -v > x && (i && !s.current && i(g), H.scrollTop = 0, S = !0, s.current = !0), S && S3(g);
    }
  }, [n, r, i, a]), f = me(function(g) {
    d(g, g.deltaY);
  }, [d]), p = me(function(g) {
    l.current = g.changedTouches[0].clientY;
  }, []), h = me(function(g) {
    var v = l.current - g.changedTouches[0].clientY;
    d(g, v);
  }, [d]), b = me(function(g) {
    if (g) {
      var v = t5 ? {
        passive: !1
      } : !1;
      g.addEventListener("wheel", f, v), g.addEventListener("touchstart", p, v), g.addEventListener("touchmove", h, v);
    }
  }, [h, p, f]), C = me(function(g) {
    g && (g.removeEventListener("wheel", f, !1), g.removeEventListener("touchstart", p, !1), g.removeEventListener("touchmove", h, !1));
  }, [h, p, f]);
  return Q(function() {
    if (e) {
      var g = u.current;
      return b(g), function() {
        C(g);
      };
    }
  }, [e, b, C]), function(g) {
    u.current = g;
  };
}
var Pr = ["boxSizing", "height", "overflow", "paddingRight", "position"], Wr = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function kr(t) {
  t.cancelable && t.preventDefault();
}
function Xr(t) {
  t.stopPropagation();
}
function zr() {
  var t = this.scrollTop, e = this.scrollHeight, n = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : n === e && (this.scrollTop = t - 1);
}
function Yr() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var jr = !!(typeof window < "u" && window.document && window.document.createElement), mn = 0, _t = {
  capture: !1,
  passive: !1
};
function D3(t) {
  var e = t.isEnabled, n = t.accountForScrollbars, r = n === void 0 ? !0 : n, i = pe({}), a = pe(null), o = me(function(l) {
    if (jr) {
      var u = document.body, d = u && u.style;
      if (r && Pr.forEach(function(b) {
        var C = d && d[b];
        i.current[b] = C;
      }), r && mn < 1) {
        var f = parseInt(i.current.paddingRight, 10) || 0, p = document.body ? document.body.clientWidth : 0, h = window.innerWidth - p + f || 0;
        Object.keys(Wr).forEach(function(b) {
          var C = Wr[b];
          d && (d[b] = C);
        }), d && (d.paddingRight = "".concat(h, "px"));
      }
      u && Yr() && (u.addEventListener("touchmove", kr, _t), l && (l.addEventListener("touchstart", zr, _t), l.addEventListener("touchmove", Xr, _t))), mn += 1;
    }
  }, [r]), s = me(function(l) {
    if (jr) {
      var u = document.body, d = u && u.style;
      mn = Math.max(mn - 1, 0), r && mn < 1 && Pr.forEach(function(f) {
        var p = i.current[f];
        d && (d[f] = p);
      }), u && Yr() && (u.removeEventListener("touchmove", kr, _t), l && (l.removeEventListener("touchstart", zr, _t), l.removeEventListener("touchmove", Xr, _t)));
    }
  }, [r]);
  return Q(function() {
    if (e) {
      var l = a.current;
      return o(l), function() {
        s(l);
      };
    }
  }, [e, o, s]), function(l) {
    a.current = l;
  };
}
function F3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var O3 = function(e) {
  var n = e.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, T3 = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: F3
};
function P3(t) {
  var e = t.children, n = t.lockEnabled, r = t.captureEnabled, i = r === void 0 ? !0 : r, a = t.onBottomArrive, o = t.onBottomLeave, s = t.onTopArrive, l = t.onTopLeave, u = G3({
    isEnabled: i,
    onBottomArrive: a,
    onBottomLeave: o,
    onTopArrive: s,
    onTopLeave: l
  }), d = D3({
    isEnabled: n
  }), f = function(h) {
    u(h), d(h);
  };
  return R(Wn, null, n && R("div", {
    onClick: O3,
    css: T3
  }), e(f));
}
function W3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var k3 = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: W3
}, X3 = function(e) {
  var n = e.name, r = e.onFocus;
  return R("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: k3,
    value: "",
    onChange: function() {
    }
  });
}, z3 = X3;
function Q1(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function Y3() {
  return Q1(/^iPhone/i);
}
function Na() {
  return Q1(/^Mac/i);
}
function j3() {
  return Q1(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Na() && navigator.maxTouchPoints > 1;
}
function J3() {
  return Y3() || j3();
}
function _3() {
  return Na() || J3();
}
var U3 = function(e) {
  return e.label;
}, $3 = function(e) {
  return e.label;
}, Q3 = function(e) {
  return e.value;
}, K3 = function(e) {
  return !!e.isDisabled;
}, q3 = {
  clearIndicator: B5,
  container: x5,
  control: P5,
  dropdownIndicator: Z5,
  group: z5,
  groupHeading: j5,
  indicatorsContainer: H5,
  indicatorSeparator: G5,
  input: $5,
  loadingIndicator: O5,
  loadingMessage: C5,
  menu: c5,
  menuList: m5,
  menuPortal: v5,
  multiValue: t3,
  multiValueLabel: n3,
  multiValueRemove: r3,
  noOptionsMessage: h5,
  option: c3,
  placeholder: f3,
  singleValue: h3,
  valueContainer: I5
}, e9 = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, t9 = 4, La = 4, n9 = 38, r9 = La * 2, i9 = {
  baseUnit: La,
  controlHeight: n9,
  menuGutter: r9
}, C1 = {
  borderRadius: t9,
  colors: e9,
  spacing: i9
}, a9 = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: Gr(),
  captureMenuScroll: !Gr(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: Z3(),
  formatGroupLabel: U3,
  getOptionLabel: $3,
  getOptionValue: Q3,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: K3,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !qd(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(e) {
    var n = e.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Jr(t, e, n, r) {
  var i = Ra(t, e, n), a = Ba(t, e, n), o = Za(t, e), s = Un(t, e);
  return {
    type: "option",
    data: e,
    isDisabled: i,
    isSelected: a,
    label: o,
    value: s,
    index: r
  };
}
function Pn(t, e) {
  return t.options.map(function(n, r) {
    if ("options" in n) {
      var i = n.options.map(function(o, s) {
        return Jr(t, o, e, s);
      }).filter(function(o) {
        return Ur(t, o);
      });
      return i.length > 0 ? {
        type: "group",
        data: n,
        options: i,
        index: r
      } : void 0;
    }
    var a = Jr(t, n, e, r);
    return Ur(t, a) ? a : void 0;
  }).filter(n5);
}
function Aa(t) {
  return t.reduce(function(e, n) {
    return n.type === "group" ? e.push.apply(e, O1(n.options.map(function(r) {
      return r.data;
    }))) : e.push(n.data), e;
  }, []);
}
function _r(t, e) {
  return t.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, O1(r.options.map(function(i) {
      return {
        data: i.data,
        id: "".concat(e, "-").concat(r.index, "-").concat(i.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(e, "-").concat(r.index)
    }), n;
  }, []);
}
function o9(t, e) {
  return Aa(Pn(t, e));
}
function Ur(t, e) {
  var n = t.inputValue, r = n === void 0 ? "" : n, i = e.data, a = e.isSelected, o = e.label, s = e.value;
  return (!Ga(t) || !a) && Sa(t, {
    label: o,
    value: s,
    data: i
  }, r);
}
function s9(t, e) {
  var n = t.focusedValue, r = t.selectValue, i = r.indexOf(n);
  if (i > -1) {
    var a = e.indexOf(n);
    if (a > -1)
      return n;
    if (i < e.length)
      return e[i];
  }
  return null;
}
function l9(t, e) {
  var n = t.focusedOption;
  return n && e.indexOf(n) > -1 ? n : e[0];
}
var b1 = function(e, n) {
  var r, i = (r = e.find(function(a) {
    return a.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return i || null;
}, Za = function(e, n) {
  return e.getOptionLabel(n);
}, Un = function(e, n) {
  return e.getOptionValue(n);
};
function Ra(t, e, n) {
  return typeof t.isOptionDisabled == "function" ? t.isOptionDisabled(e, n) : !1;
}
function Ba(t, e, n) {
  if (n.indexOf(e) > -1) return !0;
  if (typeof t.isOptionSelected == "function")
    return t.isOptionSelected(e, n);
  var r = Un(t, e);
  return n.some(function(i) {
    return Un(t, i) === r;
  });
}
function Sa(t, e, n) {
  return t.filterOption ? t.filterOption(e, n) : !0;
}
var Ga = function(e) {
  var n = e.hideSelectedOptions, r = e.isMulti;
  return n === void 0 ? r : n;
}, c9 = 1, Da = /* @__PURE__ */ function(t) {
  a4(n, t);
  var e = l4(n);
  function n(r) {
    var i;
    if (r4(this, n), i = e.call(this, r), i.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, i.blockOptionHover = !1, i.isComposing = !1, i.commonProps = void 0, i.initialTouchX = 0, i.initialTouchY = 0, i.openAfterFocus = !1, i.scrollToFocusedOptionOnUpdate = !1, i.userIsDragging = void 0, i.isAppleDevice = _3(), i.controlRef = null, i.getControlRef = function(l) {
      i.controlRef = l;
    }, i.focusedOptionRef = null, i.getFocusedOptionRef = function(l) {
      i.focusedOptionRef = l;
    }, i.menuListRef = null, i.getMenuListRef = function(l) {
      i.menuListRef = l;
    }, i.inputRef = null, i.getInputRef = function(l) {
      i.inputRef = l;
    }, i.focus = i.focusInput, i.blur = i.blurInput, i.onChange = function(l, u) {
      var d = i.props, f = d.onChange, p = d.name;
      u.name = p, i.ariaOnChange(l, u), f(l, u);
    }, i.setValue = function(l, u, d) {
      var f = i.props, p = f.closeMenuOnSelect, h = f.isMulti, b = f.inputValue;
      i.onInputChange("", {
        action: "set-value",
        prevInputValue: b
      }), p && (i.setState({
        inputIsHiddenAfterUpdate: !h
      }), i.onMenuClose()), i.setState({
        clearFocusValueOnUpdate: !0
      }), i.onChange(l, {
        action: u,
        option: d
      });
    }, i.selectOption = function(l) {
      var u = i.props, d = u.blurInputOnSelect, f = u.isMulti, p = u.name, h = i.state.selectValue, b = f && i.isOptionSelected(l, h), C = i.isOptionDisabled(l, h);
      if (b) {
        var g = i.getOptionValue(l);
        i.setValue(h.filter(function(v) {
          return i.getOptionValue(v) !== g;
        }), "deselect-option", l);
      } else if (!C)
        f ? i.setValue([].concat(O1(h), [l]), "select-option", l) : i.setValue(l, "select-option");
      else {
        i.ariaOnChange(l, {
          action: "select-option",
          option: l,
          name: p
        });
        return;
      }
      d && i.blurInput();
    }, i.removeValue = function(l) {
      var u = i.props.isMulti, d = i.state.selectValue, f = i.getOptionValue(l), p = d.filter(function(b) {
        return i.getOptionValue(b) !== f;
      }), h = Dn(u, p, p[0] || null);
      i.onChange(h, {
        action: "remove-value",
        removedValue: l
      }), i.focusInput();
    }, i.clearValue = function() {
      var l = i.state.selectValue;
      i.onChange(Dn(i.props.isMulti, [], null), {
        action: "clear",
        removedValues: l
      });
    }, i.popValue = function() {
      var l = i.props.isMulti, u = i.state.selectValue, d = u[u.length - 1], f = u.slice(0, u.length - 1), p = Dn(l, f, f[0] || null);
      d && i.onChange(p, {
        action: "pop-value",
        removedValue: d
      });
    }, i.getFocusedOptionId = function(l) {
      return b1(i.state.focusableOptionsWithIds, l);
    }, i.getFocusableOptionsWithIds = function() {
      return _r(Pn(i.props, i.state.selectValue), i.getElementId("option"));
    }, i.getValue = function() {
      return i.state.selectValue;
    }, i.cx = function() {
      for (var l = arguments.length, u = new Array(l), d = 0; d < l; d++)
        u[d] = arguments[d];
      return _d.apply(void 0, [i.props.classNamePrefix].concat(u));
    }, i.getOptionLabel = function(l) {
      return Za(i.props, l);
    }, i.getOptionValue = function(l) {
      return Un(i.props, l);
    }, i.getStyles = function(l, u) {
      var d = i.props.unstyled, f = q3[l](u, d);
      f.boxSizing = "border-box";
      var p = i.props.styles[l];
      return p ? p(f, u) : f;
    }, i.getClassNames = function(l, u) {
      var d, f;
      return (d = (f = i.props.classNames)[l]) === null || d === void 0 ? void 0 : d.call(f, u);
    }, i.getElementId = function(l) {
      return "".concat(i.state.instancePrefix, "-").concat(l);
    }, i.getComponents = function() {
      return p3(i.props);
    }, i.buildCategorizedOptions = function() {
      return Pn(i.props, i.state.selectValue);
    }, i.getCategorizedOptions = function() {
      return i.props.menuIsOpen ? i.buildCategorizedOptions() : [];
    }, i.buildFocusableOptions = function() {
      return Aa(i.buildCategorizedOptions());
    }, i.getFocusableOptions = function() {
      return i.props.menuIsOpen ? i.buildFocusableOptions() : [];
    }, i.ariaOnChange = function(l, u) {
      i.setState({
        ariaSelection: B({
          value: l
        }, u)
      });
    }, i.onMenuMouseDown = function(l) {
      l.button === 0 && (l.stopPropagation(), l.preventDefault(), i.focusInput());
    }, i.onMenuMouseMove = function(l) {
      i.blockOptionHover = !1;
    }, i.onControlMouseDown = function(l) {
      if (!l.defaultPrevented) {
        var u = i.props.openMenuOnClick;
        i.state.isFocused ? i.props.menuIsOpen ? l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && i.onMenuClose() : u && i.openMenu("first") : (u && (i.openAfterFocus = !0), i.focusInput()), l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && l.preventDefault();
      }
    }, i.onDropdownIndicatorMouseDown = function(l) {
      if (!(l && l.type === "mousedown" && l.button !== 0) && !i.props.isDisabled) {
        var u = i.props, d = u.isMulti, f = u.menuIsOpen;
        i.focusInput(), f ? (i.setState({
          inputIsHiddenAfterUpdate: !d
        }), i.onMenuClose()) : i.openMenu("first"), l.preventDefault();
      }
    }, i.onClearIndicatorMouseDown = function(l) {
      l && l.type === "mousedown" && l.button !== 0 || (i.clearValue(), l.preventDefault(), i.openAfterFocus = !1, l.type === "touchend" ? i.focusInput() : setTimeout(function() {
        return i.focusInput();
      }));
    }, i.onScroll = function(l) {
      typeof i.props.closeMenuOnScroll == "boolean" ? l.target instanceof HTMLElement && i1(l.target) && i.props.onMenuClose() : typeof i.props.closeMenuOnScroll == "function" && i.props.closeMenuOnScroll(l) && i.props.onMenuClose();
    }, i.onCompositionStart = function() {
      i.isComposing = !0;
    }, i.onCompositionEnd = function() {
      i.isComposing = !1;
    }, i.onTouchStart = function(l) {
      var u = l.touches, d = u && u.item(0);
      d && (i.initialTouchX = d.clientX, i.initialTouchY = d.clientY, i.userIsDragging = !1);
    }, i.onTouchMove = function(l) {
      var u = l.touches, d = u && u.item(0);
      if (d) {
        var f = Math.abs(d.clientX - i.initialTouchX), p = Math.abs(d.clientY - i.initialTouchY), h = 5;
        i.userIsDragging = f > h || p > h;
      }
    }, i.onTouchEnd = function(l) {
      i.userIsDragging || (i.controlRef && !i.controlRef.contains(l.target) && i.menuListRef && !i.menuListRef.contains(l.target) && i.blurInput(), i.initialTouchX = 0, i.initialTouchY = 0);
    }, i.onControlTouchEnd = function(l) {
      i.userIsDragging || i.onControlMouseDown(l);
    }, i.onClearIndicatorTouchEnd = function(l) {
      i.userIsDragging || i.onClearIndicatorMouseDown(l);
    }, i.onDropdownIndicatorTouchEnd = function(l) {
      i.userIsDragging || i.onDropdownIndicatorMouseDown(l);
    }, i.handleInputChange = function(l) {
      var u = i.props.inputValue, d = l.currentTarget.value;
      i.setState({
        inputIsHiddenAfterUpdate: !1
      }), i.onInputChange(d, {
        action: "input-change",
        prevInputValue: u
      }), i.props.menuIsOpen || i.onMenuOpen();
    }, i.onInputFocus = function(l) {
      i.props.onFocus && i.props.onFocus(l), i.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (i.openAfterFocus || i.props.openMenuOnFocus) && i.openMenu("first"), i.openAfterFocus = !1;
    }, i.onInputBlur = function(l) {
      var u = i.props.inputValue;
      if (i.menuListRef && i.menuListRef.contains(document.activeElement)) {
        i.inputRef.focus();
        return;
      }
      i.props.onBlur && i.props.onBlur(l), i.onInputChange("", {
        action: "input-blur",
        prevInputValue: u
      }), i.onMenuClose(), i.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, i.onOptionHover = function(l) {
      if (!(i.blockOptionHover || i.state.focusedOption === l)) {
        var u = i.getFocusableOptions(), d = u.indexOf(l);
        i.setState({
          focusedOption: l,
          focusedOptionId: d > -1 ? i.getFocusedOptionId(l) : null
        });
      }
    }, i.shouldHideSelectedOptions = function() {
      return Ga(i.props);
    }, i.onValueInputFocus = function(l) {
      l.preventDefault(), l.stopPropagation(), i.focus();
    }, i.onKeyDown = function(l) {
      var u = i.props, d = u.isMulti, f = u.backspaceRemovesValue, p = u.escapeClearsValue, h = u.inputValue, b = u.isClearable, C = u.isDisabled, g = u.menuIsOpen, v = u.onKeyDown, w = u.tabSelectsValue, x = u.openMenuOnFocus, V = i.state, y = V.focusedOption, H = V.focusedValue, I = V.selectValue;
      if (!C && !(typeof v == "function" && (v(l), l.defaultPrevented))) {
        switch (i.blockOptionHover = !0, l.key) {
          case "ArrowLeft":
            if (!d || h) return;
            i.focusValue("previous");
            break;
          case "ArrowRight":
            if (!d || h) return;
            i.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (h) return;
            if (H)
              i.removeValue(H);
            else {
              if (!f) return;
              d ? i.popValue() : b && i.clearValue();
            }
            break;
          case "Tab":
            if (i.isComposing || l.shiftKey || !g || !w || !y || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            x && i.isOptionSelected(y, I))
              return;
            i.selectOption(y);
            break;
          case "Enter":
            if (l.keyCode === 229)
              break;
            if (g) {
              if (!y || i.isComposing) return;
              i.selectOption(y);
              break;
            }
            return;
          case "Escape":
            g ? (i.setState({
              inputIsHiddenAfterUpdate: !1
            }), i.onInputChange("", {
              action: "menu-close",
              prevInputValue: h
            }), i.onMenuClose()) : b && p && i.clearValue();
            break;
          case " ":
            if (h)
              return;
            if (!g) {
              i.openMenu("first");
              break;
            }
            if (!y) return;
            i.selectOption(y);
            break;
          case "ArrowUp":
            g ? i.focusOption("up") : i.openMenu("last");
            break;
          case "ArrowDown":
            g ? i.focusOption("down") : i.openMenu("first");
            break;
          case "PageUp":
            if (!g) return;
            i.focusOption("pageup");
            break;
          case "PageDown":
            if (!g) return;
            i.focusOption("pagedown");
            break;
          case "Home":
            if (!g) return;
            i.focusOption("first");
            break;
          case "End":
            if (!g) return;
            i.focusOption("last");
            break;
          default:
            return;
        }
        l.preventDefault();
      }
    }, i.state.instancePrefix = "react-select-" + (i.props.instanceId || ++c9), i.state.selectValue = Br(r.value), r.menuIsOpen && i.state.selectValue.length) {
      var a = i.getFocusableOptionsWithIds(), o = i.buildFocusableOptions(), s = o.indexOf(i.state.selectValue[0]);
      i.state.focusableOptionsWithIds = a, i.state.focusedOption = o[s], i.state.focusedOptionId = b1(a, o[s]);
    }
    return i;
  }
  return i4(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && Sr(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var a = this.props, o = a.isDisabled, s = a.menuIsOpen, l = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (l && !o && i.isDisabled || // ensure focus is on the Input when the menu opens
      l && s && !i.menuIsOpen) && this.focusInput(), l && o && !i.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !l && !o && i.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (Sr(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(i, a) {
      this.props.onInputChange(i, a);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(i) {
      var a = this, o = this.state, s = o.selectValue, l = o.isFocused, u = this.buildFocusableOptions(), d = i === "first" ? 0 : u.length - 1;
      if (!this.props.isMulti) {
        var f = u.indexOf(s[0]);
        f > -1 && (d = f);
      }
      this.scrollToFocusedOptionOnUpdate = !(l && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: u[d],
        focusedOptionId: this.getFocusedOptionId(u[d])
      }, function() {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(i) {
      var a = this.state, o = a.selectValue, s = a.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var l = o.indexOf(s);
        s || (l = -1);
        var u = o.length - 1, d = -1;
        if (o.length) {
          switch (i) {
            case "previous":
              l === 0 ? d = 0 : l === -1 ? d = u : d = l - 1;
              break;
            case "next":
              l > -1 && l < u && (d = l + 1);
              break;
          }
          this.setState({
            inputIsHidden: d !== -1,
            focusedValue: o[d]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", a = this.props.pageSize, o = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var l = 0, u = s.indexOf(o);
        o || (u = -1), i === "up" ? l = u > 0 ? u - 1 : s.length - 1 : i === "down" ? l = (u + 1) % s.length : i === "pageup" ? (l = u - a, l < 0 && (l = 0)) : i === "pagedown" ? (l = u + a, l > s.length - 1 && (l = s.length - 1)) : i === "last" && (l = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[l],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(s[l])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(C1) : B(B({}, C1), this.props.theme) : C1;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var i = this.clearValue, a = this.cx, o = this.getStyles, s = this.getClassNames, l = this.getValue, u = this.selectOption, d = this.setValue, f = this.props, p = f.isMulti, h = f.isRtl, b = f.options, C = this.hasValue();
      return {
        clearValue: i,
        cx: a,
        getStyles: o,
        getClassNames: s,
        getValue: l,
        hasValue: C,
        isMulti: p,
        isRtl: h,
        options: b,
        selectOption: u,
        selectProps: f,
        setValue: d,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var i = this.state.selectValue;
      return i.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var i = this.props, a = i.isClearable, o = i.isMulti;
      return a === void 0 ? o : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function(i, a) {
      return Ra(this.props, i, a);
    }
  }, {
    key: "isOptionSelected",
    value: function(i, a) {
      return Ba(this.props, i, a);
    }
  }, {
    key: "filterOption",
    value: function(i, a) {
      return Sa(this.props, i, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function(i, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var o = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(i, {
          context: a,
          inputValue: o,
          selectValue: s
        });
      } else
        return this.getOptionLabel(i);
    }
  }, {
    key: "formatGroupLabel",
    value: function(i) {
      return this.props.formatGroupLabel(i);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var i = this.props, a = i.isDisabled, o = i.isSearchable, s = i.inputId, l = i.inputValue, u = i.tabIndex, d = i.form, f = i.menuIsOpen, p = i.required, h = this.getComponents(), b = h.Input, C = this.state, g = C.inputIsHidden, v = C.ariaSelection, w = this.commonProps, x = s || this.getElementId("input"), V = B(B(B({
          "aria-autocomplete": "list",
          "aria-expanded": f,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": p,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, f && {
          "aria-controls": this.getElementId("listbox")
        }), !o && {
          "aria-readonly": !0
        }), this.hasValue() ? (v == null ? void 0 : v.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return o ? /* @__PURE__ */ A.createElement(b, D({}, w, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: x,
          innerRef: this.getInputRef,
          isDisabled: a,
          isHidden: g,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: u,
          form: d,
          type: "text",
          value: l
        }, V)) : /* @__PURE__ */ A.createElement(B3, D({
          id: x,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: Jn,
          onFocus: this.onInputFocus,
          disabled: a,
          tabIndex: u,
          inputMode: "none",
          form: d,
          value: ""
        }, V));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var i = this, a = this.getComponents(), o = a.MultiValue, s = a.MultiValueContainer, l = a.MultiValueLabel, u = a.MultiValueRemove, d = a.SingleValue, f = a.Placeholder, p = this.commonProps, h = this.props, b = h.controlShouldRenderValue, C = h.isDisabled, g = h.isMulti, v = h.inputValue, w = h.placeholder, x = this.state, V = x.selectValue, y = x.focusedValue, H = x.isFocused;
      if (!this.hasValue() || !b)
        return v ? null : /* @__PURE__ */ A.createElement(f, D({}, p, {
          key: "placeholder",
          isDisabled: C,
          isFocused: H,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), w);
      if (g)
        return V.map(function(M, S) {
          var Z = M === y, W = "".concat(i.getOptionLabel(M), "-").concat(i.getOptionValue(M));
          return /* @__PURE__ */ A.createElement(o, D({}, p, {
            components: {
              Container: s,
              Label: l,
              Remove: u
            },
            isFocused: Z,
            isDisabled: C,
            key: W,
            index: S,
            removeProps: {
              onClick: function() {
                return i.removeValue(M);
              },
              onTouchEnd: function() {
                return i.removeValue(M);
              },
              onMouseDown: function(ae) {
                ae.preventDefault();
              }
            },
            data: M
          }), i.formatOptionLabel(M, "value"));
        });
      if (v)
        return null;
      var I = V[0];
      return /* @__PURE__ */ A.createElement(d, D({}, p, {
        data: I,
        isDisabled: C
      }), this.formatOptionLabel(I, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var i = this.getComponents(), a = i.ClearIndicator, o = this.commonProps, s = this.props, l = s.isDisabled, u = s.isLoading, d = this.state.isFocused;
      if (!this.isClearable() || !a || l || !this.hasValue() || u)
        return null;
      var f = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ A.createElement(a, D({}, o, {
        innerProps: f,
        isFocused: d
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var i = this.getComponents(), a = i.LoadingIndicator, o = this.commonProps, s = this.props, l = s.isDisabled, u = s.isLoading, d = this.state.isFocused;
      if (!a || !u) return null;
      var f = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ A.createElement(a, D({}, o, {
        innerProps: f,
        isDisabled: l,
        isFocused: d
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var i = this.getComponents(), a = i.DropdownIndicator, o = i.IndicatorSeparator;
      if (!a || !o) return null;
      var s = this.commonProps, l = this.props.isDisabled, u = this.state.isFocused;
      return /* @__PURE__ */ A.createElement(o, D({}, s, {
        isDisabled: l,
        isFocused: u
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var i = this.getComponents(), a = i.DropdownIndicator;
      if (!a) return null;
      var o = this.commonProps, s = this.props.isDisabled, l = this.state.isFocused, u = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ A.createElement(a, D({}, o, {
        innerProps: u,
        isDisabled: s,
        isFocused: l
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var i = this, a = this.getComponents(), o = a.Group, s = a.GroupHeading, l = a.Menu, u = a.MenuList, d = a.MenuPortal, f = a.LoadingMessage, p = a.NoOptionsMessage, h = a.Option, b = this.commonProps, C = this.state.focusedOption, g = this.props, v = g.captureMenuScroll, w = g.inputValue, x = g.isLoading, V = g.loadingMessage, y = g.minMenuHeight, H = g.maxMenuHeight, I = g.menuIsOpen, M = g.menuPlacement, S = g.menuPosition, Z = g.menuPortalTarget, W = g.menuShouldBlockScroll, O = g.menuShouldScrollIntoView, ae = g.noOptionsMessage, z = g.onMenuScrollToTop, Y = g.onMenuScrollToBottom;
      if (!I) return null;
      var k = function(Ce, Ee) {
        var Ne = Ce.type, ve = Ce.data, Le = Ce.isDisabled, ce = Ce.isSelected, Te = Ce.label, Ze = Ce.value, Pe = C === ve, L = Le ? void 0 : function() {
          return i.onOptionHover(ve);
        }, Ge = Le ? void 0 : function() {
          return i.selectOption(ve);
        }, Xe = "".concat(i.getElementId("option"), "-").concat(Ee), Ie = {
          id: Xe,
          onClick: Ge,
          onMouseMove: L,
          onMouseOver: L,
          tabIndex: -1,
          role: "option",
          "aria-selected": i.isAppleDevice ? void 0 : ce
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ A.createElement(h, D({}, b, {
          innerProps: Ie,
          data: ve,
          isDisabled: Le,
          isSelected: ce,
          key: Xe,
          label: Te,
          type: Ne,
          value: Ze,
          isFocused: Pe,
          innerRef: Pe ? i.getFocusedOptionRef : void 0
        }), i.formatOptionLabel(Ce.data, "menu"));
      }, j;
      if (this.hasOptions())
        j = this.getCategorizedOptions().map(function(ne) {
          if (ne.type === "group") {
            var Ce = ne.data, Ee = ne.options, Ne = ne.index, ve = "".concat(i.getElementId("group"), "-").concat(Ne), Le = "".concat(ve, "-heading");
            return /* @__PURE__ */ A.createElement(o, D({}, b, {
              key: ve,
              data: Ce,
              options: Ee,
              Heading: s,
              headingProps: {
                id: Le,
                data: ne.data
              },
              label: i.formatGroupLabel(ne.data)
            }), ne.options.map(function(ce) {
              return k(ce, "".concat(Ne, "-").concat(ce.index));
            }));
          } else if (ne.type === "option")
            return k(ne, "".concat(ne.index));
        });
      else if (x) {
        var J = V({
          inputValue: w
        });
        if (J === null) return null;
        j = /* @__PURE__ */ A.createElement(f, b, J);
      } else {
        var ee = ae({
          inputValue: w
        });
        if (ee === null) return null;
        j = /* @__PURE__ */ A.createElement(p, b, ee);
      }
      var de = {
        minMenuHeight: y,
        maxMenuHeight: H,
        menuPlacement: M,
        menuPosition: S,
        menuShouldScrollIntoView: O
      }, te = /* @__PURE__ */ A.createElement(u5, D({}, b, de), function(ne) {
        var Ce = ne.ref, Ee = ne.placerProps, Ne = Ee.placement, ve = Ee.maxHeight;
        return /* @__PURE__ */ A.createElement(l, D({}, b, de, {
          innerRef: Ce,
          innerProps: {
            onMouseDown: i.onMenuMouseDown,
            onMouseMove: i.onMenuMouseMove
          },
          isLoading: x,
          placement: Ne
        }), /* @__PURE__ */ A.createElement(P3, {
          captureEnabled: v,
          onTopArrive: z,
          onBottomArrive: Y,
          lockEnabled: W
        }, function(Le) {
          return /* @__PURE__ */ A.createElement(u, D({}, b, {
            innerRef: function(Te) {
              i.getMenuListRef(Te), Le(Te);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": b.isMulti,
              id: i.getElementId("listbox")
            },
            isLoading: x,
            maxHeight: ve,
            focusedOption: C
          }), j);
        }));
      });
      return Z || S === "fixed" ? /* @__PURE__ */ A.createElement(d, D({}, b, {
        appendTo: Z,
        controlElement: this.controlRef,
        menuPlacement: M,
        menuPosition: S
      }), te) : te;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var i = this, a = this.props, o = a.delimiter, s = a.isDisabled, l = a.isMulti, u = a.name, d = a.required, f = this.state.selectValue;
      if (d && !this.hasValue() && !s)
        return /* @__PURE__ */ A.createElement(z3, {
          name: u,
          onFocus: this.onValueInputFocus
        });
      if (!(!u || s))
        if (l)
          if (o) {
            var p = f.map(function(C) {
              return i.getOptionValue(C);
            }).join(o);
            return /* @__PURE__ */ A.createElement("input", {
              name: u,
              type: "hidden",
              value: p
            });
          } else {
            var h = f.length > 0 ? f.map(function(C, g) {
              return /* @__PURE__ */ A.createElement("input", {
                key: "i-".concat(g),
                name: u,
                type: "hidden",
                value: i.getOptionValue(C)
              });
            }) : /* @__PURE__ */ A.createElement("input", {
              name: u,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ A.createElement("div", null, h);
          }
        else {
          var b = f[0] ? this.getOptionValue(f[0]) : "";
          return /* @__PURE__ */ A.createElement("input", {
            name: u,
            type: "hidden",
            value: b
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var i = this.commonProps, a = this.state, o = a.ariaSelection, s = a.focusedOption, l = a.focusedValue, u = a.isFocused, d = a.selectValue, f = this.getFocusableOptions();
      return /* @__PURE__ */ A.createElement(E3, D({}, i, {
        id: this.getElementId("live-region"),
        ariaSelection: o,
        focusedOption: s,
        focusedValue: l,
        isFocused: u,
        selectValue: d,
        focusableOptions: f,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var i = this.getComponents(), a = i.Control, o = i.IndicatorsContainer, s = i.SelectContainer, l = i.ValueContainer, u = this.props, d = u.className, f = u.id, p = u.isDisabled, h = u.menuIsOpen, b = this.state.isFocused, C = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ A.createElement(s, D({}, C, {
        className: d,
        innerProps: {
          id: f,
          onKeyDown: this.onKeyDown
        },
        isDisabled: p,
        isFocused: b
      }), this.renderLiveRegion(), /* @__PURE__ */ A.createElement(a, D({}, C, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: p,
        isFocused: b,
        menuIsOpen: h
      }), /* @__PURE__ */ A.createElement(l, D({}, C, {
        isDisabled: p
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ A.createElement(o, D({}, C, {
        isDisabled: p
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, a) {
      var o = a.prevProps, s = a.clearFocusValueOnUpdate, l = a.inputIsHiddenAfterUpdate, u = a.ariaSelection, d = a.isFocused, f = a.prevWasFocused, p = a.instancePrefix, h = i.options, b = i.value, C = i.menuIsOpen, g = i.inputValue, v = i.isMulti, w = Br(b), x = {};
      if (o && (b !== o.value || h !== o.options || C !== o.menuIsOpen || g !== o.inputValue)) {
        var V = C ? o9(i, w) : [], y = C ? _r(Pn(i, w), "".concat(p, "-option")) : [], H = s ? s9(a, w) : null, I = l9(a, V), M = b1(y, I);
        x = {
          selectValue: w,
          focusedOption: I,
          focusedOptionId: M,
          focusableOptionsWithIds: y,
          focusedValue: H,
          clearFocusValueOnUpdate: !1
        };
      }
      var S = l != null && i !== o ? {
        inputIsHidden: l,
        inputIsHiddenAfterUpdate: void 0
      } : {}, Z = u, W = d && f;
      return d && !W && (Z = {
        value: Dn(v, w, w[0] || null),
        options: w,
        action: "initial-input-focus"
      }, W = !f), (u == null ? void 0 : u.action) === "initial-input-focus" && (Z = null), B(B(B({}, x), S), {}, {
        prevProps: i,
        ariaSelection: Z,
        prevWasFocused: W
      });
    }
  }]), n;
}(ka);
Da.defaultProps = a9;
var u9 = /* @__PURE__ */ ii(function(t, e) {
  var n = n4(t);
  return /* @__PURE__ */ A.createElement(Da, D({
    ref: e
  }, n));
}), d9 = u9;
function e7(t) {
  const {
    options: e,
    onChange: n,
    handleChange: r,
    handleInputChange: i = void 0,
    isSearchable: a = !1,
    isMulti: o = !1,
    icon: s = null,
    label: l = null,
    value: u = void 0,
    isClearable: d = !1,
    disabled: f = !1,
    placeholder: p = "Select...",
    menuPosition: h = "absolute",
    menuShouldBlockScroll: b = !0,
    hasError: C = !1,
    CustomOptionComponent: g = void 0,
    SingleValueComponent: v = void 0,
    labelClassName: w = "",
    sublabel: x,
    required: V = !1,
    isOptionDisabled: y = void 0,
    helpText: H = void 0
  } = t, I = N(!o && s && "pl-5");
  if (!n && !r)
    return console.log("onChange or handleChange is required"), null;
  const M = (Z) => {
    r && r(Z), n && n(Z);
  }, S = (Z) => {
    i && i(Z);
  };
  return /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col", children: [
    l && /* @__PURE__ */ m.jsx(F1, { label: l, sublabel: x, className: w, required: V }),
    /* @__PURE__ */ m.jsxs("div", { className: "relative", children: [
      !o && s && /* @__PURE__ */ m.jsx("span", { className: "absolute z-10 left-2 top-2.5", children: oi(s, { className: "fill-slate-500", size: 16 }) }),
      /* @__PURE__ */ m.jsx(
        d9,
        {
          placeholder: p,
          options: e,
          onChange: M,
          onInputChange: S,
          isSearchable: a,
          isClearable: d,
          isMulti: o,
          value: u,
          isDisabled: f,
          menuPosition: h,
          menuShouldBlockScroll: b,
          isOptionDisabled: y,
          components: {
            Option: ({ children: Z, ...W }) => /* @__PURE__ */ m.jsx(A1.Option, { ...W, children: g ? g(W.data) : Z }),
            SingleValue: ({ children: Z, ...W }) => /* @__PURE__ */ m.jsx(A1.SingleValue, { ...W, children: v ? v(W.data) : Z })
          },
          classNames: {
            control: (Z) => N(
              "!rounded-lg !shadow border !border-slate-300 text-slate-500 text-sm font-normal",
              Z.isFocused && "!border-blue-500 !text-black",
              Z.isDisabled && "!bg-slate-50 !text-slate-400 !cursor-not-allowed",
              C && "!border-red-500 !text-red-500"
            ),
            menu: () => "!rounded-lg !shadow border-1 !border-slate-200 text-slate-700 text-sm font-normal",
            menuList: () => "!pt-0 !pb-0 !rounded-lg",
            option: (Z) => N(
              Z.isFocused && "!bg-slate-100",
              Z.isSelected && "!text-slate-700 !bg-slate-200"
            ),
            singleValue: () => I,
            multiValue: () => "!rounded",
            multiValueLabel: () => "bg-slate-200",
            multiValueRemove: () => "bg-slate-200 hover:bg-red-300",
            placeholder: () => I,
            input: () => I,
            groupHeading: () => "!text-slate-900 !font-semibold pl-2.5 border-b border-slate-200 pb-2 !text-transform-none !text-[14px] !normal-case"
          }
        }
      )
    ] }),
    H && /* @__PURE__ */ m.jsx("div", { className: "label", children: /* @__PURE__ */ m.jsx(
      "span",
      {
        className: N(
          "label-text-alt text-slate-500 text-xs font-normal",
          C && "text-red-600"
        ),
        children: H
      }
    ) })
  ] });
}
const f9 = A.forwardRef(
  ({ className: t = "", label: e, helpText: n, hasError: r = !1, required: i = !1, sublabel: a, ...o }, s) => /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col gap-1.5", children: [
    e && /* @__PURE__ */ m.jsx(F1, { label: e, sublabel: a, required: i }),
    /* @__PURE__ */ m.jsx(
      "textarea",
      {
        className: N(
          "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm",
          "placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
          "disabled:cursor-not-allowed disabled:opacity-50",
          r && "border-red-300",
          t
        ),
        ref: s,
        ...o
      }
    ),
    n && /* @__PURE__ */ m.jsx("span", { className: N("text-slate-500 text-sm font-normal", r && "text-red-500"), children: n })
  ] })
);
f9.displayName = "Textarea";
const m9 = A.forwardRef((t, e) => {
  const {
    className: n,
    checked: r,
    disabled: i,
    helpText: a,
    label: o,
    onChange: s,
    labelClassName: l,
    variant: u,
    toggleSize: d,
    ...f
  } = t;
  return /* @__PURE__ */ m.jsx("div", { children: /* @__PURE__ */ m.jsxs("label", { className: "flex gap-2 cursor-pointer items-top", children: [
    /* @__PURE__ */ m.jsx(
      "input",
      {
        className: N(
          "toggle focus:bg-none",
          "border-none bg-white hover:bg-white",
          // check styles from globals.css for colors
          u === "positive" && "green",
          d === "xs" && "toggle-xs",
          d === "sm" && "toggle-sm",
          d === "md" && "toggle-md",
          d === "lg" && "toggle-lg",
          n
        ),
        checked: r,
        ref: e,
        ...f,
        disabled: i,
        type: "checkbox",
        onChange: s
      }
    ),
    /* @__PURE__ */ m.jsxs(
      "span",
      {
        className: N(
          "label-text text-slate-700 text-sm font-medium flex flex-col gap-2",
          l
        ),
        children: [
          o,
          a && /* @__PURE__ */ m.jsx("span", { className: "text-slate-500", children: a })
        ]
      }
    )
  ] }) });
});
m9.displayName = "Toggle";
const t7 = (t) => {
  const { children: e, className: n } = t;
  return /* @__PURE__ */ m.jsx("div", { className: N("flex flex-col border border-gray-200 rounded-lg p-4 ", n), children: e });
}, n7 = (t) => {
  const { remove: e, cancel: n, save: r } = t;
  return /* @__PURE__ */ m.jsxs("div", { className: "flex justify-between mt-4", children: [
    e && /* @__PURE__ */ m.jsx("div", { className: "flex gap-4", children: e }),
    /* @__PURE__ */ m.jsxs("div", { className: N("flex gap-4", { "ml-auto": !e }), children: [
      n && n,
      r && r
    ] })
  ] });
};
function r7({ className: t, items: e, iconOnly: n = !1, ...r }) {
  const i = (a, o) => {
    const {
      icon: s,
      badge: l,
      children: u,
      active: d = !1,
      className: f = "",
      onClick: p = void 0,
      isExpanded: h = !1
    } = a, b = N(
      "group flex box-border",
      "h-9 pl-2 pr-3 py-2 mb-1 rounded-md text-sm font-medium text-slate-700",
      "hover:border-blue-100 hover:bg-blue-100 hover:text-blue-700",
      "active:!border-blue-100 active:!bg-blue-50 active:!text-blue-700",
      d && "border border-blue-100 bg-blue-50 text-blue-700",
      !s && "ml-3",
      n && "p-0 h-9 w-9 px-3 py-2 items-center justify-center",
      n && d && "shadow",
      f
    ), C = oi(s ?? /* @__PURE__ */ m.jsx(m.Fragment, {}), {
      className: N(
        "fill-slate-500 group-hover:fill-blue-700 group-active:fill-blue-700",
        d && "fill-blue-700"
      )
    }), g = /* @__PURE__ */ m.jsxs("span", { className: "flex flex-1 items-center gap-3", children: [
      s && /* @__PURE__ */ m.jsx("span", { children: C }),
      !n && a.label,
      l && /* @__PURE__ */ m.jsx("span", { className: N(u && "mr-1"), children: l })
    ] });
    return /* @__PURE__ */ m.jsxs("li", { children: [
      (!u || n) && /* @__PURE__ */ m.jsx("a", { className: b, onClick: p, children: g }),
      !n && u && /* @__PURE__ */ m.jsxs("details", { open: h, children: [
        /* @__PURE__ */ m.jsx("summary", { className: b, onClick: p, children: g }),
        /* @__PURE__ */ m.jsx("ul", { className: "before:w-0", children: u.map(i) })
      ] })
    ] }, o);
  };
  return /* @__PURE__ */ m.jsx("ul", { className: N("menu p-0", t), ...r, children: e.map(i) });
}
const i7 = (t) => {
  const {
    children: e,
    onClose: n,
    clickOutside: r = !1,
    closeOnEscape: i = !1,
    className: a = "",
    marginTop: o = "mt-[100px]"
  } = t, s = c.useRef(null);
  return r && ci(s, n), i && F2("Escape", n), /* @__PURE__ */ m.jsxs(
    "div",
    {
      className: "relative z-[9999]",
      "aria-labelledby": "modal-title",
      role: "dialog",
      "aria-modal": "true",
      children: [
        /* @__PURE__ */ m.jsx("div", { className: "fixed inset-0 bg-slate-700 bg-opacity-30 transition-opacity z-[9999]" }),
        /* @__PURE__ */ m.jsx("div", { className: "fixed inset-0 z-[9999] w-screen overflow-y-auto", children: /* @__PURE__ */ m.jsx("div", { className: N("flex justify-center p-4", o), children: /* @__PURE__ */ m.jsx("div", { className: "relative transform transition-all bg-white rounded-lg shadow border border-slate-200", children: /* @__PURE__ */ m.jsx("div", { ref: s, className: N("w-[1024px] h-[500px]", a), children: e }) }) }) })
      ]
    }
  );
};
function a7(t) {
  const { totalCount: e, onPageChange: n, perPage: r = 10, page: i } = t, [a, o] = $(i ? i - 1 : 0), s = 3, l = Math.ceil(e / r), u = (b) => {
    o(b), n(b + 1);
  };
  Q(() => {
    i && i !== a && o(i - 1);
  }, [i]);
  const d = a === l - 1, f = a === 0, p = s * 2 < l, h = () => {
    let b = [...Array(l).keys()];
    if (p) {
      const C = a >= s && a < l - s, g = a > s + 1, v = C && a > s || a === b.length - s, w = C && a < b.length - s - 1 || a === s - 1, x = a < b.length - s - 2;
      b = [
        ...b.slice(0, s),
        ...g ? ["prefix-divider"] : [],
        ...v ? [a - 1] : [],
        ...C ? [a] : [],
        ...w ? [a + 1] : [],
        ...x ? ["suffix-divider"] : [],
        ...b.slice(Math.max(b.length - s, 0))
      ];
    }
    return b.map((C) => /* @__PURE__ */ m.jsxs(Wn, { children: [
      typeof C == "string" && C === "prefix-divider" && /* @__PURE__ */ m.jsx("span", { className: "flex h-8 mt-1", children: "..." }, C),
      typeof C == "number" && /* @__PURE__ */ m.jsx(
        ut,
        {
          variant: a === C ? "secondaryBlue" : "ghost",
          onClick: (g) => {
            g.preventDefault(), u(C);
          },
          children: C + 1
        },
        C
      ),
      typeof C == "string" && C === "suffix-divider" && /* @__PURE__ */ m.jsx("span", { className: "flex h-8 mt-1", children: "..." }, C)
    ] }, C));
  };
  return /* @__PURE__ */ m.jsx("div", { className: "w-full px-6 py-4 bg-white justify-between items-start inline-flex", children: l > 1 && /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsxs(
      ut,
      {
        variant: "secondary",
        onClick: (b) => {
          b.preventDefault(), u(a - 1);
        },
        disabled: f,
        children: [
          /* @__PURE__ */ m.jsx(
            Ae,
            {
              icon: "RiArrowLeftLine",
              size: 16,
              className: N(f && "fill-slate-200")
            }
          ),
          " ",
          "Previous"
        ]
      }
    ),
    /* @__PURE__ */ m.jsx("div", { className: "flex grow gap-2 justify-center", children: h() }),
    /* @__PURE__ */ m.jsxs(
      ut,
      {
        className: "",
        disabled: d,
        variant: "secondary",
        onClick: (b) => {
          b.preventDefault(), u(a + 1);
        },
        children: [
          "Next",
          " ",
          /* @__PURE__ */ m.jsx(
            Ae,
            {
              icon: "RiArrowRightLine",
              size: 16,
              className: N(d && "fill-slate-200")
            }
          )
        ]
      }
    )
  ] }) });
}
const g9 = ({ value: t, className: e, children: n, style: r, ...i }) => {
  const a = { "--value": t, ...r };
  return /* @__PURE__ */ m.jsx("div", { className: N("radial-progress", e), style: a, ...i, children: n });
};
g9.displayName = "RadialProgress";
function o7({ className: t, ...e }) {
  return /* @__PURE__ */ m.jsx("div", { className: N("skeleton w-full h-2", t), ...e });
}
const h9 = tt("loading loading-spinner text-blue-700", {
  variants: {
    variant: {
      circle: "loading-spinner",
      dots: "loading-dots",
      infinity: "loading-infinity"
    },
    size: {
      xs: "loading-xs",
      sm: "loading-sm",
      md: "loading-md",
      lg: "loading-lg"
    }
  },
  defaultVariants: {
    variant: "circle",
    size: "lg"
  }
});
function s7({ size: t, variant: e, className: n, ...r }) {
  return /* @__PURE__ */ m.jsx("span", { className: N(h9({ size: t, variant: e }), n), ...r });
}
const C9 = tt("tabs border-slate-200", {
  variants: {
    variant: {
      default: [
        "flex p-1 bg-slate-100 rounded-lg border items-center gap-2",
        "[&_.tab]:rounded-md",
        "[&_.tab-active]:text-slate-700 [&_.tab-active]:bg-white [&_.tab-active]:shadow"
      ].join(" "),
      bordered: [
        "flex px-1 items-start border-b gap-4",
        "[&_.tab-active]:text-blue-700 [&_.tab-active]:!border-blue-700 [&_.tab-active]:border-b"
      ].join(" ")
    },
    size: {
      sm: "",
      md: ""
    }
  },
  defaultVariants: {
    variant: "default",
    size: "sm"
  }
});
function l7({
  className: t,
  items: e,
  selected: n,
  variant: r,
  size: i,
  fullWidth: a = !0,
  preserveClientSideNavigation: o = !1,
  ...s
}) {
  const l = (u) => {
    const { id: d, label: f, onClick: p, className: h, href: b, target: C, disabled: g } = u, v = N(
      "tab flex text-slate-500",
      n === d && "tab-active",
      a && "grow shrink",
      r === "default" && i === "md" && "h-11 px-3.5 py-2.5 text-base",
      r === "default" && i === "sm" && "h-8 px-3 py-2 text-xs",
      r === "bordered" && i === "md" && "px-1 pb-4 h-[42px] text-base",
      r === "bordered" && i === "sm" && "px-1 pb-4 h-[34px] text-xs",
      g && "opacity-50 cursor-not-allowed",
      h
    ), w = (x) => {
      if (g) {
        x.preventDefault();
        return;
      }
      if (b && p) {
        if (x.button === 2 || x.ctrlKey || x.metaKey || x.button === 1)
          return;
        o && x.preventDefault(), p(u);
        return;
      }
      if (p) {
        p(u);
        return;
      }
    };
    if (b) {
      const x = {
        href: b,
        target: C,
        role: "tab",
        className: v,
        onClick: w,
        onContextMenu: void 0,
        // Allow right-click context menu
        children: f
      };
      return /* @__PURE__ */ m.jsx("a", { ...x }, d);
    }
    return /* @__PURE__ */ m.jsx(
      "a",
      {
        role: "tab",
        className: v,
        onClick: w,
        style: g ? { pointerEvents: "none" } : void 0,
        children: f
      },
      d
    );
  };
  return /* @__PURE__ */ m.jsx("div", { role: "tablist", className: N(C9({ variant: r }), t), ...s, children: e.map(l) });
}
const b9 = tt("tabs tabs-bordered", {
  variants: {},
  defaultVariants: {}
});
function c7({ className: t, items: e, selected: n, ...r }) {
  const i = (a) => {
    const { id: o, label: s, onClick: l, className: u } = a;
    return /* @__PURE__ */ m.jsx(
      "a",
      {
        role: "tab",
        className: N("tab h-[3rem]", n === o && "tab-active", u),
        onClick: () => l(a),
        children: s
      },
      o
    );
  };
  return /* @__PURE__ */ m.jsx("div", { role: "tablist", className: N(b9(), t), ...r, children: e.map(i) });
}
const p9 = A.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ m.jsx("div", { className: "relative w-full rounded-lg border border-slate-200 flex-col overflow-visible", children: /* @__PURE__ */ m.jsx(
  "table",
  {
    ref: n,
    className: N("w-full caption-bottom text-sm table-fixed", t),
    ...e
  }
) })), v9 = A.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ m.jsx(
  "tbody",
  {
    ref: n,
    className: N(
      "[&_tr:last-child]:border-0",
      "[&_tr:last-child>td:first-child]:rounded-bl-lg",
      "[&_tr:last-child>td:last-child]:rounded-br-lg",
      t
    ),
    ...e
  }
)), w9 = A.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ m.jsx("caption", { ref: n, className: N("border-t border-slate-200", t), ...e }));
p9.displayName = "Table";
v9.displayName = "TableBody";
w9.displayName = "TableCaption";
const x9 = A.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ m.jsx(
  "thead",
  {
    ref: n,
    className: N(
      "[&_tr]:border-b",
      "[&_tr:first-child>th:first-child]:rounded-tl-lg",
      "[&_tr:first-child>th:last-child]:rounded-tr-lg",
      t
    ),
    ...e
  }
)), y9 = A.forwardRef(
  ({ className: t, children: e, info: n, sortable: r, order: i, ...a }, o) => /* @__PURE__ */ m.jsx(
    "th",
    {
      ref: o,
      className: N(
        "px-6 py-3 bg-gray-50 text-slate-500 text-sm font-medium leading-[18px] text-left group",
        "whitespace-normal break-words align-top",
        "hover:text-slate-700",
        r && "cursor-pointer",
        t
      ),
      ...a,
      children: /* @__PURE__ */ m.jsxs("span", { className: "flex gap-1 break-all w-full", children: [
        e,
        " ",
        n && /* @__PURE__ */ m.jsx(
          Ae,
          {
            icon: "RiQuestionLine",
            size: 16,
            className: "fill-gray-500 group-hover:fill-slate-700"
          }
        ),
        i && /* @__PURE__ */ m.jsx(
          Ae,
          {
            icon: i === "asc" ? "RiArrowUpLine" : "RiArrowDownLine",
            size: 16,
            className: "fill-gray-500 group-hover:fill-slate-700"
          }
        )
      ] })
    }
  )
);
y9.displayName = "TableHead";
x9.displayName = "TableHeader";
const I9 = A.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ m.jsx(
  "tr",
  {
    ref: n,
    className: N(
      "border-b border-slate-100 hover:bg-slate-50",
      "[&_td:last-child]:text-right",
      t
    ),
    ...e
  }
));
I9.displayName = "TableRow";
const V9 = A.forwardRef(
  ({ className: t, children: e, supportingText: n, ...r }, i) => /* @__PURE__ */ m.jsx(
    "td",
    {
      ref: i,
      className: N(
        "px-6 py-4 justify-start items-center flex-inline",
        "text-slate-800 text-sm font-medium leading-tight text-left",
        "whitespace-normal break-words align-top",
        t
      ),
      ...r,
      children: /* @__PURE__ */ m.jsxs("span", { className: "flex gap-1 flex-col items-start break-all w-full", children: [
        e,
        n && /* @__PURE__ */ m.jsx("span", { className: "text-slate-500 font-normal", children: n })
      ] })
    }
  )
);
V9.displayName = "TableCell";
const H9 = tt("toast", {
  variants: {
    horizontal: {
      start: "toast-start",
      center: "toast-center",
      end: "toast-end"
    },
    vertical: {
      top: "toast-top",
      middle: "toast-middle",
      bottom: "toast-bottom"
    }
  },
  defaultVariants: {
    horizontal: "center",
    vertical: "bottom"
  }
});
function u7({ className: t, horizontal: e, vertical: n, handleClose: r, ...i }) {
  const { title: a, text: o, icon: s } = i, l = s ? "pl-4 flex items-start justify-center" : "";
  return /* @__PURE__ */ m.jsx("div", { className: N(H9({ horizontal: e, vertical: n }), t), children: /* @__PURE__ */ m.jsxs("div", { className: "flex flex-col p-4 bg-white rounded-lg shadow border border-slate-200 max-w-[400px]", children: [
    /* @__PURE__ */ m.jsxs("div", { className: "justify-start items-center gap-4 inline-flex", children: [
      s && /* @__PURE__ */ m.jsx("div", { className: "relative", children: s }),
      /* @__PURE__ */ m.jsx("div", { className: "w-[400px] flex-col justify-start items-start", children: /* @__PURE__ */ m.jsx("div", { className: "text-slate-900 text-sm font-medium whitespace-normal overflow-auto max-w-[300px]", children: a }) }),
      /* @__PURE__ */ m.jsx("div", { role: "button", onClick: r, children: /* @__PURE__ */ m.jsx(Ae, { icon: "RiCloseFill", className: "fill-slate-400 w-4 h-4" }) })
    ] }),
    /* @__PURE__ */ m.jsx("div", { className: l, children: /* @__PURE__ */ m.jsx("div", { className: "text-slate-500 text-sm whitespace-normal overflow-auto w-[300px]", children: o }) })
  ] }) });
}
var Fa = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var a = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (a = i(a, r(s)));
      }
      return a;
    }
    function r(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return n.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var o = "";
      for (var s in a)
        e.call(a, s) && a[s] && (o = i(o, s));
      return o;
    }
    function i(a, o) {
      return o ? a ? a + " " + o : a + o : a;
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(Fa);
var M9 = Fa.exports;
const R1 = /* @__PURE__ */ Wa(M9);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const E9 = "react-tooltip-core-styles", N9 = "react-tooltip-base-styles", $r = { core: !1, base: !1 };
function Qr({ css: t, id: e = N9, type: n = "base", ref: r }) {
  var i, a;
  if (!t || typeof document > "u" || $r[n] || n === "core" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_CORE_STYLES) || n !== "base" && typeof process < "u" && (!((a = process == null ? void 0 : process.env) === null || a === void 0) && a.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
  n === "core" && (e = E9), r || (r = {});
  const { insertAt: o } = r;
  if (document.getElementById(e)) return;
  const s = document.head || document.getElementsByTagName("head")[0], l = document.createElement("style");
  l.id = e, l.type = "text/css", o === "top" && s.firstChild ? s.insertBefore(l, s.firstChild) : s.appendChild(l), l.styleSheet ? l.styleSheet.cssText = t : l.appendChild(document.createTextNode(t)), $r[n] = !0;
}
const Kr = async ({ elementReference: t = null, tooltipReference: e = null, tooltipArrowReference: n = null, place: r = "top", offset: i = 10, strategy: a = "absolute", middlewares: o = [kd(Number(i)), zd({ fallbackAxisSideDirection: "start" }), Xd({ padding: 5 })], border: s }) => {
  if (!t) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  if (e === null) return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  const l = o;
  return n ? (l.push(Yd({ element: n, padding: 5 })), Rr(t, e, { placement: r, strategy: a, middleware: l }).then(({ x: u, y: d, placement: f, middlewareData: p }) => {
    var h, b;
    const C = { left: `${u}px`, top: `${d}px`, border: s }, { x: g, y: v } = (h = p.arrow) !== null && h !== void 0 ? h : { x: 0, y: 0 }, w = (b = { top: "bottom", right: "left", bottom: "top", left: "right" }[f.split("-")[0]]) !== null && b !== void 0 ? b : "bottom", x = s && { borderBottom: s, borderRight: s };
    let V = 0;
    if (s) {
      const y = `${s}`.match(/(\d+)px/);
      V = y != null && y[1] ? Number(y[1]) : 1;
    }
    return { tooltipStyles: C, tooltipArrowStyles: { left: g != null ? `${g}px` : "", top: v != null ? `${v}px` : "", right: "", bottom: "", ...x, [w]: `-${4 + V}px` }, place: f };
  })) : Rr(t, e, { placement: "bottom", strategy: a, middleware: l }).then(({ x: u, y: d, placement: f }) => ({ tooltipStyles: { left: `${u}px`, top: `${d}px` }, tooltipArrowStyles: {}, place: f }));
}, qr = (t, e) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(t, e), ei = (t, e, n) => {
  let r = null;
  const i = function(...a) {
    const o = () => {
      r = null;
    };
    !r && (t.apply(this, a), r = setTimeout(o, e));
  };
  return i.cancel = () => {
    r && (clearTimeout(r), r = null);
  }, i;
}, ti = (t) => t !== null && !Array.isArray(t) && typeof t == "object", B1 = (t, e) => {
  if (t === e) return !0;
  if (Array.isArray(t) && Array.isArray(e)) return t.length === e.length && t.every((i, a) => B1(i, e[a]));
  if (Array.isArray(t) !== Array.isArray(e)) return !1;
  if (!ti(t) || !ti(e)) return t === e;
  const n = Object.keys(t), r = Object.keys(e);
  return n.length === r.length && n.every((i) => B1(t[i], e[i]));
}, L9 = (t) => {
  if (!(t instanceof HTMLElement || t instanceof SVGElement)) return !1;
  const e = getComputedStyle(t);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const r = e.getPropertyValue(n);
    return r === "auto" || r === "scroll";
  });
}, ni = (t) => {
  if (!t) return null;
  let e = t.parentElement;
  for (; e; ) {
    if (L9(e)) return e;
    e = e.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, A9 = typeof window < "u" ? ai : Q, Ue = (t) => {
  t.current && (clearTimeout(t.current), t.current = null);
}, Z9 = "DEFAULT_TOOLTIP_ID", R9 = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, B9 = S1({ getTooltipData: () => R9 });
function Oa(t = Z9) {
  return $n(B9).getTooltipData(t);
}
var Ut = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, p1 = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const S9 = ({ forwardRef: t, id: e, className: n, classNameArrow: r, variant: i = "dark", anchorId: a, anchorSelect: o, place: s = "top", offset: l = 10, events: u = ["hover"], openOnClick: d = !1, positionStrategy: f = "absolute", middlewares: p, wrapper: h, delayShow: b = 0, delayHide: C = 0, float: g = !1, hidden: v = !1, noArrow: w = !1, clickable: x = !1, closeOnEsc: V = !1, closeOnScroll: y = !1, closeOnResize: H = !1, openEvents: I, closeEvents: M, globalCloseEvents: S, imperativeModeOnly: Z, style: W, position: O, afterShow: ae, afterHide: z, disableTooltip: Y, content: k, contentWrapperRef: j, isOpen: J, defaultIsOpen: ee = !1, setIsOpen: de, activeAnchor: te, setActiveAnchor: ne, border: Ce, opacity: Ee, arrowColor: Ne, role: ve = "tooltip" }) => {
  var Le;
  const ce = pe(null), Te = pe(null), Ze = pe(null), Pe = pe(null), L = pe(null), [Ge, Xe] = $({ tooltipStyles: {}, tooltipArrowStyles: {}, place: s }), [Ie, zt] = $(!1), [nt, ht] = $(!1), [he, At] = $(null), Zt = pe(!1), Rt = pe(null), { anchorRefs: Bt, setActiveAnchor: Yt } = Oa(e), Vt = pe(!1), [rt, St] = $([]), Ct = pe(!1), Ht = d || u.includes("click"), Gt = Ht || (I == null ? void 0 : I.click) || (I == null ? void 0 : I.dblclick) || (I == null ? void 0 : I.mousedown), Mt = I ? { ...I } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !I && Ht && Object.assign(Mt, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const _ = M ? { ...M } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !M && Ht && Object.assign(_, { mouseleave: !1, blur: !1, mouseout: !1 });
  const q = S ? { ...S } : { escape: V || !1, scroll: y || !1, resize: H || !1, clickOutsideAnchor: Gt || !1 };
  Z && (Object.assign(Mt, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(_, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(q, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), A9(() => (Ct.current = !0, () => {
    Ct.current = !1;
  }), []);
  const T = (E) => {
    Ct.current && (E && ht(!0), setTimeout(() => {
      Ct.current && (de == null || de(E), J === void 0 && zt(E));
    }, 10));
  };
  Q(() => {
    if (J === void 0) return () => null;
    J && ht(!0);
    const E = setTimeout(() => {
      zt(J);
    }, 10);
    return () => {
      clearTimeout(E);
    };
  }, [J]), Q(() => {
    if (Ie !== Zt.current) if (Ue(L), Zt.current = Ie, Ie) ae == null || ae();
    else {
      const E = ((P) => {
        const X = P.match(/^([\d.]+)(ms|s)$/);
        if (!X) return 0;
        const [, Me, Fe] = X;
        return Number(Me) * (Fe === "ms" ? 1 : 1e3);
      })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
      L.current = setTimeout(() => {
        ht(!1), At(null), z == null || z();
      }, E + 25);
    }
  }, [Ie]);
  const ze = (E) => {
    Xe((P) => B1(P, E) ? P : E);
  }, Re = (E = b) => {
    Ue(Ze), nt ? T(!0) : Ze.current = setTimeout(() => {
      T(!0);
    }, E);
  }, $e = (E = C) => {
    Ue(Pe), Pe.current = setTimeout(() => {
      Vt.current || T(!1);
    }, E);
  }, we = (E) => {
    var P;
    if (!E) return;
    const X = (P = E.currentTarget) !== null && P !== void 0 ? P : E.target;
    if (!(X != null && X.isConnected)) return ne(null), void Yt({ current: null });
    b ? Re() : T(!0), ne(X), Yt({ current: X }), Ue(Pe);
  }, Be = () => {
    x ? $e(C || 100) : C ? $e() : T(!1), Ue(Ze);
  }, U = ({ x: E, y: P }) => {
    var X;
    const Me = { getBoundingClientRect: () => ({ x: E, y: P, width: 0, height: 0, top: P, left: E, right: E, bottom: P }) };
    Kr({ place: (X = he == null ? void 0 : he.place) !== null && X !== void 0 ? X : s, offset: l, elementReference: Me, tooltipReference: ce.current, tooltipArrowReference: Te.current, strategy: f, middlewares: p, border: Ce }).then((Fe) => {
      ze(Fe);
    });
  }, Et = (E) => {
    if (!E) return;
    const P = E, X = { x: P.clientX, y: P.clientY };
    U(X), Rt.current = X;
  }, Dt = (E) => {
    var P;
    if (!Ie) return;
    const X = E.target;
    X.isConnected && (!((P = ce.current) === null || P === void 0) && P.contains(X) || [document.querySelector(`[id='${a}']`), ...rt].some((Me) => Me == null ? void 0 : Me.contains(X)) || (T(!1), Ue(Ze)));
  }, jt = ei(we, 50), xe = ei(Be, 50), De = (E) => {
    xe.cancel(), jt(E);
  }, F = () => {
    jt.cancel(), xe();
  }, K = me(() => {
    var E, P;
    const X = (E = he == null ? void 0 : he.position) !== null && E !== void 0 ? E : O;
    X ? U(X) : g ? Rt.current && U(Rt.current) : te != null && te.isConnected && Kr({ place: (P = he == null ? void 0 : he.place) !== null && P !== void 0 ? P : s, offset: l, elementReference: te, tooltipReference: ce.current, tooltipArrowReference: Te.current, strategy: f, middlewares: p, border: Ce }).then((Me) => {
      Ct.current && ze(Me);
    });
  }, [Ie, te, k, W, s, he == null ? void 0 : he.place, l, f, O, he == null ? void 0 : he.position, g]);
  Q(() => {
    var E, P;
    const X = new Set(Bt);
    rt.forEach((fe) => {
      Y != null && Y(fe) || X.add({ current: fe });
    });
    const Me = document.querySelector(`[id='${a}']`);
    Me && !(Y != null && Y(Me)) && X.add({ current: Me });
    const Fe = () => {
      T(!1);
    }, it = ni(te), at = ni(ce.current);
    q.scroll && (window.addEventListener("scroll", Fe), it == null || it.addEventListener("scroll", Fe), at == null || at.addEventListener("scroll", Fe));
    let We = null;
    q.resize ? window.addEventListener("resize", Fe) : te && ce.current && (We = ga(te, ce.current, K, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const _e = (fe) => {
      fe.key === "Escape" && T(!1);
    };
    q.escape && window.addEventListener("keydown", _e), q.clickOutsideAnchor && window.addEventListener("click", Dt);
    const be = [], sn = (fe) => {
      Ie && (fe == null ? void 0 : fe.target) === te || we(fe);
    }, Ta = (fe) => {
      Ie && (fe == null ? void 0 : fe.target) === te && Be();
    }, K1 = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], q1 = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(Mt).forEach(([fe, bt]) => {
      bt && (K1.includes(fe) ? be.push({ event: fe, listener: De }) : q1.includes(fe) && be.push({ event: fe, listener: sn }));
    }), Object.entries(_).forEach(([fe, bt]) => {
      bt && (K1.includes(fe) ? be.push({ event: fe, listener: F }) : q1.includes(fe) && be.push({ event: fe, listener: Ta }));
    }), g && be.push({ event: "pointermove", listener: Et });
    const er = () => {
      Vt.current = !0;
    }, tr = () => {
      Vt.current = !1, Be();
    };
    return x && !Gt && ((E = ce.current) === null || E === void 0 || E.addEventListener("mouseenter", er), (P = ce.current) === null || P === void 0 || P.addEventListener("mouseleave", tr)), be.forEach(({ event: fe, listener: bt }) => {
      X.forEach((a1) => {
        var ln;
        (ln = a1.current) === null || ln === void 0 || ln.addEventListener(fe, bt);
      });
    }), () => {
      var fe, bt;
      q.scroll && (window.removeEventListener("scroll", Fe), it == null || it.removeEventListener("scroll", Fe), at == null || at.removeEventListener("scroll", Fe)), q.resize ? window.removeEventListener("resize", Fe) : We == null || We(), q.clickOutsideAnchor && window.removeEventListener("click", Dt), q.escape && window.removeEventListener("keydown", _e), x && !Gt && ((fe = ce.current) === null || fe === void 0 || fe.removeEventListener("mouseenter", er), (bt = ce.current) === null || bt === void 0 || bt.removeEventListener("mouseleave", tr)), be.forEach(({ event: a1, listener: ln }) => {
        X.forEach((Pa) => {
          var o1;
          (o1 = Pa.current) === null || o1 === void 0 || o1.removeEventListener(a1, ln);
        });
      });
    };
  }, [te, K, nt, Bt, rt, I, M, S, Ht, b, C]), Q(() => {
    var E, P;
    let X = (P = (E = he == null ? void 0 : he.anchorSelect) !== null && E !== void 0 ? E : o) !== null && P !== void 0 ? P : "";
    !X && e && (X = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`);
    const Me = new MutationObserver((Fe) => {
      const it = [], at = [];
      Fe.forEach((We) => {
        if (We.type === "attributes" && We.attributeName === "data-tooltip-id" && (We.target.getAttribute("data-tooltip-id") === e ? it.push(We.target) : We.oldValue === e && at.push(We.target)), We.type === "childList") {
          if (te) {
            const _e = [...We.removedNodes].filter((be) => be.nodeType === 1);
            if (X) try {
              at.push(..._e.filter((be) => be.matches(X))), at.push(..._e.flatMap((be) => [...be.querySelectorAll(X)]));
            } catch {
            }
            _e.some((be) => {
              var sn;
              return !!(!((sn = be == null ? void 0 : be.contains) === null || sn === void 0) && sn.call(be, te)) && (ht(!1), T(!1), ne(null), Ue(Ze), Ue(Pe), !0);
            });
          }
          if (X) try {
            const _e = [...We.addedNodes].filter((be) => be.nodeType === 1);
            it.push(..._e.filter((be) => be.matches(X))), it.push(..._e.flatMap((be) => [...be.querySelectorAll(X)]));
          } catch {
          }
        }
      }), (it.length || at.length) && St((We) => [...We.filter((_e) => !at.includes(_e)), ...it]);
    });
    return Me.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      Me.disconnect();
    };
  }, [e, o, he == null ? void 0 : he.anchorSelect, te]), Q(() => {
    K();
  }, [K]), Q(() => {
    if (!(j != null && j.current)) return () => null;
    const E = new ResizeObserver(() => {
      setTimeout(() => K());
    });
    return E.observe(j.current), () => {
      E.disconnect();
    };
  }, [k, j == null ? void 0 : j.current]), Q(() => {
    var E;
    const P = document.querySelector(`[id='${a}']`), X = [...rt, P];
    te && X.includes(te) || ne((E = rt[0]) !== null && E !== void 0 ? E : P);
  }, [a, rt, te]), Q(() => (ee && T(!0), () => {
    Ue(Ze), Ue(Pe);
  }), []), Q(() => {
    var E;
    let P = (E = he == null ? void 0 : he.anchorSelect) !== null && E !== void 0 ? E : o;
    if (!P && e && (P = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), P) try {
      const X = Array.from(document.querySelectorAll(P));
      St(X);
    } catch {
      St([]);
    }
  }, [e, o, he == null ? void 0 : he.anchorSelect]), Q(() => {
    Ze.current && (Ue(Ze), Re(b));
  }, [b]);
  const Ye = (Le = he == null ? void 0 : he.content) !== null && Le !== void 0 ? Le : k, Ft = Ie && Object.keys(Ge.tooltipStyles).length > 0;
  return Xa(t, () => ({ open: (E) => {
    if (E != null && E.anchorSelect) try {
      document.querySelector(E.anchorSelect);
    } catch {
      return void console.warn(`[react-tooltip] "${E.anchorSelect}" is not a valid CSS selector`);
    }
    At(E ?? null), E != null && E.delay ? Re(E.delay) : T(!0);
  }, close: (E) => {
    E != null && E.delay ? $e(E.delay) : T(!1);
  }, activeAnchor: te, place: Ge.place, isOpen: !!(nt && !v && Ye && Ft) })), nt && !v && Ye ? c.createElement(h, { id: e, role: ve, className: R1("react-tooltip", Ut.tooltip, p1.tooltip, p1[i], n, `react-tooltip__place-${Ge.place}`, Ut[Ft ? "show" : "closing"], Ft ? "react-tooltip__show" : "react-tooltip__closing", f === "fixed" && Ut.fixed, x && Ut.clickable), onTransitionEnd: (E) => {
    Ue(L), Ie || E.propertyName !== "opacity" || (ht(!1), At(null), z == null || z());
  }, style: { ...W, ...Ge.tooltipStyles, opacity: Ee !== void 0 && Ft ? Ee : void 0 }, ref: ce }, Ye, c.createElement(h, { className: R1("react-tooltip-arrow", Ut.arrow, p1.arrow, r, w && Ut.noArrow), style: { ...Ge.tooltipArrowStyles, background: Ne ? `linear-gradient(to right bottom, transparent 50%, ${Ne} 50%)` : void 0 }, ref: Te })) : null;
}, G9 = ({ content: t }) => c.createElement("span", { dangerouslySetInnerHTML: { __html: t } }), D9 = c.forwardRef(({ id: t, anchorId: e, anchorSelect: n, content: r, html: i, render: a, className: o, classNameArrow: s, variant: l = "dark", place: u = "top", offset: d = 10, wrapper: f = "div", children: p = null, events: h = ["hover"], openOnClick: b = !1, positionStrategy: C = "absolute", middlewares: g, delayShow: v = 0, delayHide: w = 0, float: x = !1, hidden: V = !1, noArrow: y = !1, clickable: H = !1, closeOnEsc: I = !1, closeOnScroll: M = !1, closeOnResize: S = !1, openEvents: Z, closeEvents: W, globalCloseEvents: O, imperativeModeOnly: ae = !1, style: z, position: Y, isOpen: k, defaultIsOpen: j = !1, disableStyleInjection: J = !1, border: ee, opacity: de, arrowColor: te, setIsOpen: ne, afterShow: Ce, afterHide: Ee, disableTooltip: Ne, role: ve = "tooltip" }, Le) => {
  const [ce, Te] = $(r), [Ze, Pe] = $(i), [L, Ge] = $(u), [Xe, Ie] = $(l), [zt, nt] = $(d), [ht, he] = $(v), [At, Zt] = $(w), [Rt, Bt] = $(x), [Yt, Vt] = $(V), [rt, St] = $(f), [Ct, Ht] = $(h), [Gt, Mt] = $(C), [_, q] = $(null), [T, ze] = $(null), Re = pe(J), { anchorRefs: $e, activeAnchor: we } = Oa(t), Be = (xe) => xe == null ? void 0 : xe.getAttributeNames().reduce((De, F) => {
    var K;
    return F.startsWith("data-tooltip-") && (De[F.replace(/^data-tooltip-/, "")] = (K = xe == null ? void 0 : xe.getAttribute(F)) !== null && K !== void 0 ? K : null), De;
  }, {}), U = (xe) => {
    const De = { place: (F) => {
      var K;
      Ge((K = F) !== null && K !== void 0 ? K : u);
    }, content: (F) => {
      Te(F ?? r);
    }, html: (F) => {
      Pe(F ?? i);
    }, variant: (F) => {
      var K;
      Ie((K = F) !== null && K !== void 0 ? K : l);
    }, offset: (F) => {
      nt(F === null ? d : Number(F));
    }, wrapper: (F) => {
      var K;
      St((K = F) !== null && K !== void 0 ? K : f);
    }, events: (F) => {
      const K = F == null ? void 0 : F.split(" ");
      Ht(K ?? h);
    }, "position-strategy": (F) => {
      var K;
      Mt((K = F) !== null && K !== void 0 ? K : C);
    }, "delay-show": (F) => {
      he(F === null ? v : Number(F));
    }, "delay-hide": (F) => {
      Zt(F === null ? w : Number(F));
    }, float: (F) => {
      Bt(F === null ? x : F === "true");
    }, hidden: (F) => {
      Vt(F === null ? V : F === "true");
    }, "class-name": (F) => {
      q(F);
    } };
    Object.values(De).forEach((F) => F(null)), Object.entries(xe).forEach(([F, K]) => {
      var Ye;
      (Ye = De[F]) === null || Ye === void 0 || Ye.call(De, K);
    });
  };
  Q(() => {
    Te(r);
  }, [r]), Q(() => {
    Pe(i);
  }, [i]), Q(() => {
    Ge(u);
  }, [u]), Q(() => {
    Ie(l);
  }, [l]), Q(() => {
    nt(d);
  }, [d]), Q(() => {
    he(v);
  }, [v]), Q(() => {
    Zt(w);
  }, [w]), Q(() => {
    Bt(x);
  }, [x]), Q(() => {
    Vt(V);
  }, [V]), Q(() => {
    Mt(C);
  }, [C]), Q(() => {
    Re.current !== J && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [J]), Q(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: J === "core", disableBase: J } }));
  }, []), Q(() => {
    var xe;
    const De = new Set($e);
    let F = n;
    if (!F && t && (F = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), F) try {
      document.querySelectorAll(F).forEach((P) => {
        De.add({ current: P });
      });
    } catch {
      console.warn(`[react-tooltip] "${F}" is not a valid CSS selector`);
    }
    const K = document.querySelector(`[id='${e}']`);
    if (K && De.add({ current: K }), !De.size) return () => null;
    const Ye = (xe = T ?? K) !== null && xe !== void 0 ? xe : we.current, Ft = new MutationObserver((P) => {
      P.forEach((X) => {
        var Me;
        if (!Ye || X.type !== "attributes" || !(!((Me = X.attributeName) === null || Me === void 0) && Me.startsWith("data-tooltip-"))) return;
        const Fe = Be(Ye);
        U(Fe);
      });
    }), E = { attributes: !0, childList: !1, subtree: !1 };
    if (Ye) {
      const P = Be(Ye);
      U(P), Ft.observe(Ye, E);
    }
    return () => {
      Ft.disconnect();
    };
  }, [$e, we, T, e, n]), Q(() => {
    z != null && z.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), ee && !qr("border", `${ee}`) && console.warn(`[react-tooltip] "${ee}" is not a valid \`border\`.`), z != null && z.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), de && !qr("opacity", `${de}`) && console.warn(`[react-tooltip] "${de}" is not a valid \`opacity\`.`);
  }, []);
  let Et = p;
  const Dt = pe(null);
  if (a) {
    const xe = a({ content: (T == null ? void 0 : T.getAttribute("data-tooltip-content")) || ce || null, activeAnchor: T });
    Et = xe ? c.createElement("div", { ref: Dt, className: "react-tooltip-content-wrapper" }, xe) : null;
  } else ce && (Et = ce);
  Ze && (Et = c.createElement(G9, { content: Ze }));
  const jt = { forwardRef: Le, id: t, anchorId: e, anchorSelect: n, className: R1(o, _), classNameArrow: s, content: Et, contentWrapperRef: Dt, place: L, variant: Xe, offset: zt, wrapper: rt, events: Ct, openOnClick: b, positionStrategy: Gt, middlewares: g, delayShow: ht, delayHide: At, float: Rt, hidden: Yt, noArrow: y, clickable: H, closeOnEsc: I, closeOnScroll: M, closeOnResize: S, openEvents: Z, closeEvents: W, globalCloseEvents: O, imperativeModeOnly: ae, style: z, position: Y, isOpen: k, defaultIsOpen: j, border: ee, opacity: de, arrowColor: te, setIsOpen: ne, afterShow: Ce, afterHide: Ee, disableTooltip: Ne, activeAnchor: T, setActiveAnchor: (xe) => ze(xe), role: ve };
  return c.createElement(S9, { ...jt });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (t) => {
  t.detail.disableCore || Qr({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), t.detail.disableBase || Qr({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const F9 = tt("tooltip before:shadow before:px-3 before:py-2 before:rounded-lg", {
  variants: {
    variant: {
      default: "",
      light: "before:bg-white before:text-slate-700 after:"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function d7({
  datatip: t,
  className: e,
  children: n,
  variant: r,
  placement: i,
  id: a,
  positionStrategy: o,
  float: s
}) {
  const l = a || `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, u = A.Children.map(n, (d) => A.isValidElement(d) ? A.cloneElement(d, {
    "data-tooltip-id": l
  }) : d);
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    u,
    /* @__PURE__ */ m.jsx(
      D9,
      {
        id: l,
        place: i,
        className: N(F9({ variant: r }), e),
        positionStrategy: o,
        float: s,
        children: /* @__PURE__ */ m.jsx("div", { className: N("max-w-xs break-words", e), children: t })
      }
    )
  ] });
}
export {
  V2 as ActionIcon,
  Qe as ActionType,
  E2 as Alert,
  W9 as AlertDialog,
  k9 as Avatar,
  X9 as Badge,
  c7 as BorderedTab,
  ut as Button,
  L2 as Card,
  Q9 as Checkbox,
  z9 as CopyText,
  A2 as DataPointIcon,
  Y9 as DateRangeSelect,
  j9 as Divider,
  J9 as Drawer,
  _9 as Dropdown,
  U9 as FileList,
  $9 as FileUpload,
  n7 as FormButtons,
  t7 as FormContent,
  K9 as FormSection,
  Ae as Icon,
  pn as IconSize,
  Pi as Input,
  F1 as Label,
  q9 as ListInput,
  r7 as Menu,
  i7 as Modal,
  a7 as Pagination,
  g9 as RadialProgress,
  e7 as Select,
  o7 as SkeletonLoader,
  s7 as Spinner,
  l7 as Tab,
  p9 as Table,
  v9 as TableBody,
  w9 as TableCaption,
  V9 as TableCell,
  y9 as TableHead,
  x9 as TableHeader,
  I9 as TableRow,
  f9 as Textarea,
  u7 as Toast,
  m9 as Toggle,
  d7 as Tooltip
};
//# sourceMappingURL=index.es.js.map
